/// <reference types="googlepay" />
/* eslint-disable @typescript-eslint/naming-convention */
import AVAILABLE_TIMEZONES from '../../../constants/availableTimezones';

export type * from './contactVerification/contactVerification.types';

export enum VoPayResponse {
  GenerateEmployeeOTPResponse = 'GenerateEmployeeOTPResponse',
  ValidateEmployeeOTPResponse = 'ValidateEmployeeOTPResponse',
  CrossBorderUrlApiInfoResponse = 'CrossBorderUrlApiInfoResponse',
  FetchDomainApiResponse = 'FetchDomainApiResponse',
  AddDomainResponse = 'AddDomainResponse',
  VerifyDomainResponse = 'VerifyDomainResponse',
  DeleteDomainResponse = 'DeleteDomainResponse',
  AccountBillingSettingsResponse = 'AccountBillingSettingsResponse',
  AccountTransactions = 'AccountTransactions',
  AccountUsers = 'AccountUsers',
  AccountUsersChangePasswordResponse = 'AccountUsersChangePasswordResponse',
  ApiResponse = 'ApiResponse',
  AuthorizationResponse = 'AuthorizationResponse',
  CreateAccountUserResponse = 'CreateAccountUserResponse',
  CreditCardTransactionResponse = 'CreditCardTransactionResponse',
  DeleteAccountUserResponse = 'DeleteAccountUserResponse',
  EftFundingTransactionResponse = 'EftFundingTransactionResponse',
  EftWithdrawTransactionResponse = 'EftWithdrawTransactionResponse',
  InteracBulkPayoutTransactionResponse = 'InteracBulkPayoutTransactionResponse',
  InteracTransactionResponse = 'InteracTransactionResponse',
  IQ11AuthorizationResponse = 'IQ11AuthorizationResponse',
  LinkGooglePayResponse = 'LinkGooglePayResponse',
  PortalDocumentResponse = 'PortalDocumentResponse',
  PortalVideoResponse = 'PortalVideoResponse',
  PartnerAccountCreationLinkResponse = 'PartnerAccountCreationLinkResponse',
  PartnerAccountCreationResponse = 'PartnerAccountCreationResponse',
  PartnerAccountUsersChangePasswordResponse = 'PartnerAccountUsersChangePasswordResponse',
  PartnerBillingPackageDetailsResponse = 'PartnerBillingPackageDetailsResponse',
  PartnerBillingPackagesResponse = 'PartnerBillingPackagesResponse',
  PartnerBillingSettingsDetailsResponse = 'PartnerBillingSettingsDetailsResponse',
  PartnerCustomPackageResponse = 'PartnerCustomPackageResponse',
  PartnerInvoiceDetailsResponse = 'PartnerInvoiceDetailsResponse',
  PartnerInvoicePdfResponse = 'PartnerInvoicePdfResponse',
  PartnerInvoicesResponse = 'PartnerInvoicesResponse',
  PartnerStatementPdfResponse = 'PartnerStatementPdfResponse',
  PartnerStatisticsResponse = 'PartnerStatisticsResponse',
  PartnerUsersResponse = 'PartnerUsersResponse',
  SingleUseTokenResponse = 'SingleUseTokenResponse',
  TransactionsRefundResponse = 'TransactionsRefundResponse',
  IQ11EmbedUrlResponse = 'IQ11EmbedUrlResponse',
  GlobalPayTokenResponse = 'GlobalPayTokenResponse',
  IQ11TokenResponse = 'IQ11TokenResponse',
  CreditCardResponse = 'CreditCardResponse',
  BankAccountsResponse = 'BankAccountsResponse',
  SetMyBankAccountResponse = 'SetMyBankAccountResponse',
  RTRWithdrawTransactionResponse = 'RTRWithdrawTransactionResponse',
  SetMyCreditCardResponse = 'SetMyCreditCardResponse',
  ELinxSingleUseTokenResponse = 'ELinxSingleUseTokenResponse',
  AccountUserPermissionsResponse = 'AccountUserPermissionsResponse',
  ClientAuthorizationResponse = 'ClientAuthorizationResponse',
  TicketCategoriesResponse = 'TicketCategoriesResponse',
  HubSpotDropdownDataResponse = 'HubSpotDropdownDataResponse',
  HubSpotDealDetailsResponse = 'HubSpotDealDetailsResponse',
  DocumentUploadResponse = 'DocumentUploadResponse',
  AccessTokenInfoResponse = 'AccessTokenInfoResponse',
  PushToCardMapResponse = 'PushToCardMapResponse',
  OnboardingAppTokenResponse = 'OnboardingAppTokenResponse',
  AssignedBillingPackagesResponse = 'AssignedBillingPackagesResponse',
  GeoLocationResponse = 'GeoLocationResponse',
  MyBankAccountResponse = 'MyBankAccountResponse',
  OnboardingAccountBillingResponse = 'OnboardingAccountBillingResponse',
  OnboardingAccountBillingDocumentResponse = 'OnboardingAccountBillingDocumentResponse',
  AccountBillingDetailsResponse = 'AccountBillingDetailsResponse',
  SetMyBankAccountPurposeResponse = 'SetMyBankAccountPurposeResponse',
  AccountDocumentResponse = 'AccountDocumentResponse',
  DebitAuthorityAgreementResponse = 'DebitAuthorityAgreementResponse',
  AccountTransactionTypesResponse = 'AccountTransactionTypesResponse',
  OnboardingAppUrlResponse = 'OnboardingAppUrlResponse',
  UploadFileAttachmentResponse = 'UploadFileAttachmentResponse',
  AccountBillingSavePaymentInformationResponse = 'AccountBillingSavePaymentInformationResponse',
  RetriggerWebhookResponse = 'RetriggerWebhookResponse',
  GetTransactionCountsResponse = 'GetTransactionCountsResponse',
  InteracEmailResponse = 'InteracEmailResponse',
  SetClientEmailResponse = 'SetClientEmailResponse',
  GetDebitCardsApiResponse = 'GetDebitCardsApiResponse',
  SetMyGooglePayResponse = 'SetMyGooglePayResponse',
  SetMyApplePayResponse = 'SetMyApplePayResponse',
  SetMyPayPalResponse = 'SetMyPayPalResponse',
  SetMyVenmoResponse = 'SetMyVenmoResponse',
  FileConversionHistoryResponse = 'FileConversionHistoryResponse',
  FileConversionDownloadResponse = 'FileConversionDownloadResponse',
}

export type DomainStatus = 'unverified' | 'verified';

export type Domain = {
  Domain: string;
  Status: DomainStatus;
  Registrar: string;
  CnameRecords: {
    DKIM: {
      Hostname: string;
      Target: string;
      Text: string;
      Verified: boolean;
    };
    ReturnPath: {
      Hostname: string;
      Target: string;
      Text: string;
      Verified: boolean;
    };
  };
};

export type FetchDomainApiResponse = ApiResponse & {
  Domain?: Domain | Record<string, never>;
};

export type FetchDomainResponse = ApiResponse & {
  Domain: Domain | null;
};

export type AddDomainRequest = {
  Domain: string;
};

export type AddDomainResponse = ApiResponse & {
  Domain: Domain;
};

export type VerifyDomainRequest = {
  Domain: string;
};

export type VerifyDomainResponse = ApiResponse & {
  Domain: Domain;
};

export type DeleteDomainRequest = {
  Domain: string;
};

export type DeleteDomainResponse = ApiResponse;

export type BankFileConversionType =
  | 'bmo'
  | 'crossriver'
  | 'dc_bank'
  | 'fiserv'
  | 'globalpay'
  | 'goldmansachs'
  | 'mastercard'
  | 'nuvei'
  | 'peoples_trust_bank'
  | 'scotia_bank'
  | 'worldpay'
  | 'bankofamerica'
  | 'default_processor';

export type BankFileConversionRail =
  | 'eft'
  | 'interac'
  | 'vopayinstant'
  | 'ach'
  | 'rtp'
  | 'fednow'
  | 'fedwire'
  | 'aft'
  | 'oct'
  | 'creditcard'
  | 'debitcard';

export type FileConversionRequest = {
  Processor: BankFileConversionType;
  SourceFile: string; //Base64 encoded file content
  SourceFileName: string;
  ValueDate: string; //YYYY-MM-DD
  PaymentRail: BankFileConversionRail;
  AlternatePaymentRail: BankFileConversionRail | '';
  Service: FileConversionService;
};

export type FileConversionResponse = ApiResponse & {
  FileConversionID: string;
  TransactionCount: number;
  TotalAmount: string;
  TargetFile: string;
  TargetFileName: string;
};

export type FileConversionConfiguration = {
  FileConversionConfigurationID: string;
  FinancialInstitution: string;
  Processor: string;
  AccountNumber: string;
  PaymentRails: {
    credit: Record<
      BankFileConversionRail,
      {
        SubmissionEnabled: boolean;
        DownloadEnabled: boolean;
        IsDefault: boolean;
      }
    >;
    debit: Record<
      BankFileConversionRail,
      {
        SubmissionEnabled: boolean;
        DownloadEnabled: boolean;
        IsDefault: boolean;
      }
    >;
  };
};

export type FileConversionConfigurationsApiResponse = ApiResponse & {
  Configurations: {
    [financialInstitution: string]: FileConversionConfiguration;
  };
};

export type FileConversionConfigurationsResponse = ApiResponse & {
  Configurations: FileConversionConfiguration[];
};

export type FileConversionStatus = 'Success' | 'Failed' | 'Processing';
export type FileConversionService = 'Credit' | 'Debit';

export type FileConversionHistoryItemApi = {
  FileConversionID: string;
  FileType: BankFileConversionType;
  PaymentRail: BankFileConversionRail;
  AlternatePaymentRail: BankFileConversionRail | null;
  Service: FileConversionService;
  SourceFileName: string;
  TargetFileName: string;
  TransactionCount: number;
  TotalAmount: string;
  ConversionStatus: FileConversionStatus;
  ErrorMessage: string;
  DateAdded: string;
  LastModified: string;
  SubmittedDate: string | null;
  IsSubmitted: PseudoBool;
  Currency: SupportedCurrencies;
};
export type FileConversionHistoryItem = Omit<FileConversionHistoryItemApi, 'IsSubmitted'> & {
  IsSubmitted: boolean;
};

export type FileConversionHistoryRequest = {
  Processor?: BankFileConversionType;
  ConversionStatus?: FileConversionStatus;
  PaymentRail?: BankFileConversionRail;
  Service?: FileConversionService;
  Limit?: number;
  Offset?: number;
  Timezone?: string;
  StartDate?: string;
  EndDate?: string;
};
export type FileConversionHistoryResponseApi = ApiResponse & {
  NumberOfRecords: number;
  Conversions: {
    [key: string]: FileConversionHistoryItemApi;
  };
  PaginationMetaData?: PaginationMetaData;
};
export type FileConversionHistoryResponse = ApiResponse & {
  NumberOfRecords: number;
  Conversions: FileConversionHistoryItem[];
  PaginationMetaData?: PaginationMetaData;
};

export type FileConversionDownloadRequest = {
  FileConversionID: string;
  FileConversionConfigurationID: string;
  ValueDate: string;
  PaymentRail?: BankFileConversionRail;
};

export type FileConversionDownloadResponse = ApiResponse & {
  FileConversionID: string;
  TransactionCount: string;
  TotalAmount: string;
  FileContent: string;
  FileName: string;
};

export type FileConversionDownloadSourceRequest = {
  FileConversionID: string;
};

export type FileConversionDownloadSourceResponse = ApiResponse & {
  FileConversionID: string;
  FileContent: string;
  FileName: string;
};

export type FileConversionSubmitRequest = {
  FileConversionID: string;
  PaymentRail: BankFileConversionRail;
  FileConversionConfigurationID: string;
  ValueDate?: string;
  AlternatePaymentRail?: BankFileConversionRail;
};

export type FileConversionSubmitResponse = ApiResponse & {
  TotalTransactions: number;
  TotalFailed: number;
  TotalAmount: string;
  Currency: SupportedCurrencies;
};

export type FileConversionUploadRequest = {
  SourceFileName: string;
  SourceFile: string;
  FileConversionPreprocessingID: string;
  Service: FileConversionService;
};

export type FileConversionUploadResponse = ApiResponse & {
  FileConversionID: string;
  TransactionCount: number;
  Currency: SupportedCurrencies;
  TotalAmount: string;
};

export type FileConversionSourceFormat = 'csv' | 'xml' | 'txt' | 'json' | 'nacha' | 'cpa';

export type FileConversionPreprocessingConfigsRequest = {
  SourceFormat?: FileConversionSourceFormat;
  SourceFile: string;
};

export type FileConversionPreprocessingConfigApi = {
  FileConversionPreprocessingID: string;
  ConfigName: string;
  SourceFormat: string;
  IsDefault: PseudoBool;
};

export type FileConversionPreprocessingConfig = Omit<FileConversionPreprocessingConfigApi, 'IsDefault'> & {
  IsDefault: boolean;
};

export type FileConversionPreprocessingConfigsApiResponse = ApiResponse & {
  Configs: {
    [key: string]: FileConversionPreprocessingConfigApi;
  };
};

export type FileConversionPreprocessingConfigsResponse = ApiResponse & {
  Configs: FileConversionPreprocessingConfig[];
};

export type GooglePayToken = string;

export type LinkGooglePayRequest = {
  PaymentToken: {
    token: GooglePayToken;
  };
  CardHolderName: string;
  MaskedCardNumber: string;
  CardBrand: string;
  Email: string;
};

export type LinkGooglePayResponse = {
  Success: boolean;
  ErrorMessage: string;
  Token: string;
};

export type VirtualAccountStatus = 'Active' | 'Pending' | 'Inactive';

export type VirtualAccount = {
  VirtualAccountID: string;
  VirtualAccountNumber: string;
  Type: string;
  Status: VirtualAccountStatus;
  Currency: string;
  AccountHolderName: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  IBAN: string;
  ABARoutingNumber: string;
  BicSwift: string;
};

export type FetchVirtualAccountsRequest = {
  Status?: VirtualAccountStatus;
  Currency?: string;
};

export type FetchVirtualAccountsApiResponse = ApiResponse & {
  VirtualAccounts: {
    [key: string]: VirtualAccount;
  };
};

export type FetchVirtualAccountsResponse = ApiResponse & {
  VirtualAccounts: VirtualAccount[];
};

export type CreateVirtualAccountRequest = {
  Currency: string;
};

export type CreateVirtualAccountResponse = ApiResponse & {
  VirtualAccountID: string;
};

export type VirtualAccountCurrencyApi = {
  ShortForm: string;
  Currency: string;
  HasVirtualAccount: PseudoBool;
};

export type VirtualAccountCurrency = {
  ShortForm: string;
  Currency: string;
  HasVirtualAccount: boolean;
};

export type FetchVirtualAccountCurrenciesApiResponse = ApiResponse & {
  VirtualAccounts: {
    [key: string]: VirtualAccountCurrencyApi;
  };
};

export type FetchVirtualAccountCurrenciesResponse = ApiResponse & {
  VirtualAccounts: VirtualAccountCurrency[];
};

export type MasterVirtualAccountApi = {
  ShortForm: string;
  Currency: string;
  IsActive: PseudoBool;
  AccountNumber: string;
  Token: string;
};

export type MasterVirtualAccount = Omit<MasterVirtualAccountApi, 'IsActive'> & {
  IsActive: boolean;
};

export type FetchMasterVirtualAccountsApiResponse = ApiResponse & {
  MasterAccounts: {
    [key: string]: MasterVirtualAccountApi;
  };
};

export type FetchMasterVirtualAccountsResponse = ApiResponse & {
  MasterAccounts: MasterVirtualAccount[];
};

export type SimulateVirtualAccountCreditRequest = {
  VirtualAccountID: string;
  Amount: string;
};

export type SimulateVirtualAccountCreditResponse = ApiResponse;

export type AccountBalanceDetailApi = {
  AccountBalance: string;
  PendingFunds: string;
  SecurityDeposit: string;
  Reserve: string;
  AvailableImmediately: string;
  AvailableFunds: string;
  OffbookBalance: string;
  Currency: SupportedCurrencies;
  AsOfDate: string;
  VirtualAccountNumber: string;
  RollingReserveNSF?: string;
  RollingReserveReturns?: string;
  RollupAvailableBalance?: string;
  RollupAccountBalance?: string;
};

export type AccountBalanceDetail = {
  AccountBalance: number;
  PendingFunds: number;
  SecurityDeposit: number;
  Reserve: number;
  AvailableImmediately: number;
  AvailableFunds: number;
  OffbookBalance: number;
  Currency: SupportedCurrencies;
  AsOfDate: string;
  VirtualAccountNumber: string;
  RollingReserveNSF?: number;
  RollingReserveReturns?: number;
  RollupAvailableBalance?: number;
  RollupAccountBalance?: number;
};

export type FetchAccountBalancesRequest = {
  AsOfDate?: string;
};

export type FetchAccountBalancesApiResponse = ApiResponse & {
  AccountBalances: {
    [key: string]: AccountBalanceDetailApi;
  };
};

export type FetchAccountBalancesResponse = ApiResponse & {
  AccountBalances: AccountBalanceDetail[];
};

export enum BillingPackagePlanTypes {
  'pay as you go' = 'Pay As You Go',
  'subscription' = 'Subscription',
}
export type AccountParentAccountInfo = {
  AccountID: string;
  AccountName: string;
  ParentAccountID: string | null;
};
export type AccountWithoutPermissionsApi = {
  AccountID: string;
  AccountName: string;
  Address: string;
  Address2: string;
  Balances: {
    [key: string]: Balance;
  };
  ParentAccounts: {
    [key: string]: AccountParentAccountInfo;
  };
  SubAccounts: {
    [key: string]: AccountApi;
  };
  BillingPackageID: string;
  ClientAccountsEnabled: boolean;
  City: string;
  Country: string;
  DateIncorporation: string;
  DBAName?: string;
  Email: string;
  Fax: string;
  FullLegalName: string;
  IsActive: boolean;
  AccountStatus: string;
  LegalBusinessName: string;
  NatureOfBusiness: string;
  Occupation: string;
  OrganizationalType: string;
  OriginatorName: string;
  OriginatorShortName: string;
  ParentAccountName?: string;
  Phone: string;
  PostalCode: string;
  Province: string;
  RegistrationNumber: string;
  RegistrationProvince: string;
  Token: string;
};
export type AccountWithoutPermissions = Omit<
  AccountWithoutPermissionsApi,
  'Balances' | 'ParentAccounts' | 'SubAccounts'
> & {
  Balances: Balance[];
  ParentAccounts: AccountParentAccountInfo[];
  SubAccounts: Account[];
};

export type AccountApi = AccountPermissions & AccountWithoutPermissionsApi;

export type Account = AccountPermissions & AccountWithoutPermissions;

export type AccountBalance = Omit<AccountWithoutPermissions & Balance, 'Balances' | 'SubAccounts'> & {
  SubAccounts: AccountBalance[];
};

export type AccountBillingSettingsResponse = ApiResponse & {
  BillingSettings: {
    [idx: string]: BillingSettingBasics;
  };
};

export type AccountDetails = {
  accountId: string;
  accountName: string;
  billingPackageId: string;
  clientAccountsEnabled: boolean;
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    province: string;
    postalCode: string;
    country: string;
  };
  contact: Contact;
  token: string;
  ParentAccountName?: string;
};

export type AccountDetailsMap = {
  [key: string]: AccountDetails;
};

export type AccountMap = {
  [key: number]: Account;
};

export type AccountPermissions = {
  [key: string]: boolean | string | number;
};

export type AccountPermissionRequest = Record<string, boolean | string | number> & {
  VopayAccountID?: string;
  ApplyToAll?: boolean;
};

export type AccountPermissionsMap = {
  [key: string]: AccountPermissions;
};

export type AccountStatusData = {
  activeCount: number;
  inactiveCount: number;
  totalCount: number;
};

export type AccountTransactions = ApiResponse & {
  Transactions?: {
    [key: number]: Transaction;
  };
  CSVFile?: string;
  PDFFile?: string;
  TransactionsCount?: number;
  PaginationMetaData?: PaginationMetaData;
};
export type PartnerAccountTransactions = ApiResponse & {
  Transactions?: {
    [key: number]: Transaction;
  };
  CSVFile?: string;
  PDFFile?: string;
  TransactionsCount?: number;
  PaginationMetaData?: PaginationMetaData;
};

export type AccountTransactionStatus =
  | 'pending'
  | 'in progress'
  | 'requested'
  | 'sent'
  | 'successful'
  | 'failed'
  | 'cancelled'
  | 'cancellation requested'
  | 'settled'
  | 'waiting'
  | 'declined'
  | 'completed'
  | 'pending manual review'
  | 'received'
  | 'pending approval'
  | 'request fulfilled'
  | 'delayed'
  | 'submission failed'
  | 'pending confirmation';

export type AccountTransactionsRequest = {
  StartDateTime: string;
  EndDateTime: string;
  ClientAccountID?: string;
  Currency?: SupportedCurrencies;
  TransactionType?: TransactionTypesOptions;
  TransactionID?: string;
  ClientReferenceNumber?: string;
  ExportCSV?: boolean;
  ExportPDF?: boolean;
  IsFlagged?: boolean;
  IsRefunded?: boolean;
  TransactionStatus?: AccountTransactionStatus;
  Timezone?: string;
  SettlementDate?: string;
  SearchText?: string;
  Limit?: number;
  Offset?: number;
};

export type AccountListRequest = {
  Country: string;
  VopayAccountStatus?: string;
};

export type ParentAccountTransactionsRequest = {
  FromDate: string;
  ToDate: string;
  VopayAccountID?: string;
  Currency?: string;
  TransactionType?: string;
  Status?: string;
  ExportCSV?: boolean;
  TransactionID?: string;
  Limit?: number;
  Offset?: number;
};

export enum TicketCategoryID {
  ACCESS_USER = '1',
  TRANSACTION_ISSUE = '2',
  BILLING_INVOICE_ISSUE = '4',
  GENERAL_INQUIRY = '7',
  PRODUCT_FEEDBACK = '8',
  PORTAL = '9',
  CATEGORY_ACCOUNT = '10',
  CATEGORY_API = '11',
  CROSSBORDER = '12',
}

export type TicketCategory = {
  ID: TicketCategoryID;
  Category:
    | 'Access/User'
    | 'Transaction issue'
    | 'Billing/Invoice issue'
    | 'General inquiry'
    | 'Product Feedback'
    | 'Portal'
    | 'Account'
    | 'API'
    | 'CrossBorder';
};

export type TicketSubCategory = {
  SupportTicketCatagories_ID: TicketCategoryID;
  SubCategory: TicketSubCategoryType;
};

export type TicketSubCategoryType =
  | 'Add/Update/Modify user'
  | 'Reset my password'
  | 'Login issue'
  | 'Change or update my inbound e-Transfer email'
  | 'API credentials'
  | 'Multi-factor authentication'
  | 'Other access/user issue'
  | 'EFT fund and/or withdraw'
  | 'ACH fund and/or withdraw'
  | 'Interac money request'
  | 'Credit card'
  | 'Real-time payment'
  | 'Invoice amount'
  | 'Security deposit'
  | 'Other billing issue'
  | 'General inquiry'
  | 'h-to-card'
  | 'Transaction failed due to limits'
  | 'Processing times'
  | 'Other transaction issue'
  | 'Interac bulk payout'
  | 'Inbound e-Transfer'
  | 'Scheduled transactions'
  | 'Cancel transaction'
  | 'General portal question'
  | 'Bulk file template mismatch'
  | 'Other bulk file issue'
  | 'Other portal issue'
  | 'Report a bug'
  | 'Add or change a service'
  | 'Limit enhancement'
  | 'Transaction limit reached'
  | 'Other account issue'
  | 'API credentials'
  | 'Report a bug'
  | 'Other API issue'
  | 'Report a bug'
  | 'Feature request'
  | 'Other product issue or question'
  | 'Transaction Issue';

export type TransactionId = {
  TransactionID: string;
};

export type TransactionIdAndType = {
  TransactionID: string;
  Type: TransactionType;
};

export type AccountTransactionsMap = {
  [key: string]: Transaction[];
};

export type AccountTransactionsList = {
  [key: string]: Transaction[];
};

export type DeleteAccountUserRequest = {
  EmailAddress: string;
};

export type CreateAccountUserRequest = {
  EmailAddress: string;
  SendEmail: boolean;
};
export type CreateAccountUserResponse = ApiResponse & {
  Username: string;
  Password: string;
};
export type DeleteAccountUserResponse = ApiResponse & {
  UserID: string;
  IsActive: boolean;
};

export type FetchAccountUsersApiResponse = ApiResponse & {
  Users: { [key: number]: AccountUser };
};

export type FetchAccountUsersResponse = ApiResponse & {
  Users: AccountUser[];
};

export type BusinessTypesResponse = ApiResponse & {
  BusinessTypes: { [key: string]: BusinessType };
};
export type BusinessType = {
  BusinessTypeID: string;
  Industry: string;
  Categories: { [key: string]: BusinessCategoryType };
};
export type BusinessCategoryType = {
  BusinessTypeCategoryID: string;
  Category: string;
};
export type AccountUser = {
  Username: string;
  DateAdded: string;
  UserType: string;
};
export type PartnerUsers = ApiResponse & {
  PartnerAccounts?: { [key: number]: PartnerUser };
};
export type PartnerUser = {
  Username: string;
};

export type AccountUsersChangePasswordRequest = {
  EmailAddress: string;
  NewPassword: string;
  SendEmail: boolean;
};
export type PartnerAccountUsersChangePasswordRequest = {
  Username: string;
  NewPassword: string;
  SendEmail: boolean;
};

export type PartnerAccountUsersChangePasswordResponse = ApiResponse & {
  Username: string;
  Password: string;
};

export type CreateLeadRequest = {
  FirstName: string;
  LastName: string;
  BusinessEmail: string;
  CompanyName: string;
  DBA: string;
  websiteURL: string;
  businessModel: string;
  PartnerID: string;
  Comments: string;
  AgentID: string;
  SystemOfRecord: string;
  DataAggregator: string;
};

export type AccountUsersChangePasswordResponse = ApiResponse & {
  Username: string;
  Password: string;
};
export type Address = {
  Address1: string;
  Address2?: string;
  City: string;
  Province: string;
  Country: string;
  PostalCode: string;
};

export type ApiPartnerPermissions = {
  AccountBillingPackageRequired?: PseudoBool;
  AccountManagementEnabled?: PseudoBool;
  AccountOnboardingApiAccess?: PseudoBool;
  AccountOnboardingFormAccess?: PseudoBool;
  AccountTransfersEnabled?: PseudoBool;
  CustomBillingPackageCreationEnabled?: PseudoBool;
  LeadManagementEnabled?: PseudoBool;
  SetAccountPermissionsEnabled?: PseudoBool;
  TransactionEstimatesRequired?: PseudoBool;
  AccountEndpointAccess?: PseudoBool;
  CanAddCanadianAccounts?: PseudoBool;
  CanAddUSAccounts?: PseudoBool;
  PartnerBillsAccount?: PseudoBool;
  AccountCredentialsAccess?: PseudoBool;
  BusinessCaseRequired?: PseudoBool;
  PartnerLiability?: PseudoBool;
  ShowPartnerIncome?: PseudoBool;
  WhitelabellingEnabled?: PseudoBool;
  BrandingEmailEnabled?: PseudoBool;
  BrandingELinxEnabled?: PseudoBool;
  BrandingPortalEnabled?: PseudoBool;
  BrandingOnboardingEnabled?: PseudoBool;
  PartnerHasVirtualAccounts?: PseudoBool;
  VirtualAccountsEnabled?: PseudoBool;
};

export type ApiIsInsideSales = {
  IsInsideSales: PseudoBool;
};

export type ApiResponse = {
  Success: boolean;
  ErrorMessage: string;
};

export type Timezone = (typeof AVAILABLE_TIMEZONES)[number];

export type TimezoneRequest = {
  Timezone?: Timezone;
};

export type PartnerRole = 'Admin' | 'Support' | 'Viewer';

export type AuthorizationResponse = ApiResponse & {
  AccountID?: string;
  Key?: string;
  Signature?: string;
  JWT: string;
  AdditionalPartnerAccounts: { [AccountName: string]: string };
  Username: string;
  Name?: string;
  PartnerType: PartnerType;
  Permissions?: ApiPartnerPermissions;
  Domain: string;
  Role?: PartnerRole;
  IsInsideSales: boolean;
  MFAEnabled: boolean;
};

export type Balance = {
  AccountBalance: string;
  AvailableBalance: string;
  AvailableImmediately: string;
  Currency: SupportedCurrencies;
  PendingBalance: string;
  Reserve: string;
};

export type BillingSettings = {
  AutomaticInvoicing: { value: boolean; type: 'boolean' };
  BillingMethod: { value: 'post paid'; type: 'string' };
  Currency: { value: 'CAD' | 'USD'; type: 'string' };
  InvoiceDue: { value: 'specific'; type: 'string' };
  InvoiceDueDate: { value: string | null; type: 'number' };
  InvoicePaymentMethod: { value: 'vopay account'; type: 'string' };
  InvoicingCycle: { value: 'monthly'; type: 'string' };
  MinimumProgramFee: { value: string; type: 'amount' };
  NoMinimumProgramFeePeriod: { value: string; type: 'month' };
  NoPlatformLicenceFeePeriod: { value: string; type: 'month' };
  PlanType: { value: 'pay as you go' | 'subscription'; type: 'string' };
  PlatformLicenceFee: { value: string; type: 'amount' };
  SubAccountMinimumProgramFee: { value: boolean; type: 'boolean' };
  SubAccountsEnabled: { value: boolean; type: 'boolean' };
  ClientAccountsEnabled: { value: boolean; type: 'boolean' };
  UseProgressivePricing: { value: boolean; type: 'boolean' };
  BlendedReturnRatesEnabled: { value: boolean; type: 'boolean' };
  PlatformLicenseFeeFrequency: { value: 'monthly'; type: 'string' };
};
export type PackageSettings = {
  ADRCountries_ID: string;
  AutoBalanceTransferEnabled: PseudoBool;
  AutomaticInteracBulkPayoutEnabled: PseudoBool;
  AutomaticallyPerformKYCOnEFT: PseudoBool;
  ClientAccountsEnabled: PseudoBool;
  EFTTokenOnlyRequired: PseudoBool;
  GCMEnabled: PseudoBool;
  MaxGCMAmount: string;
  PackageName: string;
  PackageType: string;
  PortalViewOnly: PseudoBool;
  SetupFee: string;
  SubAccountPermissions: PseudoBool;
  TermInMonths: string;
  TransactionLabelOverrideEnabled: PseudoBool;
};

export type BillingSettingBasics = {
  ID: string;
  PackageName: string;
  IsActive: boolean;
  Currency: 'CAD' | 'USD';
  StartDate: string;
  EndDate: string;
};

export type CreditCardTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  CreditCardToken: string;
  Country: string;
  ClientReferenceNumber: string;
  Notes: string;
  LastModified: string;
  FailureReason: string;
  GLCode: string;
  TransactionTypeCode: string;
};

export type InteracBulkPayoutTransactionResponse = {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  FailureReason: string;
  TransactionDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  LastModified: string;
  SenderName: string;
  RecipientName: string;
  EmailAddress: string;
  Memo: string;
  ClientReferenceNumber: string;
  ConfirmationNumber: string;
  ProcessingDate: string;
  CancellationPeriod: string;
  Name: string;
  Notes: string;
  PhoneNumber: string;
  TransactionTypeCode: string;
  GLCode: string;
};

export type InteracTransactionResponse = {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  FailureReason: string;
  TransactionDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  LastModified: string;
  Name: string;
  Email: string;
  PhoneNumber: string;
  RecipientName: string;
  MessageForRecipient: string;
  ClientReferenceNumber: string;
  ConfirmationNumber: string;
  ProcessingDate: string;
  BatchFileName: string;
  Notes: string;
  TransactionTypeCode: string;
  GLCode: string;
};

export type RTRWithdrawTransactionResponse = {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: string;
  RecipientName: string;
  FinancialInstitutionNumber: string;
  HoldAmount: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  ClientReferenceNumber: string;
  ProcessingDate: string;
  LastModified: string;
  GLCode: string;
  TransactionTypeCode: string;
};

export type RTPWithdrawTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: string;
  RecipientName: string;
  ABARoutingNumber: string;
  AccountNumber: string;
  ClientReferenceNumber: string;
  LastModified: string;
  GLCode: string;
  TransactionTypeCode: string;
};

export type FedwireTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: string;
  HoldAmount: string;
  LastModified: string;
  CompanyName?: string;
  FirstName?: string;
  LastName?: string;
  Address1: string;
  Address2?: string;
  City: string;
  'Province/State': string;
  'PostalCode/Zipcode': string;
  Country: string;
  WireReferenceNumber: string;
  AccountNumber: string;
  ABARoutingNumber: string;
  ClientReferenceNumber: string;
  HoldReleaseDateTime: string;
  GLCode: string;
  TransactionTypeCode: string;
};

export type TransactionDetail = {
  transactionDetail: {
    type: string;
  };
};

export type TransactionRequest = TransactionId & TimezoneRequest;

export type EftWithdrawTransactionResponse = EftTransactionResponse & {
  ParentTransaction: LinkedTransactionsMap;
};

export type EftFundingTransactionResponse = EftTransactionResponse & {
  SubTransactions: LinkedTransactionsMap;
};

export type EftTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  HoldReleaseDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  ScheduledTransactionID: string;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  RecipientName: string;
  DOB: string;
  PhoneNumber: string;
  Email: string;
  Address1: string;
  Address2: string;
  City: string;
  Province: string;
  Country: string;
  PostalCode: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  ClientReferenceNumber: string;
  LastModified: string;
  ABARoutingNumber: string;
  IBAN: string;
  Iq11: string;
  KYCPerformed: string;
  KYCReferenceNumber: string;
  SortCode: string;
  ParentTransactionID: string;
  FailureReason: string;
  GLCode: string;
  WireReferenceNumber: string;
  TransactionTypeCode: string;
};

export type ACHTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  HoldReleaseDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  ScheduledTransactionID: string;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  RecipientName: string;
  DOB: string;
  PhoneNumber: string;
  Email: string;
  Address1: string;
  Address2: string;
  City: string;
  'Province/State': string;
  'PostalCode/Zipcode': string;
  Country: string;

  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  ClientReferenceNumber: string;
  LastModified: string;
  ABARoutingNumber: string;
  IBAN: string;
  Iq11: string;
  KYCPerformed: string;
  KYCReferenceNumber: string;
  SortCode: string;
  ParentTransactionID: string;
  FailureReason: string;
  GLCode: string;
  WireReferenceNumber: string;
  SecCode: SecCode;
  TransactionTypeCode: string;
};

export type BaseTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  HoldReleaseDateTime: string;
  Amount: string;
  Currency: SupportedCurrencies;
  HoldAmount: string;
  ScheduledTransactionID: string;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  RecipientName: string;
  DOB: string;
  PhoneNumber: string;
  Email: string;
  Address1: string;
  Address2: string;
  City: string;
  Country: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  ClientReferenceNumber: string;
  LastModified: string;
  ABARoutingNumber: string;
  IBAN: string;
  Iq11: string;
  KYCPerformed: string;
  KYCReferenceNumber: string;
  SortCode: string;
  ParentTransactionID: string;
  FailureReason: string;
  Province?: string;
  PostalCode?: string;
  'Province/State'?: string;
  'PostalCode/Zipcode'?: string;
  GLCode: string;
  WireReferenceNumber?: string;
  PaymentRailID?: string;
};

export type LinkedTransactions = {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  FailureReason: string;
  Timestamp: string;
};

export type LinkedTransactionsMap = LinkedTransactions[];

export type Contact = {
  email: string;
  fax: string;
  phone: string;
};

export type Login =
  | {
      Username: string;
      Password: string;
      SSOType?: never;
      SSOToken?: never;
    }
  | {
      Username?: never;
      Password?: never;
      SSOType: SSOType;
      SSOToken: string;
    };

// b/e values stored in vio_partner_sso_helper_factory.class.inc > $Mapping; keep them in sync!
export type SSOType = 'MicrosoftEntra';

export type EntraLogin = {
  EntraAuthCode: string;
};

export type EncodedCredentials = {
  AccountID: string;
  ApiKey: string;
  ApiSharedSecret: string;
};

export type ApiCredentials = {
  AccountID: string;
  ApiKey: string;
  ApiSignature: string;
};

export type PackageDetails = SettingsGroups;

export type PartnerAccounts = ApiResponse & {
  Accounts: Account[];
  CSVFile?: string;
  PaginationMetaData: PaginationMetaData;
};
export type PartnerAccountsApi = ApiResponse & {
  Accounts: {
    [key: number]: AccountApi;
  };
  CSVFile?: string;
  PaginationMetaData: PaginationMetaData;
};

export type PartnerAccountStatus =
  | 'Active'
  | 'Disabled'
  | 'Rejected'
  | 'Pre-Application Check'
  | 'Account Review and Validation'
  | 'Sales Manager Approval'
  | 'Agreement Pending'
  | 'Application Pending'
  | 'Setup Fee Pending'
  | 'Underwriting'
  | 'Credit Risk Review'
  | 'Account Provisioning'
  | 'Certification Pending'
  | 'Implementation Fee Pending'
  | 'Manager Approval';

export type PartnerAccountsRequest = {
  ShowToken?: boolean;
  Country?: string;
  ExportCSV?: boolean;
  AccountName?: string;
  VopayAccountStatus?: PartnerAccountStatus;
  VopayAccountID?: string;
  Offset?: number;
  Limit?: number;
  SearchText?: string;
  Currency?: string;
};

export type PartnerAccountMatrixRequest = {
  VopayAccountID: string;
  FlowOfFunds: string;
  AccountIntendedTransactionType: string;
  NTPFundingEFTEnabled: boolean;
  NTPFundingEFTAmount: string;
  NTPFundingInteracEnabled: boolean;
  NTPFundingInteracAmount: string;
  NTPFundingCreditCardEnabled: boolean;
  NTPFundingCreditCardAmount: string;
  NTPFundingTotalAmount: string;
  NTPFundingAvgFundedAmount: string;
  NTPFundingLargestFundedAmount: string;
  NTPWithdrawEFTEnabled: boolean;
  NTPWithdrawEFTAmount: string;
  NTPWithdrawInteracEnabled: boolean;
  NTPWithdrawInteracAmount: string;
  NTPWithdrawVPInstantEnabled: boolean;
  NTPWithdrawVPInstantAmount: string;
  NTPWithdrawTotalAmount: string;
  NTPWithdrawAvgWithdrawAmount: string;
  NTPWithdrawLargestWithdrawAmount: string;
  TPFundRequestEFTEnabled: boolean;
  TPFundRequestEFTAmount: string;
  TPFundRequestInteracEnabled: boolean;
  TPFundRequestInteracAmount: string;
  TPFundRequestVPInstantEnabled: boolean;
  TPFundRequestVPInstantAmount: string;
  TPFundRequestP2CEnabled: boolean;
  TPFundRequestP2CAmount: string;
  TPFundRequestTotalAmount: string;
  TPFundRequestAvgRequestAmount: string;
  TPFundRequestLargestRequestAmount: string;
  TPCollectRequestEFTEnabled: boolean;
  TPCollectRequestEFTAmount: string;
  TPCollectRequestInteracEnabled: boolean;
  TPCollectRequestInteracAmount: string;
  TPCollectRequestCreditCardEnabled: boolean;
  TPCollectRequestCreditCardAmount: string;
  TPCollectRequestTotalAmount: string;
  TPCollectRequestAvgRequestAmount: string;
  TPCollectRequestLargestRequestAmount: string;
};

export type PartnerAccountBusinessCaseRequest = {
  VopayAccountID: string;
  BusinessName: string;
  BusinessModel: string;
  WebsiteURL: string;
  NumberofYearsInBusiness: string;
  BusinessPhone: string;
  BusinessEmail: string;
  MSB: boolean;
  Notes?: string;
  PlatformUsage?: string;
  BillingPackagesID: string;
  createBillingPackage: boolean;
  DataAggregator?: string;
  SystemOfRecord?: string;
  SocialMediaPage?: string;
  CompanyPhone?: string;
  LegalAgreementNotes?: string;
};

export type PartnerAccountRequest = {
  Name: string;
  EmailAddress: string;
  LegalBusinessName: string;
  PrimaryContactFullName: string;
  Country: string;
  ClientAccountsEnabled: boolean;
  OrganizationalType: string;
  BusinessTypeID: string;
  BusinessTypeCategoryID: string;
  AccountingSoftwareIntegrationEnabled: boolean;
  BillingPackageID?: string;
  HubspotCompany_ID?: string;
  HubspotDeal_ID?: string;
  Address1: string;
  City: string;
  Province: string;
  PostalCode: string;
  WebsiteURL: string;
  BusinessPhone: string;
  FullLegalName?: string;
  SendWelcomeEmail?: boolean;
} & { [key: string]: string | boolean };
// TODO: consider strongly typing the request based on api also for a reference \partner-dashboard\src\app\components\BillingPackages\types.ts

export type HubSpotDropdownData = {
  label: string;
  value: string;
  displayOrder: number;
  hidden: boolean;
};

export type HubSpotDealDetails = {
  CompanyHubspotID: string;
  CompanyName: string;
  Industry: string;
  Country: string;
  TransactionsPerMonth: string;
  AverageTransactionSize: string;
  AccountLink: string;
  CompanyWebsite: string;
  PlatformUsage: string;
  CompanyPhone: string;
  SocialMediaPage: string;
  DealCountry: string;
};

export type HubSpotDealUpdateRequest = {
  DealID: string;
  CompanyWebsite: string;
  PlatformUsage: string;
  CompanyPhone: string;
  SocialMediaPage: string;
};

export type DocumentUploadRequest = {
  DocumentContent: string;
  DocumentName: string;
  DocumentType: string;
  DocumentTypeID?: number;
  IsPartner?: boolean;
};

export type BankAccountDocumentUploadRequest = DocumentUploadRequest & {
  ID?: number;
  Iq11Token: string;
};

export type DocumentUploadResponse = ApiResponse & {
  DocumentID: string;
};

export type AccountDocumentRequest = {
  DocumentID: string;
};

export type AccountDocumentResponse = ApiResponse & {
  Document: string;
};

export type AccountBillingDetailsRequest = {
  ApplicationID: string;
};

export type AccountBillingDetail = {
  FinancialInstitutionNumber: string;
  AccountNumber: string;
  Token: string;
  Type: string;
  Purpose: string;
  InstitutionName: string;
  FinancialInstitutionID: string;
  IsActive: string;
  IsDefault: string;
  ID: string;
  PaymentMethod: string;
};

export type AccountBillingDetailsSaveRequest = {
  ApplicationID: string;
  AccountToken1: string;
  AccountToken2: string;
  ConnectionType1: string;
  ConnectionType2: string;
  PaymentMethod1: string;
  PaymentMethod2: string;
  Functionality1: string;
  Functionality2: string;
  ConnectedAccountToken1: string;
  IsAccount1ManualBank: boolean;
  ConnectedAccountToken2: string;
  IsAccount2ManualBank: boolean;
};

export type AccountBillingDisconnectionRequest = {
  ApplicationID: string;
  AccountsDeleted: boolean;
};

export type AccountBillingSavePaymentInformationRequest = {
  ApplicationID: string;
  BillingToken: string;
  BillingPaymentMethod: string;
  OperationalToken: string;
  OperationalPaymentMethod: string;
  SetAsDefault: boolean;
  PaymentMethod: string;
};

export type AccountBillingSavePaymentInformationResponse = ApiResponse & {
  Token: {
    Billing: string;
    Operational: string;
  };
  IsDefault: string;
  Purpose: {
    BillingToken: string;
    OperationalToken: string;
  };
};

export type BankAccountDocumentDeleteRequest = {
  AccountDocumentID: string;
  BankAccountID: string;
};

export type AccountDocumentDetail = {
  ID: number;
  DocumentID: string;
  DocumentType: string;
  BankAccountNumber: string;
  BankAccountID: string;
  Description: string;
};

export type OnboardingPartnerType = 'Referral' | 'VAR' | 'Technology' | 'Inside Sales' | 'Technology Channel';

export type AccountBillingDetails = {
  Country: string;
  Type: OnboardingPartnerType;
};

export type AccountBillingPermissions = {
  CreditCardEnabled: string;
};

export type AccountBillingPartnerInfo = {
  Name: string;
  Type: string;
};

export type AccountBillingTokens = {
  Billing: string;
  Operational: string;
};

export type BillingAccountFormFields = {
  billing_token?: string;
  billing_connection_method?: string;
  billing_connection_type?: string;
  billing_account_number?: string;
  billing_institution_number?: string;
  billing_transit_number?: string;
  billing_routing_number?: string;
  billing_credit_card?: string;
};

export type SecurityAccountFormFields = {
  security_deposit_token?: string;
  security_deposit_connection_method?: string;
  security_deposit_connection_type?: string;
  security_deposit_account_number?: string;
  security_deposit_institution_number?: string;
  security_deposit_transit_number?: string;
  security_deposit_routing_number?: string;
};

export type CommonAccountFormFields = {
  account_connected?: string;
  pad_agreement_acknowledgement?: string;
};

export type AccountBillingFormFields = {
  Billing: BillingAccountFormFields;
  Security: SecurityAccountFormFields;
  Common: CommonAccountFormFields;
};

export type AccountBillingFormValues = {
  Common: CommonAccountFormFields;
};

export type AccountBillingDetailsResponse = ApiResponse & {
  AccountDetails: AccountBillingDetails;
  Permissions: AccountBillingPermissions;
  PartnerInfo: AccountBillingPartnerInfo;
  BankAccounts: { [key: number]: AccountBillingDetail };
  BankDocumentDetails: { [key: number]: AccountDocumentDetail };
  Tokens: AccountBillingTokens;
  FormFields: AccountBillingFormFields;
  FormValues: AccountBillingFormValues;
  BankStatementsRequired: boolean;
};

export type PartnerAccountCreationResponse = ApiResponse & {
  Message: string;
  AccountID: string;
  APISharedSecret: string;
  APIKey: string;
};

export type PartnerAccountCreationLinkResponse = PartnerAccountCreationResponse & {
  Link: string;
};

export type PartnerBillingPackage = {
  PackageID: string;
  PackageName: string;
  DateAdded: string;
  CreatedBy: string;
  Currency: string;
  Country: string;
};

export type PartnerBillingSettingsDetailsRequest = {
  SettingsID: string;
};
export type LeadsDetailsRequest = {
  LeadID: string;
};
export type LeadsDetailsResponse = ApiResponse & {
  lead?: Lead;
};
export type LeadsAgentRequest = {
  AgentID: string;
};
export type LeadsParentRequest = {
  PartnerID: string;
  ShowToken: string;
};
export type LeadsResponse = ApiResponse & {
  Leads?: { [key: number]: Lead };
};

export type Lead = {
  ID: string;
  FirstName: string;
  LastName: string;
  Company: string;
  Email: string;
  DateAdded: string;
  LastModified: string;
  HubspotLeadID: string;
  HubspotCompanyID: string;
  LeadStatus: string;
  PartnerUSRUsers_ID: string;
  USRUsers_ID: string;
  ReferredBy: string;
  Website: string;
  DBA: string;
  Comments: string;
  BusinessModel: string;
  Active: boolean;
  Token?: string;
};

export type PartnerBillingSettingsDetailsResponse = ApiResponse & {
  SettingsDetails: SettingsDetails;
};

export type PartnerBillingPackageDetailsRequest = {
  PackageID: string;
};

export type PartnerBillingPackageDetailsResponse = ApiResponse & {
  PackageDetails: PackageDetails;
};

export type PartnerBillingPackagesResponse = ApiResponse & {
  BillingPackages: Record<string, PartnerBillingPackage>;
};

export type PartnerCustomPackageRequest = {
  PackageName: string;
  Currency: 'CAD' | 'USD';
} & { [key: string]: string | boolean };

export type PartnerCustomPackageResponse = ApiResponse & {
  IsApproved: boolean;
};
export type PartnerAccountSummaryRequest = {
  Year: string;
  Month: string;
};
export type PartnerAccountSummaryResponse = ApiResponse & {
  Year: string;
  Month: string;
  AccountSummary?: {
    [Currency: string]: {
      [Company: string]: AccountSummary;
    };
  };
};
export type AccountSummary = {
  TotalRevenueGenerated: string;
  PartnerIncome: string;
  VopayAccountID: string;
};
export type PartnerAccountSummaryDetailsRequest = {
  Year: string;
  Month: string;
  VopayAccountID?: string;
};
export type PartnerAccountSummaryDetailsResponse = ApiResponse & {
  Year: string;
  Month: string;
  AccountSummary: {
    [Currency: string]: {
      [Company: string]: AccountSummaryDetails;
    };
  };
};
export type AccountSummaryDetails = {
  [Service: string]: {
    TotalRevenueGenerated: string;
    PartnerIncome: string;
  };
};
export type InvoicesRequest = {
  FromDate?: string;
  ToDate?: string;
  Currency?: SupportedCurrencies | '';
  SearchText?: string;
};

export type PartnerInvoiceDetailsRequest = {
  VopayAccountID?: string;
  Year: string;
  Month: string;
};

export type InvoicePdfRequest = {
  InvoiceID: string;
};

export type InvoicePdfResponse = ApiResponse & {
  InvoicePDF: string;
};

export type PartnerInvoicesResponse = ApiResponse & {
  PartnerInvoices?: { [key: string]: PartnerInvoice };
};

export type PartnerInvoice = {
  InvoiceID: string;
  CurrencyShortForm: SupportedCurrencies;
  DueDate: string;
  FromDate: string;
  InvoiceDate: string;
  InvoiceNumber: string;
  InvoiceType: 'recurring' | 'setup' | 'termination' | 'credit' | 'monthly fees';
  PaymentStatus: 'pending' | 'paid' | 'void';
  Subtotal: string;
  TaxRate: string;
  TaxTotal: string;
  TaxType: string | null;
  ToDate: string;
  Total: string;
};
export type AccountInvoicesResponse = ApiResponse & {
  Invoices?: { [key: string]: PartnerInvoice };
};
export type HubSpotDropdownDataResponse = ApiResponse & {
  PlatformUsages: Record<string, HubSpotDropdownData>;
  Industries: Record<string, HubSpotDropdownData>;
};

export type HubSpotDealDataRequest = {
  DealID: string;
};

export type HubSpotDealDetailsResponse = ApiResponse & {
  Details: HubSpotDealDetails;
};

export type PartnerInvoiceDetailsInvoiceDetails = {
  [key: string]: {
    [key in SupportedCurrencies]?: {
      [key: string]: { description: string; quantity: number; rate: string; amount: number };
    };
  };
};

export type PartnerInvoiceDetailsInvoicePeriod = {
  FromDate: string;
  ToDate: string;
};

export type PartnerInvoiceDetailsResponse = ApiResponse & {
  InvoiceDetails: PartnerInvoiceDetailsInvoiceDetails;
  InvoicePeriod: PartnerInvoiceDetailsInvoicePeriod;
};

export type PartnersResponse = ApiResponse & {
  PartnerAccount?: { [key: string]: { Username: string; Name: string } };
};

export type ELinxDeclineRequest = {
  SingleUseToken: string;
};
export type PaymentOption = 'multiple' | 'partial' | 'installments';

export type PartialPayment = {
  Amount: string;
  RemainderPaymentDate: string | null;
};

export type InstallmentDetails = {
  initialAmount: string;
  scheduleAmount: string;
  scheduleStartDate: string;
};

export type FlexiblePayment = {
  PaymentOption: PaymentOption;
  Tokens?: {
    [key: string]: {
      ConnectionType: 'bank' | 'credit' | 'debit' | 'email';
      Amount: string;
    };
  };
  PartialPaymentDetails?: PartialPayment;
  InstallmentDetails?: InstallmentDetails;
};
export type ELinxConnectionMethod =
  | 'bank'
  | 'credit'
  | 'debitcard'
  | 'email'
  | 'googlepay'
  | 'applepay'
  | 'paypal'
  | 'venmo';
export type ELinxSetAccountRequest = {
  SingleUseToken: string;
  Iq11Token?: string;
  PaymentMethod: ELinxConnectionMethod | '';
  FlexiblePaymentOptions?: FlexiblePayment;
  BankAccountRail?: BankingPaymentRail;
};

export type UserListsResponse = ApiResponse & {
  PartnerUsers?: {
    [key: string]: { Username: string };
  };
};

export type FetchPartnerAccountUsersApiResponse = ApiResponse & {
  Users: { [key: string]: AccountUser };
};

export type FetchPartnerAccountUsersResponse = ApiResponse & {
  Users: AccountUser[];
};

export type UserListsRequest = {
  Username: string;
};

export type CreditCardRequest = {
  ClientAccountID: string;
  ClientControlled?: boolean;
  CreditCardToken?: string;
};

export type CreditCardApiResponse = {
  CreditCardToken: string;
  CreditCardHolderName: string;
  CreditCardNumber: string;
  CreditCardExpiryYear: string;
  CreditCardExpiryMonth: string;
  CreditCardBrand: string;
  SendingEligibility?: PseudoBool;
  ReceivingEligibility?: PseudoBool;
  FundsAvailability?: string;
  IsDefault: PseudoBool;
};

export type CreditCardsApiResponse = ApiResponse & {
  CreditCards?: {
    [key: number]: CreditCardApiResponse;
  };
};

export type CreditCardResponse = ApiResponse & {
  CreditCards: (Omit<CreditCardApiResponse, 'IsDefault' | 'SendingEligibility' | 'ReceivingEligibility'> & {
    IsDefault: boolean;
    SendingEligibility?: boolean;
    ReceivingEligibility?: boolean;
  })[];
};

export type AccessTokenInfoRequest = {
  IframeKey: string;
  PaymentSelectionMethod: string;
  ForOnboarding: boolean;
};

export type AccessTokenExtraInfo = Omit<Record<string, string>, 'TokenizationSpecification'> & {
  TokenizationSpecification?: google.payments.api.PaymentMethodTokenizationSpecification;
};

export type AccessTokenInfoResponse = ApiResponse & {
  AccessToken: string;
  Processor: string;
  ExtraInfo: AccessTokenExtraInfo;
};

export type LinkPushToCardMapRequest = {
  IframeKey: string;
  Token: string;
  RequestID: string;
  IsPayLinkTransaction: boolean;
};

export type PushToCardDetails = {
  CardToken: string;
  IframeUrl: string;
};

export type PushToCardMapResponse = ApiResponse & {
  PushToCardDetails: PushToCardDetails;
};

export type BankAccountsRequest = TimezoneRequest & {
  ClientAccountID: string;
  Purpose?: string;
  MasterAccountOnly?: boolean;
  fetchBankAccounts?: boolean;
};

export type GetDebitCardsRequest = {
  DebitCardToken?: string;
  ClientAccountID?: string;
  ClientControlled?: boolean;
};

type BankAccount = {
  BankId: number;
  AccountHolderName: string;
  InstitutionName: string;
  FinancialInstitutionNumber: number;
  BranchTransitNumber: number;
  ABARoutingNumber: string;
  AccountNumber: number;
  Currency: string;
  Token: string;
  FlinksAccountID: string;
  FlinksLoginID: string;
  PlaidAccountID: string;
  InveriteRequestGUID: string;
  ClientControlledBankAccount: number;
  IsDefault: string;
  ClientAccountID: string;
  ClientReferenceNumber: string;
  Address: string;
  City: string;
  PostalCode: string;
  Province: string;
  EmailAddress: string;
  Phone: string;
  DateAdded: string;
  IntegrationType: string;
  FlinksAccountId: string;
  FlinksLoginId: string;
  PlaidProcessorToken: string;
  FiservToken: string;
  MxAuthorizationCode: string;
  MxProcessorToken: string;
};

export type BankAccountsResponse = ApiResponse & {
  BankAccounts: {
    [key: number]: BankAccount;
  };
};

export type DeleteCreditCardRequest = {
  CreditCardToken: string;
  ForOnboarding?: boolean;
};

export type DeleteDebitCardRequest = {
  CardToken: string;
};

export type DeleteBankAccountRequest = {
  Token: string;
  PortalUser?: string;
  ForOnboarding?: boolean;
};

export type DeleteBankAccountDocumentsRequest = {
  Token: string;
  PortalUser?: string;
  ForOnboarding?: boolean;
};

export type PortalUser = {
  PortalUser?: string;
};

export type EmailRequest = {
  Email: string;
};

export type IsPartner = {
  IsPartner?: boolean;
};

export type CreateUserRequest = {
  EmailAddress: string;
  SendEmail: boolean;
  Role: string;
};
export type CreateUserResponse = ApiResponse & {
  Username: string;
  Password: string;
};
export type DeleteUserRequest = {
  EmailAddress: string;
};
export type DeleteUserResponse = ApiResponse & {
  UserID: string;
  IsActive: boolean;
};
export type UserChangePasswordRequest = {
  EmailAddress: string;
  NewPassword: string;
  SendEmail: boolean;
};
export type UserChangeRoleRequest = {
  Role: string;
  PartnerUserName: string;
};
export type UserChangePasswordResponse = ApiResponse & {
  Username: string;
  Password: string;
};
export type StatementCsvRequest = {
  InvoiceID: string;
};

export type StatementCsvResponse = ApiResponse & {
  InvoiceCSV: string;
};
export type StatementPDFResponse = ApiResponse & {
  InvoicePDF: string;
};
export type PartnerStatementPdfRequest = {
  InvoiceID: string;
};

export type PartnerStatementPdfResponse = ApiResponse & {
  StatementPDF: string;
};

export type PartnerStatisticsResponse = ApiResponse & {
  Statistics: PartnerStatistics;
};

export type PartnerStatistics = {
  balances: {
    totals: {
      [currency: string]: {
        AvailableBalance: number;
        AccountBalance: number;
        PendingBalance: number;
        AvailableImmediately: number;
        Reserve: number;
      };
    };
  };
  statusCount: {
    total: number;
    active: number;
    inactive: number;
  };
  transactions: {
    dailyAverages: {
      [transactionType: string]: number;
    };
    dailyBreakdown: {
      [date: string]: {
        [transactionType: string]: number;
      };
    };
    dailyCounts: {
      [date: string]: number;
    };
  };
};

export type PartnerStatisticsDataResponse = ApiResponse & {
  Statistics: PartnerStatisticsData;
};

export type PartnerStatisticsData = {
  [StatType: string]: PartnerStatisticsBasicData;
};

export type PartnerStatisticsBasicData = {
  numOfData: {
    yearly: number;
    monthly: number;
    weekly: number;
  };
  volOfData: {
    yearly: number;
    monthly: number;
    weekly: number;
  };
};

export type BankHolidaysApiResponse = ApiResponse & {
  BankHolidays: {
    [idx: number]: BankHoliday;
  };
};

export type BankHolidaysResponse = ApiResponse & {
  BankHolidays: BankHoliday[];
};

export type BankHoliday = {
  Country: string;
  HolidayDate: string;
  HolidayName: string;
};

export type UserDataOverviewResponse = ApiResponse & {
  Statistics: {
    [Id: string]: {
      name: string;
      value: number;
    };
  };
};

export type TicketClientsRequest = EmailRequest & TimezoneRequest;
export type TicketDetailsClientRequest = TicketDetialRequest & TimezoneRequest;

export type TicketDetialRequest = {
  TicketID: string;
};

export type Ticket = {
  dateAdded: string;
  lastUpdated: string;
  id: number | null;
  status: string | null;
  subject: string | null;
  description?: string;
};

export type TicketsApiResponse = ApiResponse & {
  Tickets: {
    [key: string]: Ticket;
  };
};

export type TicketsResponse = ApiResponse & {
  Tickets: Ticket[];
};

export type TicketComment = {
  author: string;
  email: string;
  comment: string;
  created_at: string;
  content_url: string | null;
};
export type TicketDetailsResponse = ApiResponse & {
  Ticket: {
    dateAdded: string;
    lastUpdated: string;
    id: string;
    status: string;
    subject: string;
    description: string;
    author: string;
    ticketComments: TicketComment[];
  };
};
export type SubmitTicketRequest = {
  AccountName: string;
  CcEmails: string;
  SenderEmailAddress?: never; // Even though the endpoint allows it, don't send it for security reasons
  TicketSubject: string;
  TicketContent: string;
  TicketCategory: string;
  TransactionID: string;
  TicketAttachment: string;
  TicketRequesterName: string;
  TicketSubCategory: string;
  AttachmentFileName: string;
};

export type SubmitTicketResponse = ApiResponse & {
  TicketID: number;
};

export type SubmitTicketCommentRequst = {
  TicketComment: string;
  TicketAuthor: string;
  TicketID: string;
};
export type TicketAttachmentRequst = {
  ID?: number | undefined;
  TicketAttachment: string;
};
export type PartnerAccountTransferRequest = {
  TransferTypeID: string;
  DebitorAccountID: string;
  RecipientAccountID: string;
  Amount: string;
  Currency: string;
  ClientReferenceNumber: string;
  Notes: string;
};

export type PartnerAccountTransferResponse = ApiResponse & {
  TransactionID: string;
};

export type PartnerAccountFundAndTransferResponse = ApiResponse & {
  FundingTransactionID: string;
  AccountTransferID: string;
};
export type PartnerAccountTransferAndWithdrawResponse = ApiResponse & {
  AccountTransferID: string;
  WithdrawTransactionID: string;
};
export type PartnerAccountFundTransferAndWithdrawResponse = ApiResponse & {
  FundingTransactionID: string;
  AccountTransferID: string;
  WithdrawTransactionID: string;
};

export type ActivityOverviewResponse = ApiResponse & {
  Statistics: {
    [Id: number]: ActivityOverviewItem;
  };
};
export type ActivityOverviewItem = {
  TransactionType: string;
  TransactionDate: string;
  Amount: number;
};
export type PartnerStatisticsBasicDataRequest = {
  StatType: string;
};

export type ActivityOverviewRequest = {
  ToDate: string;
  FromDate: string;
};

export type AgreementDetailsResponse = ApiResponse & {
  DocumentID: string;
  AgreementStatus: string;
  DateAdded: string;
};
export type IQ11Login = {
  EmailAddress: string;
  Password: string;
};

export type IQ11AuthorizationResponse = ApiResponse & {
  ClientAccount: IQ11AuthorizationClientAccount;
  JWT: string;
  Permissions: IQ11Permissions;
};
export type IQ11Permissions = {
  BankAccountsEnabled: boolean;
  CreditCardsEnabled: boolean;
};

export type IQ11AuthorizationClientAccount = {
  BusinessName: string;
  ClientAccountID: string;
  ClientDisplayName: string;
  ClientType: string;
  DateAdded: string;
  DateDeleted: string;
  EmailAddress: string;
  FirstName: string;
  LastName: string;
  IPAddress: string;
  IsActive: string;
  IsPrimaryAccount: string;
  IsBillingAccount: string;
  LastModified: string;
  TransactionLimit: string;
  ID: number;
  VIOClientAccountUsers_ID: number;
  VIOAccounts_ID: number;
};
export type IQ11PersonalProfile = {
  FullName: string;
  EmailAddress: string;
  PhoneNumber: string;
  Address: string;
  Password: string;
  ConfirmPassword: string;
};

export type IQ11BusinessProfile = {
  CompanyName: string;
  EmailAddress: string;
  PhoneNumber: string;
  Address: string;
  Password: string;
  ConfirmPassword: string;
};

export type IQ11CreditCard = {
  FullName: string;
  CardNumber: string;
  ExpirationDate: string;
  CVV: string;
  Address: string;
  Brand: string;
};

export type IQ11CreditCardEmbedUrlRequest = {
  RedirectURL: string;
  ClientAccountID: string;
};

export type AcceptedCardBrand = 'visa' | 'mastercard' | 'discover' | 'amex' | 'unionpay';
export const allCardBrands: AcceptedCardBrand[] = ['visa', 'mastercard', 'discover', 'amex', 'unionpay'];

export type IQ11EmbedUrlRequest = {
  RedirectURL: string;
  ClientAccountID: string;
  PaymentSelectionMethod?: string;
  AccountSelectionMethod?: string;
  RedirectMethod?: string;
  Language?: string;
  AcceptedCardBrands?: string; // comma separated array of AcceptedCardBrands
  CardTypeValidation?: boolean;
};

export type IQ11EmbedUrlResponse = ApiResponse & {
  EmbedURL: string;
  IframeKey: string;
};

export type SetMyCreditCardRequest = {
  CreditCardToken: string;
  SetAsDefault: boolean;
  ClientAccountID?: string;
};

export type SetMyCreditCardResponse = ApiResponse & {
  CreditCardToken: string;
  IsDefault: string;
};

export type SetMyDebitCardRequest = {
  CardToken: string;
  SetAsDefault: boolean;
  ClientAccountID?: string;
};

export type SetMyDebitCardResponse = ApiResponse & {
  CardToken: string;
  IsDefault: string;
};

export type SetClientEmailRequest = {
  Token: string;
  ClientAccountID: string;
  SetAsDefault: boolean;
};

export type SetClientEmailResponse = ApiResponse & {
  IsDefault: boolean;
  Token: string;
};

export type SetMyBankAccountRequest = {
  PortalUser?: string;
  Token: string;
  ClientAccountID?: string;
  SetAsDefault: boolean;
  Purpose?: string;
};

export type SetMyBankAccountPurposeRequest = SetMyBankAccountRequest & {
  RemovePurpose?: string | null;
};

export type SetMyBankAccountResponse = ApiResponse & {
  Token: string;
  IsDefault: string;
};

export type SetMyApplePayRequest = {
  ApplePayToken: string;
  ClientAccountID?: string;
  SetAsDefault?: boolean;
};

export type SetMyApplePayResponse = ApiResponse & {
  ApplePayToken: string;
  IsDefault: boolean;
};

export type SetMyPayPalRequest = {
  PayPalToken: string;
  ClientAccountID?: string;
  SetAsDefault?: boolean;
};

export type SetMyPayPalResponse = ApiResponse & {
  PayPalToken: string;
  IsDefault: boolean;
};

export type SetMyVenmoRequest = {
  VenmoToken: string;
  ClientAccountID?: string;
  SetAsDefault?: boolean;
};

export type SetMyVenmoResponse = ApiResponse & {
  VenmoToken: string;
  IsDefault: boolean;
};

export type SetMyBankAccountPurposeResponse = SetMyBankAccountResponse & {
  Purpose: { [idx: number]: string };
};

export type MyBankAccountRequest = {
  Token: string;
  ClientAccountID?: string;
};

export type MyBankAccountResponse = ApiResponse & {
  BankAccounts: { [idx: number]: ClientBankAccountsLists };
};

export type DeleteGroupContactRequest = {
  ContactID: string;
};

export type OnboardingAppTokenRequest = {
  OnboardingAppKey: string;
  ApplicationID: string;
};

export type OnboardingAppTokenResponse = ApiResponse & {
  Token: string;
  AccountType: 'vopay' | 'partner';
};

export type AssignedBillingPackagesRequest = {
  Token?: string;
};

export type BillingPackage = {
  Reserve: string;
  SetupFee: string;
  MinimumProgramFee: string;
  [key: string]: string;
};

export type AssignedBillingPackagesResponse = ApiResponse & {
  AssignedBillingPackage: BillingPackage;
};

export type PartnerType = 'PayFac' | 'ISV' | 'ISO' | 'Inside Sales';

export type PseudoBool = '0' | '1';

export type PseudoDataType = 'boolean' | 'amount' | 'percent' | 'select';

export type PlanFee<T> = { label: string; value: T | null; type: PseudoDataType };

export type TierOption<T> = {
  label: string;
  value: T;
};

export type TierFee<T> = {
  label: string;
  value: T | null;
  type: PseudoDataType;
  options: Record<string, TierOption<T>>;
};

export type PlanSetting = {
  permissions: { [key: string]: PlanFee<boolean> };
  maxAmounts: { [key: string]: PlanFee<string> };
  payAsYouGo: { [key: string]: PlanFee<string> };
  subscription: { [key: string]: PlanFee<string> };
  common: { [key: string]: PlanFee<string> };
  tiers: { [key: string]: TierFee<string> };
};

export type PlanSettings = {
  [sectionName: string]: PlanSetting;
};

export type SettingsGroups = {
  BillingSettings?: BillingSettings;
  PlanSettings?: PlanSettings;
  PackageSettings?: PackageSettings;
};

export type SettingsDetails = SettingsGroups;

export type SingleUseTokenRequest = {
  Username?: string;
  Token?: string;
  ApplicationType: 'registration' | 'Verification';
};

export type SingleUseTokenResponse = ApiResponse & {
  Token: string;
  IsValidToken: boolean;
};

export type OnboardingAppUrlRequest = {
  VopayAccountID: string;
};

export type OnboardingAppUrlResponse = ApiResponse & {
  OnboardingURL: string;
};

export type SupportedCurrencies = 'CAD' | 'USD' | 'GBP' | 'EUR' | 'AUD' | 'DKK' | 'SEK' | 'NOK' | 'PLN';
export type SupportedTransferTypes = 'Transfer' | 'FundAndTransfer' | 'TransferAndWithdraw' | 'FundTransferAndWithdraw';

export type Transaction = {
  ChildTransactionIDs: { [idx: number]: string };
  D: string;
  ClientReferenceNumber: string;
  ConfirmedByClient: boolean;
  CreditAmount: string;
  Currency: SupportedCurrencies;
  ClientAccountID: string;
  AccountID: string;
  AccountName: string;
  DebitAmount: string;
  HoldAmount: string;
  IsRefunded: string;
  LastModified: string;
  Notes: string;
  ParentTransactionID: string;
  PayLinkDetails: { [idx: number]: string };
  ScheduledTransactionID: string;
  TransactionDateTime: string;
  TransactionFailureReason: string;
  TransactionFlag: string;
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  FullName: string;
  Username: string;
  SettlementDate: string;
  PaymentRailID: string;
};

export type AccountTransaction = {
  ChildTransactionIDs: { [idx: number]: string };
  D: string;
  ClientReferenceNumber: string;
  ConfirmedByClient: boolean;
  CreditAmount: string;
  Currency: SupportedCurrencies;
  AccountID: string;
  AccountName: string;
  ClientAccountID: string;
  DebitAmount: string;
  HoldAmount: string;
  IsRefunded: string;
  LastModified: string;
  Notes: string;
  ParentTransactionID: string;
  PayLinkDetails: { [idx: number]: string };
  ScheduledTransactionID: string;
  TransactionDateTime: string;
  TransactionFailureReason: string;
  TransactionFlag: string;
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  FullName: string;
};

export type AccountUserPermissions = {
  ViewSubaccounts?: boolean;
  AddSubaccounts?: boolean;
  CreatePayments?: boolean;
  CreateCollections?: boolean;
  ViewBeneficiaries?: boolean;
  AddBeneficiaries?: boolean;
  ViewBulkFileUpload?: boolean;
  CreateBulkFileUpload?: boolean;
  ViewScheduledTransactions?: boolean;
  ViewTransactionHistory?: boolean;
  ViewSettings?: boolean;
  AddSettings?: boolean;
  ViewUsers?: boolean;
  AddUsers?: boolean;
  ApproveTransactions?: boolean;
  ManageUserPermissions?: boolean;
  CreateAccountTransfer?: boolean;
  ViewClientAccounts?: boolean;
  AddClientAccounts?: boolean;
  CreateClientAccountTransfers?: boolean;
  CreateConversions?: boolean;
  ManageDefaultPayments?: boolean;
  CreateSupportTickets?: boolean;
  ViewSupportTickets?: boolean;
  ViewReconciliation?: boolean;
  ViewAccountingBillsAndInvoices?: boolean;
  ProcessAccountingBillsAndInvoices?: boolean;
  CreditCardEnabled?: boolean;
  IQ11Enabled?: boolean;
  TransactionCancellation?: boolean;
  ViewTransactionReport?: boolean;
  CreateTransactionReport?: boolean;
  ManageTransactionGroups?: boolean;
  ViewTransactionApprovalWorkflow?: boolean;
};

export type TransactionsRefundResponse = ApiResponse & {
  TransactionID: string;
};

export type TicketCategoriesResponse = ApiResponse & {
  SupportTicketCategory: TicketCategory[];
  SupportTicketSubCategory: TicketSubCategory[];
};

export type TransactionsRefundRequest = {
  TransactionID: string;
};

export type TransactionsCancelResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: string;
  Timestamp: string;
};

export type TransactionsCancelRequest = {
  TransactionID: string;
  Amount?: string;
};

export type AccountUserPermissionsRequest = {
  EmailAddress: string;
};

export type PermissionItem = {
  label: string;
  permitted: boolean;
};

export type PermissionGroup = {
  [permissionKey: string]: PermissionItem;
};

export type PermissionsMap = {
  [groupName: string]: PermissionGroup;
};

export type AccountUserPermissionsResponse = ApiResponse & {
  Username: string;
  Permissions: { [key: string]: string };
};
export type AccountUserPermissionsNewResponse = ApiResponse & {
  Username: string;
  Permissions: PermissionsMap;
};
export type AccountUserPermissionsMap = {
  [key: string]: boolean;
};

export type AccountUserPermissionsPostRequest = AccountUserPermissions & {
  EmailAddress: string;
};

export type SigningAuthorityInfoRequest = {
  AccountID: string;
  Key: string;
  Signature: string;
};

export type SigningAuthorityInfoResponse = ApiResponse & {
  AccountName: string;
  SigningAuthority: { [key: string]: SigningAuthority };
};

export type PartnerSigningAuthorityInfoApiResponse = ApiResponse & {
  PartnerName: string;
  SigningAuthority: {
    [key: string]: SigningAuthority;
  };
};
export type PartnerSigningAuthorityInfoResponse = ApiResponse & {
  PartnerName: string;
  SigningAuthority: SigningAuthority[];
};

export type Signer = {
  ID: string;
  FullName: string;
  DOB: string;
  Occupation: string;
  EmailAddress: string;
  HomeAddress: string;
  DocumentSigned: string;
  DateAdded: string;
};

export type SigningAuthority = {
  ID: string;
  FullName: string;
  DOB: string;
  Occupation: string;
  EmailAddress: string;
  HomeAddress: string;
  DocumentSigned: string;
  DateAdded: string;
};

export type AccountLimitsRequest = {
  PortalUser: string;
  Date: string;
};

type Limits = {
  Daily: string;
  Weekly: string;
  Monthly: string;
};

type RemainingLimits = {
  Daily: string;
  Weekly: string;
  Monthly: string;
};

type InboundOutbound = {
  Limits: Limits;
  RemainingLimits: RemainingLimits;
};

export type AccountLimitsResponse = ApiResponse & {
  Inbound: InboundOutbound;
  Outbound: InboundOutbound;
};

export type AgreementDownloadRequest = {
  DocumentID: string;
};

export type VoidAgreementRequest = {
  DocumentID: string;
};

export type AgreementDownloadResponse = ApiResponse & {
  base64: string;
};

export type DeleteSignerRequest = {
  SigningAuthorityID: string;
};

export type DeleteSignerResponse = ApiResponse & {
  SigningAuthorityID: string;
};

export type EditSignerRequest = {
  AuthorizedFullLegalName: string;
  AuthorizedDOB: string;
  AuthorizedOccupation: string;
  AuthorizedEmailAddress: string;
  AuthorizedAddress1?: string;
  AuthorizedAddress2?: string;
  AuthorizedCity?: string;
  AuthorizedProvince?: string;
  AuthorizedCountry?: string;
  AuthorizedPostalCode?: string;
  SigningAuthorityID?: string;
};

export type EditSignerResponse = ApiResponse & {
  Message: string;
};

export type SendOnboardingEmailRequest = {
  Email: string;
  Link: string;
  Name: string;
  VopayAccountID: string;
};

export type AddSignerRequest = {
  AuthorizedFullLegalName: string;
  AuthorizedDOB: string;
  AuthorizedOccupation: string;
  AuthorizedEmailAddress: string;
  AuthorizedAddress1?: string;
  AuthorizedAddress2?: string;
  AuthorizedCity?: string;
  AuthorizedProvince?: string;
  AuthorizedCountry?: string;
  AuthorizedPostalCode?: string;
};

export type AddSignerResponse = ApiResponse & {
  Message: string;
  SigningAuthorityID: string;
};

export enum TransactionStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in progress',
  REQUESTED = 'requested',
  SENT = 'sent',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  CANCELLATION_REQUESTED = 'cancellation requested',
  SETTLED = 'settled',
  WAITING = 'waiting',
  DECLINED = 'declined',
  COMPLETE = 'complete',
  RECEIVED = 'received',
  PENDING_APPROVAL = 'pending approval',
  PENDING_CONFIRMATION = 'pending confirmation',
  BLOCKED_BY_FINANCIAL_INSTITUTION = 'blocked by financial institution',
  BLANK = '',
}

export enum TransactionType {
  ACH_FUNDING = 'ACH Funding',
  ACH_WITHDRAWAL = 'ACH Withdrawal',
  CROSSBORDER_WITHDRAWAL = 'Crossborder Withdrawal',
  EFT_FUNDING = 'EFT Funding',
  EFT_WITHDRAWAL = 'EFT Withdrawal',
  VOPAYINSTANT_WITHDRAWAL = 'VoPayInstant Withdraw',
  FEE = 'Fee',
  ACCOUNT_TRANSFER = 'Account Transfer',
  REVERSAL = 'Reversal',
  SECURITY_DEPOSIT = 'Security Deposit',
  INTERACT_MONEY_REQUEST = 'Interac Money Request',
  OTHER_FUNDING = 'Other Funding',
  OTHER_WITHDRAWAL = 'Other Withdrawal',
  CURRENCY_CONVERSION = 'Currency Conversion',
  INTERACT_BULK_PAYOUT = 'Interac Bulk Payout',
  REVERSAL_INTERAC = 'Reversal Interac',
  REVERSAL_MONEY_REQUEST = 'Reversal Money Request',
  INTERNATIONAL_FUNDING = 'International Funding',
  INTERNATIONAL_WITHDRAWAL = 'International Withdrawal',
  VISA_DIRECT_PUSH = 'Visa Direct Push',
  INBOUND_E_TRANSFER = 'Inbound e-Transfer',
  CREDIT_CARD = 'Credit Card',
  PAYLINK = 'PayLink',
  REFUND = 'Refund',
  RTR_WITHDRAWAL = 'RTR Withdrawal',
  RTP_WITHDRAWAL = 'RTP Withdrawal',
  FEDWIRE_WITHDRAWAL = 'Fedwire Withdrawal',
  FEDWIRE_FUNDING = 'Fedwire Funding',
  BANK_ACCOUNT = 'Bank Account',
  GOOGLE_PAY = 'Google Pay',
  PAYPAL_WITHDRAWAL = 'PayPal Withdrawal',
  VENMO_WITHDRAWAL = 'Venmo Withdrawal',
  BILL_PAY = 'Bill Pay',
  ELINX = 'eLinx',
  AUTO_BALANCE_TRANSFER = 'Auto Balance Transfer',
  VIRTUAL_ACCOUNT_DEPOSIT = 'Virtual Account Deposit',
  VIRTUAL_ACCOUNT_FUNDING = 'Virtual Account Funding',
  VIRTUAL_ACCOUNT_WITHDRAW = 'Virtual Account Withdraw',
  VIRTUAL_ACCOUNT_WIRE = 'Virtual Account Wire',
}

export enum ScheduleType {
  RECURRING = 'recurring',
  ONE_TIME = 'One Time',
}
export type Branding = {
  PrimaryColor: string;
  SecondaryColor: string;
  TextColor: string;
  ButtonTextColor: string;
  DateAdded: string | null;
  LastModified: string | null;
};
export type BrandingDetails = {
  Branding?: Branding;
  Logo?: string;
};

export type TokenInfoApiResponse = ApiResponse & {
  AccountSelectionMethod: string;
  AccountHolderType: 'individual' | 'business' | '';
  BGColor: string;
  ClientName: string;
  ConsentMessage: string;
  Country: string;
  Currency: SupportedCurrencies;
  FlinksInstitutionID: number;
  ForegroundColor: string;
  Language: string;
  PaymentSelectionMethod: string;
  RedirectMethod: string;
  RedirectURL: string;
  TermsAndConditions: string;
  HasLogin: boolean;
  Version: string;
  WithTransactions: boolean;
  DebitAuthority: string;
  RequireDebitAuthorityAgreement: boolean;
  BrandingDetails: BrandingDetails;
  DarkMode: boolean;
  Trigger3DS: boolean;
  CardTypeValidation: boolean;
  AcceptedCardBrands: string;
  JWT: string;
  PageTitle?: string | null;
  Favicon?: string | null;
  AgreementURL: string;
  DebitAgreementBusinessEnUrl: string;
  DebitAgreementBusinessFrUrl: string;
  DebitAgreementIndividualEnUrl: string;
  DebitAgreementIndividualFrUrl: string;
  PrivacyPolicyEnURL: string;
  PrivacyPolicyFrURL: string;
  TermsOfServiceEnURL: string;
  TermsOfServiceFrURL: string;
};

export type TokenInfoResponse = ApiResponse & {
  AccountSelectionMethod: string;
  AccountHolderType: 'individual' | 'business' | '';
  BGColor: string;
  ClientName: string;
  ConsentMessage: string;
  Country: string;
  Currency: SupportedCurrencies;
  FlinksInstitutionID: number;
  ForegroundColor: string;
  Language: string;
  PaymentSelectionMethod: string;
  RedirectMethod: string;
  RedirectURL: string;
  TermsAndConditions: string;
  HasLogin: boolean;
  Version: string;
  WithTransactions: boolean;
  DebitAuthority: string;
  RequireDebitAuthorityAgreement: boolean;
  BrandingDetails: BrandingDetails;
  DarkMode: boolean;
  Trigger3DS: boolean;
  CardTypeValidation: boolean;
  AcceptedCardBrands: AcceptedCardBrand[];
  JWT: string;
  PageTitle?: string | null;
  Favicon?: string | null;
  AgreementURL: string;
  DebitAgreementBusinessEnUrl: string;
  DebitAgreementBusinessFrUrl: string;
  DebitAgreementIndividualEnUrl: string;
  DebitAgreementIndividualFrUrl: string;
  PrivacyPolicyEnURL: string;
  PrivacyPolicyFrURL: string;
  TermsOfServiceEnURL: string;
  TermsOfServiceFrURL: string;
};

export type FinancialInstitutionsRequest = {
  Country?: string;
  Search?: string;
  Version?: string;
};
export type FinancialInstitutionsResponse = ApiResponse & {
  FinancialInstitutions: { [key: string]: FinancialInstitution };
};
export type FinancialInstitutionInfo = {
  FinancialInstitutionID: string;
  FinancialInstitutionNumber: string;
  FIName: string;
  FINameFrench: string;
  ColorCode: string;
  VIOFinancialInstitutionsFiserv_ID: string;
  Country: string;
  ExternalFIID: string;
  OnlineConnectionEnabled: string;
  AssociatedFINames: string;
  AssociatedFINamesFrench: string;
  AssociatedExternalFIIDs: string;
  HasMoreThanOne: boolean;
};
export type FinancialInstitution = {
  FinancialInstitutionID: string;
  FinancialInstitutionNumber: string;
  FIName: string;
  FINameFrench: string;
  ColorCode: string;
  VIOFinancialInstitutionsFiserv_ID: string;
  Country: string;
  ExternalFIID: string;
  OnlineConnectionEnabled: string;
  AssociatedFINames: string;
  AssociatedFINamesFrench: string;
  AssociatedExternalFIIDs: string;
};
export type FinancialInstitutionBranchesRequest = {
  FinancialInstitutionID: number;
};
export type FinancialInstitutionBranch = {
  Address: string;
  BranchTransitNumber: number;
  FinancialInstitutionNumber: number;
  ID: number;
  PostalCode: string;
  Province: string;
  TownCity: string;
};

export type FinancialInstitutionBranchesApiResponse = ApiResponse & {
  Branches: {
    [key: string]: FinancialInstitutionBranch;
  };
  FinancialInstitutions?: {
    [key: string]: number;
  };
};
export type FinancialInstitutionBranchesResponse = ApiResponse & {
  Branches: FinancialInstitutionBranch[];
  FinancialInstitutions?: number[];
};

export type IFrameEventRequest = {
  EventData: string;
};

export type IQ11CompleteRequest = {
  institution: string;
  loginId: string;
  accountId: string;
  FullName: string;
  requestId?: string;
  IdentificationNumber?: string;
  PhoneNumber?: string;
  SessionToken?: string;
};
export type IQ11TokenResponse = ApiResponse & {
  Token: string;
};
export type SubmitPartnerSupportTicketResponse = ApiResponse & {
  Response?: {
    [key: string]: {
      [key: string]: string;
    };
  };
};
export type ELinxSingleUseTokenRequest = {
  Token: string;
  ApplicationType: 'paylink' | 'verification';
};

export type PaymentMethodDisplayOptions = 'Existing' | 'New' | 'Both';

type ELinxDetailsApi = {
  FirstName: string;
  LastName: string;
  ReceiverName: string;
  SenderEmailAddress: string;
  ReceiverEmailAddress: string;
  InvoiceNumber: string;
  Note: string;
  SenderName: string;
  Amount: string;
  Currency: string;
  Status: string;
  FailureReason: string;
  Link: string;
  IframeURL: string;
  IframeKey: string;
  TransactionID: string;
  ScheduledTransactionID: string;
  EFTType: string;
  PaymentType: string;
  TransactionDate: string;
  Frequency: 'single' | 'recurring' | ''; // TODO: consider taking '' out
  NameOfFrequency: string;
  SemiMonthlyFrequencyType: string;
  ScheduleEndDate: string;
  EndingAfterPayments: string;
  Type: 'transaction' | 'scheduled' | 'beneficiary' | ''; // TODO: consider taking '' out
  CanDecline: string;
  ScheduleStartDate: string;
  ExpireDate: number;
  LastModified: string;
  BankAccountLinked: boolean;
  BankAccountToken?: string;
  RecipientMessage: string;
  InteracEmbedUrl?: string;
  InteracTransactionID?: string;
  RemainderPaymentDate?: string;
  FlexiblePaymentOptions?: string;
  MinimumPaymentAccepted?: string;
  ReceiverPhoneNumber: string;
  PaymentMethodDisplayOptions: PaymentMethodDisplayOptions;
  ClientAccountID?: string;
  DisplayEmbbedInterac: boolean;
  BankAccountRail: string;
  DocumentLink: string;
};
export type ELinxDetails = Omit<ELinxDetailsApi, 'BankAccountRail'> & {
  BankAccountRail: BankingPaymentRail[];
};

export type VerificationDetails = {
  VerificationRequestID: string;
  Amount: string;
  SenderEmailAddress: string;
  ReceiverEmailAddress: string;
  Link: string;
  VerificationStatus: string;
  VerificationAttempts: string;
  VerificationStartDate: string;
  VerificationAttemptDate: string;
  ExpireDate: string;
};

export type ELinxSingleUseTokenApiResponse = ApiResponse & {
  JWT: string;
  Token: string;
  IsValidToken: boolean;
  ExtraInfo: {
    PayLinkDetails: ELinxDetailsApi;
    VerificationDetails?: VerificationDetails;
  };
  Name: string;
  LegalBusinessName: string;
  BusinessAddress: {
    Address1: string;
    Address2: string;
    City: string;
    Province: string;
    Country: string;
  };
  IsPartnerToken: boolean;
  AccountStatus: string;
  PartnerAccountType: string;
  SubAccountType: string;
  PageTitle?: string | null;
  Favicon?: string | null;
};
export type ELinxSingleUseTokenResponse = Omit<ELinxSingleUseTokenApiResponse, 'ExtraInfo'> & {
  ExtraInfo: {
    PayLinkDetails: ELinxDetails;
    VerificationDetails?: VerificationDetails;
  };
};

export type LinkBankAccountManuallyRequest = {
  FinancialInstitutionID?: number;
  BranchTransitNumber?: number;
  FinancialInstitutionNumber?: string;
  AccountNumber?: number;
  RoutingNumber?: number;
  FirstName: string;
  LastName: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  City?: string;
  Province?: string;
  CompanyName?: string;
  Address?: string;
  PostalCode?: string;
  Currency?: string;
  Country: string;
  IdentificationNumber?: string;
};

export type BankAccountConnectionRequest = {
  FinancialInstitutionID: number;
  SessionGUID?: string;
  UserToken?: string;
  Username: string;
  Password: string;
  SecurityType?: string;
  Answer?: string;
};
export type BankAccountConnectionResponse = ApiResponse & {
  BankAccounts?: { [key: string]: BankAccountConnection };
  Question?: string;
  Prompt?: string;
  SecurityType?: string;
  UserToken?: string;
};
export type BankAccountConnection = {
  AccountNumber: number;
  AccountType: string;
  BankAccountID: number;
  Currency: string;
  CurrentBalance: number;
};
export type LinkBankAccountRequest = {
  BankAccountID: number;
  SessionGUID?: string;
  UserToken: string;
};

export type GlobalPayTokenRequest = {
  reference: string;
  card: {
    cvv: string;
    expiry_month: string;
    expiry_year: string;
    number: string;
  };
  usage_mode: string;
};
export type GlobalPayTokenResponse = ApiResponse & {
  detailed_error_code?: number;
  detailed_error_description?: string;
  error_code?: string;
  id: string;
  time_created: string;
  status: string;
  usage_mode: string;
  merchant_id: string;
  merchant_name: string;
  account_id: string;
  account_name: string;
  reference: string;
  card: {
    masked_number_last4: string;
    brand: string;
    expiry_month: string;
    expiry_year: string;
  };
  action: {
    id: string;
    type: string;
    time_created: string;
    result_code: string;
    app_id: string;
    app_name: string;
  };
};
export type TokenInfoRequest = {
  ForOnboarding: boolean;
};

export type LinkCreditCardRequest = TokenInfoRequest & {
  PaymentToken: string;
  CardHolderName: string;
  MaskedCardNumber: string;
  CardBrand: string | null;
  ExpiryYear: string;
  ExpiryMonth: string;
  Email?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  Province?: string;
  PostalCode?: string;
  Country?: string;
};

export type ClientLogin = {
  Username?: string;
  Password?: string;
  JWToken?: string;
  RememberMe?: boolean;
};

export type PartnerLogin = {
  username?: string;
  password?: string;
};

export type ApiClientPermissions = {
  ViewSubaccounts?: boolean;
  AddSubaccounts?: boolean;
  CreatePayments?: boolean;
  CreateCollections?: boolean;
  ViewBeneficiaries?: boolean;
  AddBeneficiaries?: boolean;
  ViewBulkFileUpload?: boolean;
  CreateBulkFileUpload?: boolean;
  ViewScheduledTransactions?: boolean;
  ViewTransactionHistory?: boolean;
  ViewSettings?: boolean;
  AddSettings?: boolean;
  ViewUsers?: boolean;
  AddUsers?: boolean;

  ManageUserPermissions?: boolean;
  CreateAccountTransfer?: boolean;
  ViewClientAccounts?: boolean;
  AddClientAccounts?: boolean;
  CreateClientAccountTransfers?: boolean;
  CreateConversions?: boolean;
  ManageDefaultPayments?: boolean;
  CreateSupportTickets?: boolean;
  ViewSupportTickets?: boolean;
  ViewReconciliation?: boolean;
  ViewAccountingBillsAndInvoices?: boolean;
  ProcessAccountingBillsAndInvoices?: boolean;
  TransactionLabelOverrideEnabled?: boolean;
  TransactionCancellation?: boolean;
  ViewTransactionApprovalWorkflow?: boolean;
  CreateTransactionApprovalWorkflow?: boolean;
  ApproveTransactions?: boolean;
  ViewTransactionReport?: boolean;
  CreateTransactionReport?: boolean;
  ManageTransactionGroups?: boolean;
  ManageEmailDomains?: boolean;
  ManageInterestAccounts?: boolean;
  ViewInterestAccounts?: boolean;
  ViewElinxSettings?: boolean;
  ManageElinxSettings?: boolean;
  CreateBills?: boolean;
  CreateInvoices?: boolean;
  ViewBankAccountTransactionHistory?: boolean;
  ManageDisputes?: boolean;
  ManageBlockedAccounts?: boolean;
  ViewAccountSummary?: boolean;
  ViewAccountandBilling?: boolean;
  ManageAccountandBilling?: boolean;
  CreateFundMyAccountTransactions?: boolean;
  CreateWithdrawMyAccountTransactions?: boolean;
  CreateBankAccountTransfer?: boolean;
  ViewOperationalAccounts?: boolean;
  CreateAutoBalanceTransfer?: boolean;
  CreateElinxConnect?: boolean;
  CreateElinxPay?: boolean;
  CreateElinxCollect?: boolean;
  CreateElinxFlex?: boolean;
  ViewClientAccountNotes?: boolean;
  CreateClientAccountNotes?: boolean;
  ViewLearningCentre?: boolean;
  ViewUserRoles?: boolean;
  ManageUserRoles?: boolean;
};

export type PushToCardProcessor = 'crossriver' | 'nuvei' | 'mastercard' | 'globalpay' | 'worldpay';
export type CreditCardProcessor = 'globalpay' | 'nuvei' | 'worldpay';
export type ACHFundingProcessor = 'fiserv' | 'goldmansachs' | 'crossriver' | 'nuvei' | 'worldpay';
export type ACHWithdrawProcessor = 'fiserv' | 'goldmansachs' | 'crossriver' | 'nuvei' | 'bmo' | 'worldpay';
export type InteracMoneyRequestProcessor = 'dc_bank' | 'peoples_trust_bank' | 'bmo' | 'scotia_bank';
export type InteracBulkPayoutProcessor = 'bmo' | 'peoples_trust_bank' | 'dc_bank' | 'scotia_bank';
export type FedwireProcessor = 'goldmansachs';
export type RTPProcessor = 'nuvei' | 'crossriver' | 'goldmansachs';
export type FednowProcessor = 'crossriver';
export type ClientPortalAccountType =
  | 'Standard'
  | 'Treasury Management'
  | 'Interest'
  | 'Technology'
  | 'Secured Account';

export type ClientAuthorizationBaseResponse = ApiResponse & {
  Success: boolean;
  AccountID: string;
  AccountName: string;
  Key: string;
  Signature: string;
  JWT: string;
  FirebaseToken: string;
  Country: string;
  TransactionApprovalWorkflowEnabled: string;
  GCMEnabled: string;
  EFTCollectEnabled: string;
  EFTSendEnabled: string;
  ACHFundEnabled: string;
  ACHWithdrawEnabled: string;
  USDEFTCollectEnabled: string;
  USDEFTSendEnabled: string;
  RTRWithdrawEnabled: string;
  FedwireWithdrawEnabled: string;
  FedwireFundEnabled: string;

  InteracMoneyRequestEnabled: string;
  InboundEtransferEnabled: string;
  InteracBulkPayoutEnabled: string;
  PortalViewOnly: string;
  MoneyRequestGenerateUrlEnabled: string;
  KYCLightEnabled: string;
  SubAccountPermissions: string;
  ClientAccountsEnabled: string;
  AutoBalanceTransferEnabled: string;
  TransactionLabelOverrideEnabled: string;
  IQ11StandardEnabled: string;
  IQ11BoostEnabled: string;
  IQ11PlusEnabled: string;
  IQ11AdvantageEnabled: string;
  TransactionServiceDefault: string;
  PayLinkEnabled: string;
  CustomFlinksCredentialsSet: boolean;
  CustomPlaidCredentialsSet: boolean;
  CustomInveriteCredentialsSet: boolean;
  EnablePaylinkDecline: string;
  CreditCardEnabled: string;
  GooglePayEnabled: PseudoBool;
  UserManagementEnabled: string;
  AccountingSystemIntegrationEnabled: string;
  AccountingSoftwareIntegrationEnabled: string;
  AccountTransferEnabled: string;
  RealTimeMoneyRequestEnabled: string;
  CustomGlobalPaySharedSecret: boolean;
  PushToCardEnabled: string;
  BrandingEmailEnabled: string;
  BrandingELinxEnabled: string;
  BrandingPortalEnabled: string;
  BrandingOnboardingEnabled: string;
  EmailDomainEnabled: PseudoBool;
  ChatSupportEnabled: PseudoBool;
  InteracBasicVerificationEnabled: PseudoBool;
  InteracEnhancedVerificationEnabled: PseudoBool;
  MicroDepositBankAccountVerificationEnabled: PseudoBool;
  CardBasicVerificationEnabled: PseudoBool;
  CardEnhancedVerificationEnabled: PseudoBool;
  RTPWithdrawEnabled: string;
  AccountType: ClientPortalAccountType;
  Domain: string;
  MFAEnabled: boolean;
  PasswordResetRequired: boolean;
  ParentAccountID?: string;
  ParentAccountName?: string;
  SubAccountType?: string;
  UserPermissions: ApiClientPermissions;
  AdditionalAccounts: { [key: string]: string };
  InterestAccountEnabled: PseudoBool;
  InteracVerificationEnabled: PseudoBool;
  SupportTicketEnabled: PseudoBool;
  DigitalWalletsEnabled: PseudoBool;
  FileConversionEnabled: PseudoBool;
  FileSubmissionEnabled: PseudoBool;
  BillPayEnabled: PseudoBool;
  VirtualAccountsEnabled: PseudoBool;
  AccountSummaryEnabled: PseudoBool;
  AccountAndBillingEnabled: PseudoBool;
  FundMyAccountEnabled: PseudoBool;
  WithdrawMyAccountEnabled: PseudoBool;
  BankAccountTransferEnabled: PseudoBool;
  OperationalAccountsEnabled: PseudoBool;
  PartnerBillsAccount: PseudoBool;
  PaymentsEnabled: PseudoBool;
  CollectionsEnabled: PseudoBool;
  ShowSubAccountOrgChart: PseudoBool;
  PushToCardProcessor: PushToCardProcessor | '';
  CreditCardProcessor: CreditCardProcessor | '';
  ACHFundingProcessor: ACHFundingProcessor | '';
  ACHWithdrawProcessor: ACHWithdrawProcessor | '';
  InteracMoneyRequestProcessor: InteracMoneyRequestProcessor | '';
  InteracBulkPayoutProcessor: InteracBulkPayoutProcessor | '';
  FedwireProcessor: FedwireProcessor | '';
  RTPProcessor: RTPProcessor | '';
  FednowProcessor: FednowProcessor | '';
  PaypalWithdrawEnabled: PseudoBool;
  VenmoWithdrawEnabled: PseudoBool;
  AFTEnabled: PseudoBool;
  CPortalEnabled: PseudoBool;
};
export type ClientAuthorizationResponse = Omit<
  ClientAuthorizationBaseResponse,
  | 'ChatSupportEnabled'
  | 'BankAccountVerificationEnabled'
  | 'InteracVerificationEnabled'
  | 'SupportTicketEnabled'
  | 'DigitalWalletsEnabled'
  | 'PaypalWithdrawEnabled'
  | 'VenmoWithdrawEnabled'
  | 'GooglePayEnabled'
  | 'MicroDepositBankAccountVerificationEnabled'
  | 'CardBasicVerificationEnabled'
  | 'CardEnhancedVerificationEnabled'
  | 'FileConversionEnabled'
  | 'FileSubmissionEnabled'
  | 'BillPayEnabled'
  | 'VirtualAccountsEnabled'
  | 'AccountAndBillingEnabled'
  | 'FundMyAccountEnabled'
  | 'WithdrawMyAccountEnabled'
  | 'BankAccountTransferEnabled'
  | 'OperationalAccountsEnabled'
  | 'PartnerBillsAccount'
  | 'PaymentsEnabled'
  | 'CollectionsEnabled'
  | 'ShowSubAccountOrgChart'
  | 'AFTEnabled'
  | 'AccountSummaryEnabled'
  | 'CPortalEnabled'
> & {
  ChatSupportEnabled: boolean;
  InteracVerificationEnabled: boolean;
  SupportTicketEnabled: boolean;
  DigitalWalletsEnabled: boolean;
  PaypalWithdrawEnabled: boolean;
  VenmoWithdrawEnabled: boolean;
  GooglePayEnabled: boolean;
  MicroDepositBankAccountVerificationEnabled: boolean;
  CardBasicVerificationEnabled: boolean;
  CardEnhancedVerificationEnabled: boolean;
  FileConversionEnabled: boolean;
  FileSubmissionEnabled: boolean;
  BillPayEnabled: boolean;
  VirtualAccountsEnabled: boolean;
  AccountAndBillingEnabled: boolean;
  FundMyAccountEnabled: boolean;
  WithdrawMyAccountEnabled: boolean;
  BankAccountTransferEnabled: boolean;
  OperationalAccountsEnabled: boolean;
  PartnerBillsAccount: boolean;
  PaymentsEnabled: boolean;
  CollectionsEnabled: boolean;
  ShowSubAccountOrgChart: boolean;
  AFTEnabled: boolean;
  AccountSummaryEnabled: boolean;
  CPortalEnabled: boolean;
};

export type ClientResetPasswordEmailRequest = {
  Username: string;
};

export type GeoLocationResponse = {
  ip: string;
  city: string;
  region: string;
  country: string;
  loc: string;
  org: string;
  postal: string;
  timezone: string;
};

export type ClientResetPasswordEmailResponse = ApiResponse;

export type VerifyRecaptchaRequest = {
  response: string;
};

export type VerifyRecaptchaResponse = ApiResponse;

export type AccountBalanceRequest = {
  PortalUser?: string;
  Currency: string;
};

export type AccountBalanceResponse = ApiResponse & {
  AccountBalance: string;
  AvailableFunds: string;
  AvailableImmediately: string;
  Currency: SupportedCurrencies;
  PendingFunds: string;
  Reserve: string;
  RollingReserveNSF: string;
  RollingReserveReturns: string;
  RollupAvailableBalance?: string;
  RollupAccountBalance?: string;
};

export type TransactionHistoryStatus =
  | 'All'
  | 'requested'
  | 'pending'
  | 'in progress'
  | 'sent'
  | 'successful'
  | 'complete'
  | 'settled'
  | 'failed'
  | 'cancellation requested'
  | 'waiting'
  | 'cancelled'
  | 'pending approval'
  | null;

export type TransactionsHistoryRequest = {
  StartDateTime: string;
  EndDateTime: string;
  PortalUser?: string;
  ClientAccountID?: string;
  Currency?: string;
  TransactionType?: string;
  TransactionID?: string;
  ClientReferenceNumber?: string;
  ScheduledTransactionID?: string;
  IsFlagged?: boolean;
  IsRefunded?: boolean;
  ExportCSV?: boolean;
  ExportPDF?: boolean;
  IncludeSubaccountTransactions?: boolean;
  Timezone?: string;
  TransactionStatus?: TransactionHistoryStatus;
  Limit?: number;
  Offset?: number;
  SearchText?: string;
  ExportParams?: {
    IncludeSubAccounts: boolean;
    SubAccountLimit?: number;
  };
};

export type SubAccountTransactionsHistoryRequest = TransactionsHistoryRequest & {
  SubAccountID?: string;
};

export type TransactionsList = {
  PortalUser: string;
  StartDateTime: string;
  EndDateTime: string;
  Currency: string;
};

export type TransactionsLists = {
  AccountName: string;
  AccountID: string;
  ChildTransactionIDs: string[];
  ClientAccountID: string;
  ClientReferenceNumber: string;
  CreditAmount: string;
  Currency: string;
  DebitAmount: string;
  FullName: string;
  HoldAmount: string;
  IsRefunded: boolean;
  IsRefund: boolean;
  LastModified: string;
  Notes: string;
  ParentTransactionID: string;
  ELinxRequestID: string;
  ScheduledTransactionID: string;
  TransactionDateTime: string;
  TransactionErrorCode: string;
  TransactionFailureReason: string;
  TransactionFlag: string;
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionTypesOptions;
  TransactionTypeCode: string;
  SettlementDate: string;
  ConvenienceFeeAmount: string;
  PaymentRailID: string;
  GLCode: string;
  WalletName1: string;
  WalletName2: string;
};

export type PaginationMetaData = {
  Limit: number;
  Offset: number;
  TotalRecords: number;
};

export type TransactionsHistoryResponse = ApiResponse & {
  PDFFile?: string;
  CSVFile?: string;
  NumberOfRecords: number;
  Transactions: TransactionsLists[];
  PaginationMetaData: PaginationMetaData;
};

export type TransactionsListsApi = {
  AccountID: string;
  AccountName: string;
  ChildTransactionIDs: { [idx: number]: string };
  ClientAccountID: string;
  ClientReferenceNumber: string;
  CreditAmount: string;
  Currency: string;
  DebitAmount: string;
  FullName: string;
  HoldAmount: string;
  IsRefunded: PseudoBool;
  IsRefund: PseudoBool;
  LastModified: string;
  Notes: string;
  ParentTransactionID: string;
  ELinxRequestID: string;
  ScheduledTransactionID: string;
  TransactionDateTime: string;
  TransactionErrorCode: string;
  TransactionFailureReason: string;
  TransactionFlag: string;
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionTypesOptions;
  SettlementDate: string;
  ConvenienceFeeAmount: string;
  PaymentRailID: string;
  GLCode: string;
  TransactionTypeCode: string;
  WalletName1: string;
  WalletName2: string;
};

export type TransactionsHistoryApiResponse = ApiResponse & {
  PDFFile?: string;
  CSVFile?: string;
  NumberOfRecords: number;
  Transactions: { [idx: string]: TransactionsListsApi };
  PaginationMetaData: PaginationMetaData;
};

export type SubAccountTransactionsHistoryResponse = TransactionsHistoryResponse;

export type ClientBankAccountsRequest = TimezoneRequest & {
  PortalUser?: string;
  ClientControlled?: boolean;
  MasterAccountOnly?: boolean;
  Token?: string;
  ClientAccountID?: string;
  Limit?: number;
  IntegrationType?: string;
  Currency?: string;
  SearchText?: string;
};

export type ClientBankAccountsLists = {
  ABARoutingNumber: string;
  AccountHolderName: string;
  AccountNumber: string;
  Address: string;
  BankID: string;
  BranchTransitNumber: string;
  City: string;
  ClientAccountID: string;
  ClientControlledBankAccount: string;
  ClientReferenceNumber: string;
  Currency: string;
  DateAdded: string;
  EmailAddress: string;
  FinancialInstitutionNumber: string;
  FiservToken: string;
  FlinksAccountID: string;
  FlinksLoginID: string;
  InstitutionName: string;
  IntegrationType: string;
  InveriteRequestGUID: string;
  IsDefault: string;
  MxAuthorizationCode: string;
  MxProcessorToken: string;
  Phone: string;
  PlaidAccountID: string;
  PlaidProcessorToken: string;
  'PostalCode/ZipCode': string;
  'Province/State': string;
  Token: string;
  Purpose?: string;
  ConnectionType?: string;
  Verified?: string;
};

export type ClientBankAccountsResponse = ApiResponse & {
  BankAccounts: { [idx: number]: ClientBankAccountsLists };
  PaginationMetaData?: PaginationMetaData;
};

export type ClientCreditCardsRequest = {
  PortalUser?: string;
  ClientControlled?: boolean;
  CreditCardToken?: string;
  ClientAccountID?: string;
};

export type ClientCreditCardLists = {
  ClientAccountID: string;
  CreditCardBrand: CardBrand;
  CreditCardExpiryMonth: string;
  CreditCardExpiryYear: string;
  CreditCardHolderName: string;
  CreditCardNumber: string;
  CreditCardToken: string;
  IsDefault: string;
};

export type ClientCreditCardsResponse = ApiResponse & {
  CreditCards: { [idx: number]: ClientCreditCardLists };
};

export type ClientDebitCardsResponse = ApiResponse & {
  DebitCards: { [idx: number]: ClientDebitCardLists };
};

export type ClientDebitCardsRequest = {
  PortalUser?: string;
  ClientControlled?: boolean;
  DebitCardToken?: string;
  ClientAccountID?: string;
};

export type ClientDebitCardLists = {
  ClientAccountID: string;
  DebitCardBrand: string;
  DebitCardExpiryMonth: string;
  DebitCardExpiryYear: string;
  DebitCardHolderName: string;
  DebitCardNumber: string;
  DebitCardToken: string;
  IsDefault: string;
};

export type ClientTransactionsRequest = {
  PortalUser: string;
  Token: string;
};

export type ClientTransactionsApiResponse = ApiResponse & {
  LastRetrievedTime: string;
  AggregatorTransactions: string | Record<string, PaasTransactionBase>;
};

export type ClientTransactionsResponse = ApiResponse & {
  LastRetrievedTime: string;
  AggregatorTransactions: PaasTransaction[];
};

export type ClientBalanceRequest = {
  PortalUser: string;
  Token: string;
};

export type ClientBalanceResponse = ApiResponse & {
  AccountBalance: string;
  BalanceAsAtDate: string;
};

export type AccountPermissionsRequest = {
  PortalUser: string;
  EmailAddress: string;
};

export type PermissionsApiResponse = {
  [idx: string]: keyof ApiClientPermissions;
};

export type AccountPermissionsResponse = ApiResponse & {
  Username: string;
  Permissions: PermissionsApiResponse;
};

export type AutoBalanceTransferRequest = {
  PortalUser: string;
};

export type AutoBalanceTransferResponse = ApiResponse & {
  ABARoutingNumber: string;
  AccountHolderName: string;
  AccountNumber: string;
  AutoBalanceTransferAmount: string;
  BranchTransitNumber: string;
  Currency: string;
  Description: string;
  FinancialInstitutionNumber: string;
  NameOfFrequency: string;
  ScheduleStartDate: string;
  Status: string;
};

export type SubAccountsRequest = {
  PortalUser?: string;
  ShowToken?: boolean;
  SearchText?: string;
  Currency?: string;
  Country?: string;
  ActiveOnly?: boolean;
  Limit?: number;
  Offset?: number;
  SubaccountID?: string;
};

export type SubAccountParentInfo = {
  AccountID: string;
  AccountName: string;
  ID: string;
  ParentAccountID: string | null;
};

export type SubAccountsLists = {
  ACHFundEnabled: boolean;
  ACHWithdrawEnabled: boolean;
  AccountID: string;
  AccountName: string;
  AccountStatus: string;
  AccountingSoftwareIntegrationEnabled: boolean;
  AddUserEnabled: boolean;
  Address: string;
  Address2: string;
  AutoBalanceTransferEnabled: boolean;
  Balances: {
    [key: number]: {
      AccountBalance: string;
      AvailableBalance: string;
      AvailableImmediately: string;
      Currency: string;
      PendingBalance: string;
      Reserve: string;
      RollupAvailableBalance?: string;
      RollupAccountBalance?: string;
    };
  };
  City: string;
  ClientAccountsEnabled: boolean;
  Country: string;
  DailyLimitAmount: string;
  EFTCollectEnabled: boolean;
  EFTSendEnabled: boolean;
  Email: string;
  Fax: string;
  FlinksUrl: string;
  GCMEnabled: boolean;
  IQ11AdvantageEnabled: boolean;
  IQ11BoostEnabled: boolean;
  IQ11PlusEnabled: boolean;
  IQ11StandardEnabled: boolean;
  InboundEtransferEnabled: boolean;
  InteracBulkPayoutEnabled: boolean;
  InteracMoneyRequestEnabled: boolean;
  IsActive: boolean;
  IsBusinessCaseSet: boolean;
  LegalBusinessName: string;
  MaxFundEFTAmount: string;
  MaxGCMAmount: string;
  MaxInteracBulkPayoutAmount: string;
  MaxInteracMoneyAmount: string;
  MaxRTRWithdrawAmount: string;
  MaxVisaDirectAmount: string;
  MaxWithdrawEFTAmount: string;
  MonthlyLimitAmount: string;
  MonthlyTransactionLimit: string;
  OriginatorName: string;
  OriginatorShortName: string;
  PayLinkEnabled: boolean;
  Phone: string;
  PortalViewOnly: boolean;
  PostalCode: string;
  Province: string;
  RTRWithdrawEnabled: boolean;
  ParentAccountName: string;
  ParentAccountID: string;
  SigningAuthorities: {
    [key: number]: {
      DOB: string;
      DateAdded: string;
      EmailAddress: string;
      FullName: string;
      HomeAddress: string;
      ID: string;
      Occupation: string;
    };
  };
  SubAccountType: string;
  Token: string;
  TransactionServiceDefault: string;
  USDEFTCollectEnabled: boolean;
  USDEFTSendEnabled: boolean;
  VisaDirectEnabled: boolean;
  WebhookUrl: string;
  WeeklyLimitAmount: string;
  KYCLightEnabled: boolean;
  AFTEnabled: boolean;
  ParentAccounts: SubAccountParentInfo[];
  SubAccounts: SubAccountsLists[];
};

export type SubAccountsListsShow = {
  ACHFundEnabled: boolean;
  ACHWithdrawEnabled: boolean;
  AccountID: string;
  AccountName: string;
  AccountStatus: string;
  AccountingSoftwareIntegrationEnabled: boolean;
  AddUserEnabled: boolean;
  Address: string;
  Address2: string;
  AutoBalanceTransferEnabled: boolean;
  AccountBalance: string;
  AvailableBalance: string;
  AvailableImmediately: string;
  Currency: string;
  RollupAvailableBalance?: string;
  RollupAccountBalance?: string;
  PendingBalance: string;
  Reserve: string;
  City: string;
  ClientAccountsEnabled: boolean;
  Country: string;
  DailyLimitAmount: string;
  EFTCollectEnabled: boolean;
  EFTSendEnabled: boolean;
  AFTEnabled: boolean;
  Email: string;
  Fax: string;
  FlinksUrl: string;
  GCMEnabled: boolean;
  IQ11AdvantageEnabled: boolean;
  IQ11BoostEnabled: boolean;
  IQ11PlusEnabled: boolean;
  IQ11StandardEnabled: boolean;
  InboundEtransferEnabled: boolean;
  InteracBulkPayoutEnabled: boolean;
  InteracMoneyRequestEnabled: boolean;
  IsActive: boolean;
  IsBusinessCaseSet: boolean;
  LegalBusinessName: string;
  MaxFundEFTAmount: string;
  MaxGCMAmount: string;
  MaxInteracBulkPayoutAmount: string;
  MaxInteracMoneyAmount: string;
  MaxRTRWithdrawAmount: string;
  MaxVisaDirectAmount: string;
  MaxWithdrawEFTAmount: string;
  MonthlyLimitAmount: string;
  MonthlyTransactionLimit: string;
  OriginatorName: string;
  OriginatorShortName: string;
  PayLinkEnabled: boolean;
  Phone: string;
  PortalViewOnly: boolean;
  PostalCode: string;
  Province: string;
  RTRWithdrawEnabled: boolean;
  ParentAccountName: string;
  ParentAccountID: string;
  SigningAuthorities: {
    [key: number]: {
      DOB: string;
      DateAdded: string;
      EmailAddress: string;
      FullName: string;
      HomeAddress: string;
      ID: string;
      Occupation: string;
    };
  };
  SubAccountType: string;
  Token: string;
  TransactionServiceDefault: string;
  USDEFTCollectEnabled: boolean;
  USDEFTSendEnabled: boolean;
  WebhookUrl: string;
  WeeklyLimitAmount: string;
  KYCLightEnabled: boolean;
  ParentAccounts: SubAccountParentInfo[];
};

export type SubAccountsListsApi = Omit<SubAccountsLists, 'ParentAccounts' | 'SubAccounts'> & {
  ParentAccounts: { [key: string]: SubAccountParentInfo };
  SubAccounts: { [key: string]: SubAccountsListsApi };
};

export type SubAccountsResponseApi = ApiResponse & {
  ParentAccount: string;
  Subaccounts: { [key: string]: SubAccountsListsApi };
  PaginationMetaData?: PaginationMetaData;
};

export type SubAccountsResponse = ApiResponse & {
  ParentAccount: string;
  Subaccounts: SubAccountsLists[];
  PaginationMetaData?: PaginationMetaData;
};

export type DeletePaypalAccountRequest = {
  PayPalToken: string;
};

export type DeleteVenmoAccountRequest = {
  VenmoToken: string;
};

export type DeleteClientBankAccountRequest = {
  PortalUser: string;
  Token: string;
};

export type DeleteClientCreditCardRequest = {
  PortalUser: string;
  CreditCardToken: string;
};

export type EmbedUrlRequest = {
  RedirectURL: string;
  ClientAccountID?: string;
  ContactID?: string;
  CompanyName?: string;
  BGColor?: string;
  ForegroundColor?: string;
  Language?: string;
  RedirectMethod?: string;
  ConsentMessage?: string;
  AccountSelectionMethod?: string;
  PaymentSelectionMethod?: ELinxConnectionMethod | string; // can be a comma separated string of methods
  Verify?: string;
  ClientControlled?: boolean;
  ClientReferenceNumber?: string;
  TermsAndConditions?: string;
  Country?: string;
  WithTransactions?: boolean;
  ForReconciliation?: boolean;
  AccountHolderType?: 'individual' | 'business' | '';
  CardTypeValidation?: boolean;
  AcceptedCardBrands?: string;
};

export type EmbedUrlResponse = ApiResponse & {
  EmbedURL: string;
  IframeKey: string;
};

export type BankingPaymentRail = 'eft' | 'vopayinstant' | 'ach' | 'rtp' | 'fedwire';

export type SendELinxRequest = ElinxNotificationSettings & {
  SenderName: string;
  ReceiverName: string;
  ReceiverEmailAddress?: string;
  IframeKey?: string;
  RecipientMessage?: string;
  InvoiceNumber?: string;
  Note?: string;
  ClientReferenceNumber?: string;

  PaymentType?: 'fund' | 'withdraw'; // if blank, automatically eConnect; if not blank, Amount and Currency are required
  Amount?: number; // if provided, must provide PaymentType
  Currency?: string; // defaults to CAD
  BankingPaymentRail?: BankingPaymentRail;

  DocumentID?: string;

  // new reoccuring feilds
  Frequency?: string;
  ScheduleStartDate?: string;
  NameOfFrequency?: string;
  ScheduleEndDate?: string;
  EndingAfterPayments?: string;
  SemiMonthlyFrequencyType?: string;

  // maybe need to add feild
  ClientAccountID?: string;
  ContactID?: string;
  SendEmail?: boolean; // TODO: deprecate and remove

  // required for eFlex
  // flexible payments
  FlexiblePaymentOptions?: string;
  MinimumPaymentAccepted?: number;
  RemainderPaymentDate?: string;
  NumberOfInstallments?: string | number;
  InstallmentFrequency?: 'weekly' | 'biweekly' | 'monthly';

  // existing payments
  PaymentMethodDisplayOptions?: PaymentMethodDisplayOptions;
  ReceiverPhoneNumber?: string;

  SendNotification?: boolean;
  NotificationMethod?: ElinxNotificationMethod;
};

export type SendELinxResponse = ApiResponse & {
  Amount: string;
  ClientReferenceNumber?: string;
  InvoiceNumber: string;
  Link: string;
  Note: string;
  ELinxRequestID: string;
  ELinxRequestType: string;
  ReceiverEmailAddress: string;
  ReceiverName: string;
  SendEmail?: boolean;
  SenderEmailAddress: string;
  SenderName: string;
  Status: string;
};

export type EftFundRequest = {
  PortalUser?: string;
  CompanyName?: string;
  FirstName?: string;
  LastName?: string;
  DOB?: string;
  PhoneNumber?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  Province?: string;
  Country?: string;
  PostalCode?: string;
  Token?: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  AccountNumber: string;
  Amount: number;
  Currency?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  ClientAccountID?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  institution?: string;
  KYCPerformed?: boolean;
  DelayBankingInfo?: boolean;
  TransactionLabel?: string;
  KYCReferenceNumber?: string;
};

export type EftFundResponse = ApiResponse & {
  TransactionID: string;
  Flagged: string;
  Iq11: boolean;
};

export type ScheduledEftFundRequest = {
  PortalUser: string;
  Amount: number;
  Frequency: string;
  NameOfFrequency: string;
  ScheduleStartDate: string;
  ScheduleEndDate: string;
  EndingAfterPayments: string;
  Description: string;
  AccountNumber: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  ClientAccountID?: string;
  SemiMonthlyFrequencyType?: string;
  FirstName?: string;
  LastName?: string;
  CompanyName?: string;
  DOB?: string;
  PhoneNumber?: string;
  Address1?: string;
  City?: string;
  Province?: string;
  Country?: string;
  PostalCode?: string;
  ClientReferenceNumber?: string;
  KYCPerformed?: boolean;
  KYCReferenceNumber?: string;
  EmailAddress?: string;
  IPAddress?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  Token?: string;
  PlaidPublicToken?: string;
  PlaidAccessToken?: string;
  PlaidAccountID?: string;
  PlaidProcessorToken?: string;
  InveriteRequestGUID?: string;
  DelayBankingInfo?: boolean;
  IdempotencyKey?: string;
  Notes?: string;
};

export type ScheduledEftFundResponse = ApiResponse & {
  Amount: number;
  ScheduledTransactionID: string;
  Frequency: string;
  Description: string;
  ScheduleStartDate: string;
  Status: string;
};

export type CancelAutoBalanceTransferRequest = {
  PortalUser: string;
};

export type ChargeCreditCardRequest = {
  PortalUser?: string;
  Amount: number;
  Currency: string;
  Country: string;
  CreditCardToken: string;
  IdempotencyKey?: string;
  ClientAccountID?: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type ChargeCreditCardResponse = ApiResponse & {
  TransactionID: string;
};

export type IdVerificationRequest = {
  FirstName?: string;
  LastName?: string;
  EmailAddress?: string;
};

export type InteracMoneyRequestRequest = {
  PortalUser?: string;
  Amount: number;
  Currency: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  RecipientName: string;
  MessageForRecipient: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  ClientAccountID?: string;
  SingleUseToken?: string;
  GenerateURL: boolean;
  GLCode?: string;
  TransactionCode?: string;
};

export type InteracBulkPayoutRequest = {
  Amount: number;
  Answer?: string;
  ClientAccountID?: string;
  ClientReferenceNumber?: string;
  Currency: string;
  EmailAddress?: string;
  Language?: string;
  Memo?: string;
  MessageForRecipient: string;
  Notes?: string;
  PhoneNumber?: string;
  PortalUser?: string;
  Question?: string;
  RecipientName: string;
  CancellationPeriod?: number;
  GLCode?: string;
  TransactionCode?: string;
};

export type InteracBulkPayoutResponse = ApiResponse & {
  TransactionID: string;
  Flagged?: string;
  TransactionStatus: string;
};

export type InteracMoneyRequestResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: string;
  MoneyRequestURL?: string;
};

export type IdVerificationResponse = {
  Success: string;
  ErrorMessage: string;
  VerifcationLink: string;
  WorkflowRunID: string;
};

export type CancelInteracMoneyRequest = {
  TransactionID: string;
};

export type CancelVoPayInstantRequest = {
  TransactionID: string;
};

export type CancelInteracMoneyResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: string;
  Timestamp: string;
};

export type CancelVoPayInstantResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: string;
  Timestamp: string;
};

export type EftWithdrawRequest = {
  Amount: number;
  PortalUser?: string;
  FirstName?: string;
  LastName?: string;
  CompanyName?: string;
  DOB?: string;
  PhoneNumber?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  Province?: string;
  ClientAccountID?: string;
  Country?: string;
  TransactionLabel?: string;
  PostalCode?: string;
  FinancialInstitutionNumber?: string;
  BranchTransitNumber?: string;
  AccountNumber?: string;
  IBAN?: string;
  SortCode?: string;
  Currency?: string;
  Token?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  KYCPerformed?: boolean;
  DelayBankingInfo?: boolean;
  ParentTransactionID?: string;
  KYCReferenceNumber?: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type RtrWithdrawRequest = {
  Amount: number;
  FirstName?: string;
  LastName?: string;
  City?: string;
  Country?: string;
  FinancialInstitutionNumber?: string;
  BranchTransitNumber?: string;
  AccountNumber?: string;
  Token?: string;
  Notes?: string;
  ClientReferenceNumber?: string;
  ClientAccountID?: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type EftWithdrawResponse = ApiResponse & {
  TransactionID: string;
  Flagged: string;
};

export type RtrWithdrawResponse = ApiResponse & {
  TransactionID: string;
  Flagged: string;
  TransactionStatus: string;
};

export type ScheduledEftWithdrawRequest = {
  Amount: number;
  Frequency: string;
  AccountNumber: string;
  FinancialInstitutionNumber: string;
  BranchTransitNumber: string;
  NameOfFrequency: string;
  ScheduleStartDate: string;
  ScheduleEndDate: string;
  EndingAfterPayments: string;
  Description: string;
  PortalUser?: string;
  SemiMonthlyFrequencyType?: string;
  FirstName?: string;
  LastName?: string;
  CompanyName?: string;
  PhoneNumber?: string;
  Address1?: string;
  City?: string;
  Province?: string;
  Country?: string;
  PostalCode?: string;
  EmailAddress?: string;
  DOB?: string;
  Token?: string;
  IPAddress?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  PlaidAccountID?: string;
  PlaidPublicToken?: string;
  PlaidAccessToken?: string;
  PlaidProcessorToken?: string;
  InveriteRequestGUID?: string;
  DelayBankingInfo?: boolean;
  KYCPerformed?: boolean;
  IdempotencyKey?: string;
  ClientAccountID?: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type ScheduledEftWithdrawResponse = ApiResponse & {
  Amount: number;
  ScheduledTransactionID: string;
  Frequency: string;
  Description: string;
  ScheduleStartDate: string;
  Status: string;
};

export type CreateAutoBalanceTransferRequest = {
  ScheduleStartDate: string;
  AutoBalanceTransferAmount: number;
  TypeOfFrequency: string;
};

export type PortalGenerateQRCodeRequest = {
  Username: string;
  PortalDomain: string;
};
export type PortalGenerateQRCodeResponse = ApiResponse & {
  QRCode: string;
};
export type PortalAuthenticateRequest = {
  Username: string;
  Code: string;
};
export type PortalAuthenticateResponse = ApiResponse & {
  Authorized: boolean;
  MfaHash: string | null;
};
export type PortalChangePasswordRequest = {
  Username: string;
  OldPassword: string;
  NewPassword: string;
};
export type PortalResetPasswordRequest = {
  Password: string;
  PasswordToken: string;
};

export type AccountTransferFromRequest = {
  Amount: number;
  DebitorClientAccountID?: string;
  RecipientClientAccountID?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  Currency?: string;
  DebitorAccountID: string;
  IdempotencyKey?: string;
};

export type AccountTransferFromResponse = ApiResponse & {
  TransactionID: string;
};

export type AccountTransferToRequest = {
  Amount: number;
  RecipientAccountID: string;
  DebitorClientAccountID?: string;
  RecipientClientAccountID?: string;
  Currency?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  ParentTransactionID?: string;
  IdempotencyKey?: string;
};

export type AccountTransferToResponse = ApiResponse & {
  TransactionID: string;
};

export type AccountTransferFundRequest = {
  Amount: number;
  DebitorClientAccountID: string;
  RecipientClientAccountID?: string;
  RecipientClientAccountIDSplit?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  TransactionLabel?: string;
  Currency?: string;
};

export type AccountTransferFundResponse = ApiResponse & {
  FundingTransactionID: string;
  AccountTransferID?: string;
  AccountTransferIDs?: {
    [key: string]: {
      ClientAccountID: string;
      ID: string;
    };
  };
};

export type AccountTransferWithdrawRequest = {
  DebitorClientAccountID: string;
  RecipientClientAccountID?: string;
  RecipientClientAccountIDSplit?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
  TransactionLabel?: string;
  Currency?: string;
};

export type AccountTransferWithdrawResponse = ApiResponse & {
  WithdrawTransactionID?: string;
  AccountTransferID?: string;
  AccountTransferIDs?: {
    [key: string]: {
      ClientAccountID: string;
      ID: string;
    };
  };
  WithdrawTransactionIDs?: {
    [key: string]: {
      ClientAccountID: string;
      ID: string;
    };
  };
};

export type AccountTransferFundWithdrawRequest = {
  DebitorClientAccountID: string;
  RecipientClientAccountID?: string;
  RecipientClientAccountIDSplit?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
  TransactionLabel?: string;
  Currency?: string;
};

export type AccountTransferFundWithdrawResponse = ApiResponse & {
  FundingTransactionID: string;
  WithdrawTransactionID?: string;
  AccountTransferID?: string;
  AccountTransferIDs?: {
    [key: string]: {
      ClientAccountID: string;
      ID: string;
    };
  };
  WithdrawTransactionIDs?: {
    [key: string]: {
      ClientAccountID: string;
      ID: string;
    };
  };
};

export type AccountTransferScheduleRequest = {
  Frequency: string;
  SemiMonthlyFrequencyType?: string;
  ScheduleStartDate?: string;
  ScheduleEndDate?: string;
  EndingAfterPayments?: number;
  Description: string;
  Amount: number;
  DebitorClientAccountID: string;
  RecipientClientAccountID?: string;
  RecipientClientAccountIDSplit?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  TransactionLabel?: string;
  Currency?: string;
};

export type RecipientClientAccountIDSplit = {
  ClientAccountID: string;
} & (
  | {
      Amount: string;
      Percentage?: never;
    }
  | {
      Amount?: never;
      Percentage: string;
    }
);

export type AccountTransferScheduleResponse = ApiResponse & {
  ScheduledTransfersID: string;
};
export type AccountTransferScheduleCancelRequest = {
  ScheduledTransferID: string;
};

export type AccountTransferScheduleCancelResponse = ApiResponse & {
  Status: string;
};

export type AccountTransferSchedulesRequest = {
  ScheduledTransferID?: string;
  StartDate?: string;
  EndDate?: string;
  SearchText?: string;
  TransferType?: string;
  TransferFrequency?: string;
  TransferStatus?: string;
};
export type AccountTransferScheduleTransfers = {
  ScheduledTransferID: string;
  TransferDate: string;
  Amount: number;
  Status: string;
  FailureReason: string;
  Currency: string;
  FundingTransactionID: string;
  AccountTransferID: string;
  WithdrawTransactionID: string;
  AccountTransferIDs: string;
  WithdrawTransactionIDs: string;
};
export type TemporaryAccountTransferScheduleTransfers = {
  [key: number]: {
    ScheduledTransferID: string;
    Currency: SupportedCurrencies;
    TransferDate: string;
    Amount: 0;
    Status: string;
    NumberOfRecipients: string;
    FailureReason: string;
    FundingTransactionID: string;
    AccountTransferID: string;
    WithdrawTransactionID: string;
    AccountTransferIDs: string;
    WithdrawTransactionIDs: string;
    id: string;
    isExpanded: boolean;
    isVisible: boolean;
    expandedId: string;
    class: string;
  }[];
};
export type AccountTransferSchedule = {
  ID: string;
  DebitorClientAccountID: string;
  RecipientClientAccountID: string;
  RecipientClientAccountIDSplit: string;
  Amount: number;
  TransferType: string;
  ReverseOnFailure: boolean;
  Frequency: string;
  SemiMonthlyFrequencyType: string;
  ClientReferenceNumber: string;
  Notes: string;
  TransactionLabel: string;
  Description: string;
  ScheduleStartDate: string;
  ScheduleEndDate: string;
  EndingAfterPayments: string;
  Status: string;
  Currency: string;
  DateAdded: string;
};

export type AccountTransferSchedulesResponse = ApiResponse & {
  ScheduledClientAccountTransfers: {
    [key: number]: AccountTransferSchedule;
    UpcomingTransfers?: {
      [key: string]: AccountTransferScheduleTransfers;
    };
    CompletedTransfers?: {
      [key: string]: AccountTransferScheduleTransfers;
    };
  };
  PaginationMetaData?: PaginationMetaData;
};
export type CreateSubAccountRequest = {
  LegalBusinessName: string;
  EmailAddress: string;
  SendWelcomeEmail?: boolean;
  OriginatorName?: string;
  OriginatorShortName?: string;
  ParentAccountID?: string;
};

export type CreateSubAccountResponse = ApiResponse & {
  Message: string;
  APISharedSecret: string;
  APIKey: string;
};

export type ContactGroupsRequest = {
  PortalUser?: string;
};

export type ContactGroupsLists = {
  ACTCurrencies_ID: string;
  DateAdded: string;
  Description: string;
  GroupName: string;
  ID: string;
  LastModified: string;
  Service: string;
  VIOAccounts_ID: string;
};

export type ContactGroupsResponse = ApiResponse & {
  ContactGroups: { [key: string]: ContactGroupsLists };
};

export type RenewAccountRequest = {
  Token: string;
};

export type CreateGroupRequest = {
  GroupName: string;
  Description: string;
  Service: string;
  Currency: string;
};

export type CreateGroupResponse = ApiResponse & {
  GroupID: string;
};

export type EditGroupRequest = {
  GroupName: string;
  Description: string;
  GroupID: string;
};

export type DeleteGroupRequest = {
  GroupID: string;
};

export type AddGroupContactRequest = {
  GroupID: string;
  Token: string;
};

export type AddGroupContactResponse = ApiResponse & {
  ContactID: string;
};

export type GroupContactRequest = {
  GroupID: string;
};

export type GroupContactList = {
  Account: string;
  AccountHolderName: string;
  ClientReferenceNumber: string;
  ContactID: string;
  IsActive: string;
  Token: string;
};

export type GroupContactResponse = ApiResponse & {
  Contacts: { [key: string]: GroupContactList };
};

export type ScheduledTransactionsRequest = {
  StartDate?: string;
  EndDate?: string;
  SearchText?: string;
  ScheduleTransactionType?: string;
  Frequency?: string;
  NameOfFrequency?: string;
  ScheduledTransactionStatus?: string;
  ScheduledTransactionID?: string;
  ClientAccountID?: string;
  ContactID?: string;
};

export type ScheduledDetails = {
  AccountNumber: string;
  Address1: string;
  BranchTransitNumber: string;
  City: string;
  ClientReferenceNumber: string;
  CompanyName: string;
  Country: string;
  DOB: string;
  EmailAddress: string;
  ErrorMessage: { [key: string]: ApiResponse };
  FinancialInstitutionNumber: string;
  FirstName: string;
  FlinksAccountID: string;
  FlinksLoginID: string;
  IPAddress: string;
  InveriteRequestGUID: string;
  KYCPerformed: string;
  KYCReferenceNumber: string;
  LastName: string;
  PhoneNumber: string;
  PlaidAccessToken: string;
  PlaidAccountID: string;
  PlaidProcessorToken: string;
  PlaidPublicToken: string;
  PostalCode: string;
  Province: string;
  Token: string;
};

export type UpcomingTransactions = {
  Amount: string;
  ID: string;
  LastModified: string;
  ProcessingDate: string;
  ScheduledDate: string;
  Status: string;
  TransactionID: string;
};

export type CompletedTransactions = {
  Amount: string;
  ID: string;
  LastModified: string;
  ProcessingDate: string;
  ScheduledDate: string;
  Status: string;
  TransactionID: string;
};

export type ScheduledTransactionsList = {
  Amount: string;
  Description: string;
  EndDate: string;
  EndingAfterPayments: string;
  Frequency: string;
  ID: string;
  NameOfFrequency: string;
  ScheduledDetails: ScheduledDetails;
  Currency: SupportedCurrencies;
  CompletedTransactions: { [key: string]: CompletedTransactions };
  UpcomingTransactions: { [key: string]: UpcomingTransactions };
  StartDate: string;
  Status: AccountTransactionStatus;
  Type: string;
};

export type ScheduledTransactionsResponseRaw = ApiResponse & {
  NumberOfRecords: number;
  ScheduledTransactions?: Record<string, ScheduledTransactionsList>;
  PaginationMetaData?: PaginationMetaData;
};

export type ScheduledTransactionsResponse = ApiResponse & {
  NumberOfRecords: number;
  ScheduledTransactions: ScheduledTransactionsList[];
  PaginationMetaData?: PaginationMetaData;
};

export type InboundETransferTransactionRequest = {
  TransactionID: string;
};

export type InboundETransferList = {
  Amount: string;
  DateReceived: string;
  Email: string;
  ID: string;
  Message: string;
  MessageID: string;
  Name: string;
  Status: TransactionStatus;
};

export type InboundETransferTransactionResponse = ApiResponse & {
  Transactions: InboundETransferList;
};

export type VisaDirectPushTransactionRequest = {
  TransactionID: string;
};

export type VisaDirectPushTransactionResponse = {
  ErrorMessage: string;
  Success: boolean;
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: string;
  HoldAmount: string;
  CompanyName: string;
  FirstName: string;
  LastName: string;
  ClientReferenceNumber: string;
  KYCPerformed: string;
  KYCReferenceNumber: string;
  VisaTransferID: string;
  LastModified: string;
  MaskedCardNumber: string;
};

export type CurrencyConversionTransactionRequest = {
  TransactionID: string;
};

export type CurrencyConversionTransactionList = {
  TransactionID: string;
  SellCurrency: string;
  BuyCurrency: string;
  ConversionRate: string;
  SellAmount: string;
  BuyAmount: string;
};

export type CurrencyConversionTransactionResponse = ApiResponse & {
  Transactions: CurrencyConversionTransactionList;
};

export type ClientAccountListRequest = RequestWithPagination & {
  ClientAccountID?: string;
  ClientType?: string;
  AccountStatus?: boolean; // IsActive; yeah, weird...
  Label?: string;
  SearchText?: string;
  IsBusiness?: boolean;
  MaxBalance?: string;
  MinBalance?: string;
};

export type AccountType = 'individual' | 'business' | 'receive-only' | 'unverified' | 'standard';

export type ClientAccount = AdditionalContacts & {
  Address1: string;
  Address2: string;
  BusinessCategory: string;
  BusinessIndustry: string;
  BusinessName: string;
  BusinessNumber: string;
  BusinessWebsite: string;
  City: string;
  ClientAccountID: string;
  ClientName: string;
  ClientType: AccountType;
  Country: string;
  DOB: string;
  EmailAddress: string;
  FirstName: string;
  InteracEtransferPreference: string;
  IsActive: boolean;
  IsPrimaryAccount: string;
  IsBillingAccount: string;
  LastName: string;
  ParentAccountID: string;
  ParentAccountName: string;
  PhoneNumber: string;
  IdentificationNumber: string;
  PostalCode: string;
  Province: string;
  SINLastDigits: string;
  Labels: string[];
  Currency: string;
  Balances?: ClientAccountBalance[];
  Language: string;
  TransactionLimit: string;
  IsBusiness: boolean;
  CAPUserID: string;
};

export type ClientAccountBalance = {
  Currency: SupportedCurrencies | '';
  Balance: number;
  PendingBalance: number;
  AvailableBalance: number;
};

export type ClientAccountListApiResponse = ApiResponse &
  ResponseWithPagination & {
    ClientAccounts: {
      [key: string]: Omit<ClientAccount, 'IsActive' | 'Labels' | 'Balances'> & {
        IsActive: string;
        Labels: string;
        Balances: {
          Currency: SupportedCurrencies;
          Balance: string;
          PendingBalance: string;
          AvailableBalance: string;
        }[];
        AdditionalContacts: {
          email?: Record<number, string>;
        };
      };
    };
  };

export type ClientAccountListResponse = ApiResponse &
  ResponseWithPagination & {
    ClientAccounts: ClientAccount[];
  };

export type ClientAccountBalanceRangeResponse = ApiResponse & {
  MinBalance: number;
  MaxBalance: number;
};

export type ClientAccountPaymentMethodRequest = {
  ClientAccountID: string;
  PaymentSelectionMethods?: string;
};

export type ContactPaymentMethodRequest = {
  ContactID: string;
};

export type ApiPaymentMethodResponse = ApiResponse & {
  PaymentMethods?: {
    [idx: string]: {
      PaymentMethod: PaymentMethodType;
      AddedOn: string;
      PaymentDetails: string;
      IsDefault: string;
      Token: string;
      Currency: SupportedCurrencies | null;
      ExtraFields: {
        VerificationStatus?: VerificationStatus; // for banks
        InstitutionName?: string; // for banks
        BankID?: string; // for... banks
        CardBrand?: CardBrand; // for cards
        ExpirationDate?: string; // for cards
      };
    };
  };
};

export type PaymentMethod = {
  PaymentMethod: PaymentMethodType;
  AddedOn: string;
  PaymentDetails: string;
  IsDefault: boolean;
  Token: string;
  Currency: SupportedCurrencies | null;
  ExtraFields: {
    // for Bank:
    AccountHolderName?: string;
    VerificationStatus?: VerificationStatus;
    VerificationSentOn?: string;
    InstitutionName?: string;
    BankID?: string;
    PaymentRails?: string;

    // for Email/Phone;
    Name?: string;
    HasQuestionAndAnswer?: boolean;
    AutoDepositEnabled?: boolean;

    // for CreditCard
    CardBrand?: CardBrand;
    CardHolderName?: string;
    ExpirationDate?: string;

    // for third-party
    RecipientType?: string;

    ProvinceAbbreviation?: string | null;
    CountryAbbreviation?: string | null;
  };
};

export type PaymentMethodResponse = ApiResponse & {
  PaymentMethods: PaymentMethod[];
};

export type ClientAccountBalanceRequest = {
  ClientAccountID: string;
  Currency?: string;
};

export type ClientAccountBalanceResponse = ApiResponse & {
  AccountBalance: string;
  AvailableFunds: string;
  Currency: string;
  PendingFunds: string;
  Reserve: string;
};

export type DefaultBankAccountRequest = TimezoneRequest & {
  PortalUser?: string;
  ClientAccountID?: string;
  Currency?: string;
};

export type DefaultBankAccountList = {
  ABARoutingNumber: string;
  ADRProvinces_ID: string;
  AccountHolderName: string;
  AccountNumber: string;

  Address: string;
  BicSwift: string;
  BranchTransitNumber: string;
  BankId: string;

  City: string;
  ClientAccountID: string;
  ClientControlledBankAccount: boolean;
  ClientReferenceNumber: string;
  Currency: string;
  DataProviderMessage: string;
  DateAdded: string;
  EmailAddress: string;
  ExternalRecordID: string;
  FailureReasonCode: string;
  FinancialInstitutionNumber: string;
  FiservToken: string;
  FlinksAccountID: string;
  FlinksLoginID: string;
  IBAN: string;
  InstitutionName: string;
  InveriteRequestGUID: string;
  IsActive: string;
  IsBlackListed: string;
  IsDefault: boolean;
  LastModified: string;
  MxAuthorizationCode: string;
  MxProcessorToken: string;
  OtherProvince: string;
  Phone: string;
  PlaidAccountID: string;
  PlaidProcessorToken: string;
  PostalCode: string;
  SortCode: string;
  Token: string;
  Type: string;
  VIOPartnerAccounts_ID: string;
};

export type DefaultBankAccountResponse = ApiResponse & {
  DefaultOperationalBankAccount: { [key: string]: DefaultBankAccountList };
  DefaultBillingBankAccount: { [key: string]: DefaultBankAccountList };
};

export type PaasTransactionsRequest = {
  PortalUser?: string;
};
export type PaasTransactionBase = {
  AggregatorTransactionID: string;
  Processor: string;
  ProcessorID: string;
  Code: string | null;
  TransactionDate: string;
  Debit: number | null;
  Credit: number | null;
  Balance: number;
  Description: string;
  Category: string;
  SubCategory: string;
  Company: string;
  Classification: string;
  IsDataEnriched: PseudoBool;
  MCC: string;
};
export type PaasTransaction = Omit<PaasTransactionBase, 'IsDataEnriched'> & {
  IsDataEnriched: boolean;
};

export type PaasTransactionsResponse = ApiResponse & {
  Transactions: { [key: string]: PaasTransactionBase };
};

export type BatchFileTransactionsRequest = {
  PortalUser?: string;
  BatchID: string;
  TransactionType: string;
  PaymentType: string;
};

export type BatchFileTransactionsList = {
  ID: string;
  FirstName: string;
  LastName: string;
  DateAdded: string;
  LastModified: string;
  Amount: string;
  Status: string;
  VIOAccountTransactions_ID: string;
};

export type BatchFileTransactionsResponse = ApiResponse & {
  Transactions: { [key: string]: BatchFileTransactionsList };
};

export type InteracEmailRequest = {
  ClientAccountID?: string;
  RecipientName?: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  ClientReferenceNumber?: string;
  ClientControlled?: boolean;
  Limit?: number;
  SearchText?: string;
  Token?: string;
};

export type InteracEmailList = {
  ID: string;
  VIOAccounts_ID: string;
  VIOClientAccounts_ID: string;
  ACTCurrencies_ID: string;
  ClientControlledEmail: string;
  RecipientName: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  IsDefault?: string;
  Question: string;
  Answer: string;
  Message: string;
  ClientReferenceNumber: string;
  IsActive: string;
  DateAdded: string;
  LastModified: string;
  Token: string;
  Currency: string;
  Verified: string;
  RegisteredName: string;
  Alias: string;
  CustomerType: string;
  AutoDepositEnabled: string;
  TransactionLimit: string;
};

export type InteracEmailResponse = ApiResponse & {
  InteracEmails: { [key: string]: InteracEmailList };
};

export type InteracAddEmailRequest = PortalUser & {
  ClientAccountID?: string;
  ContactID?: string;
  RecipientName: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  Currency?: string;
  Question?: string;
  Answer?: string;
  Message?: string;
  ClientReferenceNumber?: string;
  etransferConnectionType?: string;
  ClientControlled: boolean;
  Nickname?: string;
};

export type InteracAddEmailResponse = ApiResponse & {
  Token: string;
};

export type SupportedLanguages = 'en' | 'fr';

export type InteracLinkEmailRequest = PortalUser & {
  RecipientName: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  Question?: string;
  Answer?: string;
  etransferConnectionType?: string;
  Language?: SupportedLanguages;
};

export type InteracLinkEmailResponse = ApiResponse & {
  Token: string;
};

export type IQ11TokenizeRequest = PortalUser & {
  ClientAccountID?: string;
  ContactID?: string;
  AccountHolderName: string;
  AccountNumber?: string;
  FinancialInstitutionNumber?: string;
  BranchTransitNumber?: string;
  IBAN?: string;
  ABARoutingNumber?: string;
  SortCode?: string;
  ClientReferenceNumber?: string;
  ClientControlled: boolean;
  Currency?: string;
  Address1?: string;
  City?: string;
  Province?: string;
  PostalCode?: string;
  PhoneNumber?: string;
  Country?: string;
};

export type IQ11TokenizeResponse = ApiResponse & {
  Token: string;
};

export type BulkPaymentRequestList = {
  Account: string;
  ClientReferenceNumber: string;
  IsActive: string;
  Token: string;
  Amount: string;
  Currency: string;
  FirstName: string;
  LastName: string;
  Message: string;
};

export type BulkPaymentRequest = {
  BatchName: string;
  BatchData: { [key: string]: BulkRequestList } | string;
};

export type BulkResponse = ApiResponse & {
  BatchTransactionRequestID: string;
  TotalSubmittedTransactions: string;
  NumberOfRejectedTransactions: string;
  RejectedTransactions: string;
};

export type BulkRequestList = {
  [key: string]: string | number | boolean | undefined;
};

export type BulkCollectionRequest = {
  BatchName: string;
  BatchData: { [key: string]: BulkRequestList } | string;
};
export type Batches = {
  [key: string]: Batch;
};
export type Batch = {
  BatchName: string;
  BatchTransactionRequestID: number;
  DateAdded: string;
  NumRecords: number;
  PaymentType: string;
  TotalAmount: number;
  TotalCreated: number;
  TotalFailed: number;
  TotalSubmitted: number;
  TransactionType: string;
};
export type UploadBatchRequest = PortalUser & {
  TransactionType?: string;
  PaymentType?: string;
  FromDate?: string;
  ToDate?: string;
  Timezone?: string;
};
export type UploadBatchFileApiResponse = ApiResponse & {
  Batches?: Batches;
};
export type UploadBatchFileResponse = ApiResponse & {
  Batches: Batch[];
  PaginationMetaData?: PaginationMetaData;
};

export type UploadBatchFileDetailseResponse = ApiResponse & {
  BatchDetails: {
    [key: string]: {
      BatchName: string;
      ResponseData?: { [key: string]: string };
      Status: string;
      TransactionID: number;
      TransactionPayload: { [key: string]: string };
      BatchTransactionRequestDetailsRecordID: number;
      FailureReason: string;
    };
  };
};
export type UploadBatchFileDetailsRequest = PortalUser & {
  BatchTransactionRequestID: number;
};
export type DefaultPaymentMethodRequest = {
  PortalUser?: string;
};
export type DefaultPaymentMethodResponse = ApiResponse & {
  DefaultPaymentMethod: 'vopay' | 'bank' | 'credit';
};
export type SetDefaultPaymentMethodRequest = {
  PortalUser?: string;
  PaymentMethod: 'vopay' | 'bank' | 'credit';
};

export type CancelScheduledWithdrawRequest = {
  ScheduledTransactionID: string;
};

export type CancelScheduledWithdrawResponse = ApiResponse & {
  Status: string;
};

export type CancelScheduledFundRequest = {
  ScheduledTransactionID: string;
};

export type CancelScheduledFundResponse = ApiResponse & {
  Status: string;
};

export type EditScheduledWithdrawRequest = {
  ScheduledTransactionID: string;
  UpcomingPayment: string;
  Amount?: string;
  NewDate?: string;
};

export type EditScheduledFundRequest = {
  ScheduledTransactionID: string;
  UpcomingPayment: string;
  Amount?: string;
  NewDate?: string;
};

export type ConfirmTransactionRequest = {
  TransactionID: string;
};

export type GetTransactionCountsRequest = {
  Currency?: SupportedCurrencies;
  StartDateTime?: string;
  EndDateTime?: string;
};

export type GetTransactionCountsResponse = ApiResponse & {
  CountData: CountData;
};

export type CountData = {
  [date: string]: number;
};

export type CreateClientAccountRequest = {
  FirstName: string;
  LastName: string;
  EmailAddress?: string;
  Address1?: string;
  City?: string;
  Province?: string;
  Country?: string;
  PostalCode?: string;
  PhoneNumber?: string;
  IdentificationNumber?: string;
  ClientAccountID?: string;
  Currency: string;
  FinancialInstitutionNumber?: string; // _TODO: these are optional, right?
  BranchTransitNumber?: string;
  AccountNumber?: string;
  Token?: string;

  FlinksAccountID?: string;
  FlinksLoginID?: string;
  PlaidProcessorToken?: string;
};

export type CreateClientAccountIndividualRequest = CreateClientAccountRequest & {
  DOB: string;
  SINLastDigits: string;
  Label?: string;
};

export type CreateClientAccountBusinessRequest = CreateClientAccountRequest & {
  BusinessName: string;
  BusinessNumber: string;
  BusinessTypeID: string;
  BusinessTypeCategoryID: string;
  BusinessWebsite: string;
  BusinessPhone: string;
  Label?: string;
};

export type CreateClientAccountReceiveOnlyRequest = CreateClientAccountRequest & {
  BusinessName?: string;
  Label?: string;
};

export type CreateClientAccountStandardRequest = CreateClientAccountRequest & {
  BusinessName?: string;
  Label?: string;
};

export type CreateClientAccountResponse = ApiResponse & {
  ClientAccountID: string;
};

export type EditClientAccountRequest = {
  ClientAccountID: string;
  FirstName?: string;
  LastName?: string;
  EmailAddress?: string;
  BusinessName?: string;
  BusinessNumber?: string;
  BusinessTypeID?: string;
  BusinessTypeCategoryID?: string;
  BusinessWebsite?: string;
  PhoneNumber?: string;
  IdentificationNumber?: string;
  Label?: string;
  SourceOfIncome?: string;
  Occupation?: string;
  DateOfBirth?: string;
  DOB?: string;
  Nationality?: string;
  SINLastDigits?: string;
  InteracEtransferPreference?: string;
  OtherProvince?: string;
} & Partial<Address>;

export type EditClientAccountResponse = ApiResponse;

export const webhookEventList = [
  'transaction',
  'elinx',
  'bankaccount',
  'batchrequest',
  'batchdetail',
  'accountonboarding',
  'scheduledtransactions',
  'transactiongroup',
  'accountverifications',
  'accountbalance',
  'clientaccountbalance',
  'paymentreceived',
  'accountlimit',
  'virtualtransaction',
  'creditcard',
  'debitcard',
] as const;
export type WebhookEvent = (typeof webhookEventList)[number];

export type WebhookEvents = {
  Event: WebhookEvent;
  Url: string;
};
export type WebhooksEvents = {
  DateSent: string;
  EventID: string;
  Module: string;
  Status: string;
  Type: string;
  WebhookID: string;
  WebhookUrl: string;
  NotificationStatus: string;
  ResponseText: string;
  ResponseStatusCode: string;
};
export type UpdateWebhookRequest = PortalUser & {
  WebHookUrl: string;
  Disabled: boolean;
  Type?: WebhookEvent;
};
export type RetriggerWebhookResponse = ApiResponse;
export type RetriggerWebhookRequest = PortalUser & {
  EventID: string;
  Type: string;
};
export type UpdatePartnerWebhookRequest = PartnerUser & {
  WebHookUrl: string;
  Disabled: boolean;
  Type?: WebhookEvent;
};
export type WebhookResponse = ApiResponse & {
  WebHookURL: string;
  Webhooks: { [s: string]: WebhookEvents };
};
export type WebhooksResponse = ApiResponse & {
  WebhookNotifications: { [s: string]: WebhooksEvents };
  Pagination?: PaginationMetaData;
};

export type ClientWebhooksRequest = TimezoneRequest & {
  EndDate: string;
  StartDate: string;
  Type?: string;
};

export type WebhooksRequest = {
  EndDate: string;
  StartDate: string;
  Type: string;
};
export type WebhooksList = WebhooksEvents & {
  isChecked?: boolean;
};

export type SetPlaidCredentialsRequest = PortalUser & {
  PlaidClientID: string;
  PlaidSecretKey: string;
  PlaidUrl: string;
};
export type SetFlinksCredentialsRequest = PortalUser & {
  FlinksUrl: string;
};
export type SetInveriteCredentialsRequest = PortalUser & {
  InveriteAPIKey: string;
  InveriteUrl: string;
};
export type SetGlobalPayCredentialsRequest = PortalUser & {
  GlobalPayAppID: string;
  GlobalPaySharedSecret: string;
};
export type ClientAccountsRequest = {
  ClientType: string;
  ClientAccountID: string;
};
export type SaveAuthorizedIPsRequest = PortalUser & {
  AuthorizedIPs: string;
};
export type AuthorizedIPsResponse = ApiResponse & {
  AuthorizedIPs: string;
};

export type ELinxSettingsSetSendeeEmailRequest = PortalUser & {
  ReceiverNotifications: boolean;
  SenderNotifications: boolean;
};
export type ELinxSettingsSetSenderEmailRequest = PortalUser & {
  SenderEmailAddress: string;
};
export type ELinxSettingsSetTokenExpirationRequest = PortalUser & {
  TokenExpirationTime: number;
};
export type PostELinxSettingsUpdateRequestRequest = PortalUser & {
  ReceiverNotifications: boolean | PseudoBool;
  SenderNotifications: boolean | PseudoBool;
  SenderEmailAddress: string;
  TokenExpirationTime: number;
  IsDeclineEnabled: boolean | PseudoBool;
  PortalUser: string;
};
export type ELinxSettingsSetDeclineRequest = PortalUser & {
  IsDeclineEnabled: boolean;
};
export type ELinxCancelRequest = PortalUser & {
  ELinxRequestID: string;
};
export type ELinxSettingsRequest = PortalUser & {
  ReceiverNotifications: boolean;
  SenderNotifications: boolean;
  SenderEmailAddress: string;
  TokenExpirationTime: number;
  IsDeclineEnabled: boolean;
};

export type ElinxNotificationMethod = 'email' | 'sms' | 'whatsapp';

export type ELinxSettingsResponse = ApiResponse & {
  ELinxSettings: {
    EnableELinxDecline: PseudoBool;
    ELinxReminderEnabled: PseudoBool;
    ReceiverNotificationsEnabled: PseudoBool;
    SenderNotificationsEnabled: PseudoBool;
    ELinxExpirationTime: number;
    ELinxSenderEmailAddress: string;
    DefaultNotificationMethod: ElinxNotificationMethod;
    ELinxReminderFrequency: string;
  };
};

export type ElinxType = 'ePay' | 'eCollect' | 'eFlex' | 'eConnect';
export type BankAccountConnectionType = 'manual' | 'flinks' | 'plaid' | 'fiserv' | 'inverite' | 'mx';

export type ELinxHistoryItem = {
  AccountNumber?: string;
  Amount?: number;
  BranchTransitNumber?: number;
  ClientReferenceNumber?: string;
  CreditCardBrand?: string;
  CreditCardExpiryMonth?: number;
  CreditCardExpiryYear?: number;
  CreditCardNumber?: number;
  CreditCardToken?: string;
  Currency?: string;
  FinancialInstitutionNumber?: number;
  IQ11Token?: string;
  Institution?: string;
  Link: string;
  Note: string;
  ELinxRequestID: number;
  ELinxRequestType: string;
  PaymentType: string;
  ReceiverEmailAddress: string;
  ReceiverName: string;
  ReceiverPhoneNumber?: string;
  RecipientMessage: string;
  RequestDate: string;
  ScheduledPaymentsID?: number;
  SenderEmailAddress: string;
  SenderName: string;
  Status: 'pending' | 'completed' | 'cancelled' | 'declined' | 'waiting' | 'pending approval';
  TransactionID?: string;
  TransactionTypes?: string;
  eLinxType: ElinxType;
  InvoiceNumber: string;
  BankingPaymentRail: BankingPaymentRail;
  BankAccountConnectionType: BankAccountConnectionType;
  RequestPaymentMethodType: string;
  PaymentMethodDisplayOptions: PaymentMethodDisplayOptions;
  NotificationMethod: ElinxNotificationMethod;
  ReminderFrequency: string;
  FlexiblePaymentOptions: {
    [key: number]: string;
  };
  MinimumPaymentAccepted: string;
  RemainderPaymentDate: string;
  NumberOfInstallments: string;
  InstallmentFrequency:
    | 'daily'
    | 'weekly'
    | 'biweekly'
    | 'monthly'
    | 'bimonthly'
    | 'semi-monthly'
    | '3 months'
    | '6 months'
    | 'yearly';
  DocumentID: string;
  ReceiverContactType: AccountType;
} & (
  | {
      ClientAccountID?: never;
      ContactID: string;
    }
  | {
      ClientAccountID: string;
      ContactID?: never;
    }
);

export type ElinxReminderApiResponse = {
  NotificationEnabled: PseudoBool;
  ReminderEnabled: PseudoBool;
};

export type ElinxReminderResponse = {
  NotificationEnabled: boolean;
  ReminderEnabled: boolean;
};

export type RecipientsApiResponse = {
  Recipients: Record<string, string>;
};

export type RecipientsResponse = {
  Recipients: string[];
};

export type CardSettingsApiResponse = {
  CardTypeValidation: PseudoBool;
  AcceptedCardBrands: string; // comma separated string of AcceptedCardBrand
};

export type CardSettingsResponse = {
  CardTypeValidation: boolean;
  AcceptedCardBrands: AcceptedCardBrand[];
};

export type ELinxHistoryResponse = ApiResponse & {
  ELinxRequests: (ELinxHistoryItem & ElinxReminderResponse & RecipientsResponse & CardSettingsResponse)[];
  PaginationMetaData?: PaginationMetaData;
};

export type ELinxHistoryApiResponse = ApiResponse & {
  ELinxRequests: {
    [key: string]: ELinxHistoryItem & ElinxReminderApiResponse & RecipientsApiResponse & CardSettingsApiResponse;
  };
  PaginationMetaData?: PaginationMetaData;
};

export type ELinxHistoryRequest = PortalUser & {
  ELinxRequestType?: string;
  ELinxRequestID?: string;
  StartDateTime?: string;
  EndDateTime?: string;
  Timezone?: string;
  ELinxStatus?: string;
  SearchText?: string;
  ClientAccountID?: string;
  ContactID?: string;
};

export type DeleteInteracEmailRequest = {
  Token: string;
  ClientAccountID?: string;
};

export type AdditionalApiContacts = {
  AdditionalContacts: {
    email?: Record<number, string>;
  };
};

export type AdditionalContacts = {
  AdditionalContacts: {
    email?: string[];
  };
};

export type ClientAccounts = {
  Address1: string;
  Address2: string;
  BusinessCategory: string;
  BusinessIndustry: string;
  BusinessNumber: string;
  BusinessPhone: string;
  BusinessWebsite: string;
  City: string;
  ClientAccountID: string;
  ClientName: string;
  ClientType: string;
  Country: string;
  DOB: string;
  EmailAddress: string;
  IsActive: string;
  ParentAccountID: string;
  ParentAccountName: string;
  PostalCode: string;
  Province: string;
  SINLastDigits: string;
};

export type ClientAccountsResponse = ApiResponse & {
  ClientAccounts: { [key: string]: ClientAccounts };
};

export type ClientChangePasswordRequest = {
  EmailAddress: string;
  OldPassword: string;
  NewPassword: string;
};

export type LinkPushToCardRequest = {
  PaymentToken: string;
  CardHolderName: string;
  MaskedCardNumber: string;
  CardBrand: string | null;
  ExpiryYear: string;
  ExpiryMonth: string;
  Email?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  Province?: string;
  PostalCode?: string;
  Country?: string;
};

export type AccountTransactionTypesRequest = {
  IsFunding?: string;
  IsWithdraw?: string;
  IsBillable?: string;
  IsManual?: string;
  CountriesID?: string;
};

export type AccountTransactionType = {
  ID: string;
  TransactionType: string;
  IsManualTransaction: string;
  IsBillable: string;
  IsFunding: string;
  IsWithdraw: string;
  ADRCountries_ID: string;
};

export type AccountTransactionTypesResponse = ApiResponse & {
  TransactionTypes: { [key: string]: AccountTransactionType };
};

export type AccountTransactionTypesPartnerResponse = ApiResponse & {
  TransactionTypes: AccountTransactionType[];
};

export type WithdrawMyAccountRequest = {
  ClientAccountID?: string;
  Amount: number;
  Currency: string;
  ClientReferenceNumber?: string;
  Notes?: string;
};
export type WithdrawMyAccountResponse = ApiResponse & {
  TransactionID: string;
};
export type FundMyAccountRequest = {
  ClientAccountID?: string;
  Amount: number;
  Currency: string;
  ClientReferenceNumber?: string;
  Notes?: string;
};
export type FundMyAccountResponse = ApiResponse & {
  TransactionID: string;
};
export type MyAccountScheduleRequest = {
  Amount: number;
  Frequency: string;
  NameOfFrequency: string;
  ScheduleStartDate: string;
  ScheduleEndDate?: string;
  EndingAfterPayments?: string;
  SemiMonthlyFrequencyType?: string;
  Description: string;
  ClientReferenceNumber?: string;
  Currency: string;
};

export type MyAccountScheduleResponse = ApiResponse & {
  ScheduledTransactionID: string;
  Frequency: string;
  Description: string;
  ScheduleStartDate: string;
  Status: string;
  Amount: number;
};

export type VoidACHTransactionRequest = {
  TransactionID: string;
};
export type VoidACHTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: string;
  Timestamp: string;
};
export type RefundACHTransactionRequest = {
  TransactionID: string;
  Amount?: number;
};
export type RefundACHTransactionResponse = ApiResponse & {
  TransactionID: string;
  Timestamp: string;
};
export type SecCode = 'PPD' | 'CCD' | 'WEB' | 'TEL' | 'ARC' | 'IAT' | 'POP';
export type ACHFundRequest = {
  CompanyName?: string;
  FirstName?: string;
  LastName?: string;
  IdentificationNumber?: string;
  PhoneNumber?: string;
  EmailAddress?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  Country?: string;
  ZipCode?: string;
  Token?: string;
  ABARoutingNumber?: string;
  AccountNumber?: string;
  Amount: number;
  Currency: string;
  ClientAccountID?: string;
  Notes?: string;
  TransactionLabel?: string;
  SecCode?: SecCode;
};
export type ACHFundResponse = ApiResponse & {
  TransactionID: string;
};
export type ACHWithdrawRequest = {
  CompanyName?: string;
  FirstName?: string;
  LastName?: string;
  IdentificationNumber?: string;
  PhoneNumber?: string;
  EmailAddress?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  Country?: string;
  ZipCode?: string;
  Token?: string;
  ABARoutingNumber?: string;
  AccountNumber?: string;
  Amount: number;
  Currency: string;
  ClientAccountID?: string;
  Notes?: string;
  TransactionLabel?: string;
  GLCode?: string;
  TransactionCode?: string;
  SecCode?: SecCode;
};
export type ACHWithdrawResponse = ApiResponse & {
  TransactionID: string;
};
export type ACHFundScheduleRequest = {
  CompanyName?: string;
  FirstName?: string;
  LastName?: string;
  IdentificationNumber?: string;
  PhoneNumber?: string;
  EmailAddress?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  Country?: string;
  ZipCode?: string;
  Token?: string;
  ABARoutingNumber?: string;
  AccountNumber?: string;
  Amount: number;
  Currency: string;
  ClientAccountID?: string;
  Notes?: string;
  TransactionLabel?: string;
  Frequency: string;
  NameOfFrequency: string;
  ScheduleStartDate: string;
  ScheduleEndDate: string;
  EndingAfterPayments: string;
  SemiMonthlyFrequencyType: string;
  Description: string;
  GLCode?: string;
  TransactionCode?: string;
};
export type ACHFundScheduleResponse = ApiResponse & {
  ScheduledTransactionID: string;
};
export type ACHFundTransactionRequest = TimezoneRequest & {
  TransactionID: string;
};
export type ACHFundTransactionResponse = ACHTransactionResponse & {
  SubTransactions: LinkedTransactionsMap;
};
export type ACHWithdrawTransactionRequest = TimezoneRequest & {
  TransactionID: string;
};
export type ACHWithdrawTransactionResponse = ACHTransactionResponse & {
  ParentTransaction: LinkedTransactionsMap;
};
export type ACHSheduleTransactionRequest = {
  ScheduledTransactionID: string;
};
export type ACHSheduleTransactionResponse = ApiResponse & {
  NumberOfRecords: number;
  ScheduledTransactions: { [key: string]: ScheduledTransactionsList };
};
export type RefundCreditCardTransactionRequest = {
  TransactionID: string;
};
export type RefundCreditCardTransactionResponse = ApiResponse & {
  TransactionID: string;
  Amount?: number;
};

export type VoidCreditCardTransactionRequest = {
  TransactionID: string;
};
export type VoidCreditCardTransactionResponse = ApiResponse & {
  TransactionID: string;
};

export type OnboardingFormFields = {
  registered_address1: number;
  registered_city: number;
  registered_country: number;
  registered_postal_code: number;
  registered_province: number;
  tax_id?: number;
};

export type DocumentCategory =
  | 'agreement'
  | 'tier-agreement'
  | 'var-payfac-agreement'
  | 'referral-agreement'
  | 'account-creation-agreement'
  | 'application'
  | 'terms-of-service'
  | 'telecheck-application'
  | 'var-agreement'
  | 'technology-agreement';

export type SendLegalAgreementResponse = ApiResponse & {
  DocumentSent?: boolean;
  DocumentLink?: string;
  EmailAddress: string;
  DocumentCategory: DocumentCategory | undefined;
  DocumentComplete: boolean;
  OnboardingFormFields?: OnboardingFormFields;
};

export type PostLegalAgreementResponse = ApiResponse & {
  DocumentSent?: boolean;
  DocumentLink?: string;
};

export type OnboardingTokenRequest = {
  ApplicationID: string;
  OnboardingAppKey: string;
};

export type OnboardingAccountType = 'partner' | 'vopay';

export type OnboardingTokenResponse = ApiResponse & {
  Token: string;
  AccountType: OnboardingAccountType;
};

export type SubscriptionItem = {
  ID: string;
  RecipientEmails?: string;
  ReportName: string;
  // TODO: make required once we've retired the old Reports screens
  ReportID?: string;
  ReportAvailable?: string;
  ReportType?: Exclude<AccountTransactionReportType, '' | 'InterestReport'>;
  Description: string;
  ScheduledDate: string;
  IsActive: string;
  PaymentRails: {
    [key: string]: string;
  };
  ScheduleType: string;
  Frequency?: string;
  DateFormat: string;
  FromDate: string;
  ToDate: string;
  DateAdded: string;
};

export type FetchSubscriptionListResponse = ApiResponse & {
  Subscriptions: SubscriptionItem[];
  PaginationMetaData?: PaginationMetaData;
};

export type CreateReportsResponse = ApiResponse & {
  AccountSubscriptionReport: {
    ID: string;
    ReportName: string;
    Description: string;
    ScheduledDate: string;
    IsActive: string;
    PaymentRails: {
      [key: string]: string;
    };
    ScheduleType: string;
    DateFormat: string;
    FromDate: string;
    ToDate: string;
    DateAdded: string;
  };
};

export type DownloadReportsResponse = ApiResponse & {
  ReportFile: string;
  ReportName: string;
};
export type AccountTransactionReports = {
  ID: string;
  VIOAccountTransactionReportSubscriptions_ID: string;
  FromDate: string;
  ToDate: string;
  ScheduledDate: string;
  IsAvailable: string;
  DateAdded: string;
  LastModified: string;
};
export type SubscriptionDetail = {
  ID: string;
  ReportName: string;
  Description: string;
  IsActive: string;
  ScheduleType: ReportSchedule;
  DateFormat: string;
  DateAdded: string;
  LastModified: string;
  FromDate?: string;
  ToDate?: string;
  AccountTransactionReportType: AccountTransactionReportType;
  IncludeSubAccounts: boolean;
  IncludeGraph: boolean;
  DateRangeOption: string;
  PaymentRails: {
    [key: string]: string;
  };
};

export type TransactionFailureReason = 'administrative' | 'nsf' | 'unauthorized';

export type ReportDetailApiResponse = ApiResponse & {
  AccountSubscriptionDetail: {
    ID: string;
    VIOAccounts_ID: string;
    USRUsers_ID: string;
    ReportName: string;
    Description: string;
    IsActive: string;
    ScheduleType: ReportSchedule;
    DateFormat: string;
    DateAdded: string;
    LastModified: string;
    AccountTransactionReportType: AccountTransactionReportType;
    IncludeSubAccounts: string;
    IncludeGraph: string;
    DateRangeOption: string;
    FromDate: string;
    ToDate: string;
    RecipientEmails: string;
    Frequency: FrequencyType;
    FilterParams: {
      TransactionReportFailureReasons: {
        [key: string]: TransactionFailureReason;
      };
    };
    PaymentRails: {
      [key: string]: string;
    };
    AccountTransactionReports: {
      [key: string]: AccountTransactionReports;
    };
  };
};

type FrequencyType = 'daily' | 'weekly' | 'monthly' | '';

export type ReportDetailResponse = ApiResponse & {
  AccountSubscriptionDetail: {
    ID: string;
    VIOAccounts_ID: string;
    USRUsers_ID: string;
    ReportName: string;
    FromDate: string;
    ToDate: string;
    RecipientEmails: string;
    Description: string;
    IsActive: string;
    ScheduleType: ReportSchedule;
    Frequency: FrequencyType;
    DateFormat: string;
    DateAdded: string;
    LastModified: string;
    AccountTransactionReportType: AccountTransactionReportType | '';
    IncludeSubAccounts: boolean;
    IncludeGraph: boolean;
    DateRangeOption: string;
    PaymentRails: {
      [key: string]: string;
    };
    FilterParams: {
      TransactionReportFailureReasons: TransactionFailureReason[];
    };
    AccountTransactionReports: {
      [key: string]: AccountTransactionReports;
    };
  };
};

export type AccountTransactionReportType =
  | 'ApprovalActivityReport'
  | 'AccountTransactionHistoryReport'
  | 'AccountTransactionSummary'
  | 'AccountingSoftwareActivityReport'
  | 'EndOfDayBalance'
  | 'TransactionsPerPaymentRail'
  | 'TransactionSuccessAndFailureAnalysisReport'
  | 'InvoiceReport'
  | 'InterestReport'
  | 'GLCodeTransactionSummary'
  | 'GLCodeSummaryReport'
  | 'TransactionSummaryByCode'
  | 'TransactionCodeSummary'
  | 'TransactionFailureDetailReport';

export type ReportsRequest = PortalUser & {
  AccountTransactionReportType?: string;
  SubscriptionID?: string;
  ScheduleType?: string;
  PaymentRail?: string;
  SearchText?: string;
};

export type EditReportRequest = {
  PortalUser: string;
  SubscriptionID: string;
  IsActive?: string;
  ReportName?: string;
  Description?: string;
  DateFormat?: string;
  ScheduleType?: string;
  Frequency?: string;
  FromDate?: string;
  ToDate?: string;
};
type ReportSchedule = 'one-time' | 'subscription' | '';

export type CreateReportRequest = {
  PortalUser?: string;
  ReportName: string;
  Description: string;
  PaymentRails: string;
  ScheduleType: ReportSchedule;
  DateFormat: string;
  FromDate: string;
  ToDate: string;
  RecipientEmails: string;
  AccountTransactionReportType: AccountTransactionReportType | '';
  IncludeSubAccounts: boolean;
  IncludeGraph: boolean;
  DateRangeOption: string;
  TransactionReportFailureReasons: string;
};

export type DownloadReportRequest = {
  ReportID: string;
};

export type AccountVerificationRequest = {
  VerificationRequestID?: string;
  Token?: string;
  StartDateTime?: string;
  EndDateTime?: string;
  Timezone?: string;
  RequestStatus?: string;
  SearchText?: string;
  VerificationStatus?: string;
  ClientAccountID?: string;
  ContactID?: string;
};

export type VerificationRequestsList = {
  VerificationRequestID: string;
  VerificationType: 'bank' | 'interac';
  Amount: string;
  Details: {
    Credit: {
      FirstName: string;
      LastName: string;
    };
    Debit: {
      FirstName: string;
      LastName: string;
    };
    Bank: {
      AccountNumber: string;
      FinancialInstitutionId: string;
      Currency?: SupportedCurrencies;
    };
    EmailAddress: {
      AccountHolderName: string;
      EmailAddress: string;
    };
  };
  Status: {
    Transaction: {
      Credit: string;
      Debit: string;
    };
    Verification: string;
    Request: string;
  };
  VerificationAttempts: string;
  EmailAddress: {
    Sender: string;
    Receiver: string;
  };
  Link: string;
  LastModified: string;
};

export type AccountVerificationResponse = ApiResponse & {
  VerificationRequests: { [key: string]: VerificationRequestsList };
  PaginationMetaData?: PaginationMetaData;
};

export type AccountVerificationConfirmRequest = {
  VerificationRequestID: string;
  Amount: string;
  Token: string;
};

export type AccountVerificationConfirmResponse = ApiResponse & {
  ConfirmationStatus: boolean;
};

export type InitiateBankAccountVerificationRequest = {
  Country: string;
  VerificationMode: string;
  FirstName?: string;
  LastName?: string;
  ClientRefNumber: string;
  AccountNumber: string;
  InstitutionNumber: string;
  TransitNumber: string;
  SendEmail?: boolean;
  SenderEmailAddress?: string;
  ReceiverEmailAddress?: string;
  CompanyName?: string;
  ClientAccountID?: string;
  IntegrationType?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  PlaidAccountID?: string;
  PlaidProcessorToken?: string;
  InveriteRequestGUID?: string;
  MxAuthorizationCode?: string;
  FiservToken?: string;
  MxProcessorToken?: string;
  Token?: string;
  FlinksAccountId?: string;
  FlinksLoginId?: string;
  ABARoutingNumber?: string;
  Address1?: string;
  City?: string;
  State?: string;
  ZipCode?: string;
  PhoneNumber?: string;
};

export type VerifyInteracRequest = {
  EmailAddress: string;
  ClientAccountID?: string;
  ContactID?: string;
  AccountHolderName?: string;
  VerificationTier: 'basic' | 'enhanced';
};

export type VerifyInteracResponse = ApiResponse & {
  VerificationRequestID: string;
  ProvidedName: string;
  RegisteredName: string;
  VerificationStatus: string;
};

export type VerifyCardRequest = {
  CardToken: string;
  VerificationTier: 'basic' | 'enhanced';
};

export type VerifyCardResponse = ApiResponse & {
  VerificationRequestID: string;
  VerificationStatus: string;
  VerificationInfo?: {
    CardHolderName?: string;
    CardType?: string;
    CardBrand?: string;
    SendingEligibility?: PseudoBool;
    ReceivingEligibility?: PseudoBool;
    FundsAvailability?: string;
  };
};

export type InitiateBankAccountVerificationResponse = ApiResponse & {
  VerificationRequestID: string;
  Link: string;
};

export type ClientAccountLabel = {
  ID: string;
  Label: string;
};

export type FetchClientAccountLabelsRequest = {
  ClientAccountID?: string;
};

export type FetchContactLabelsRequest = {
  ContactID?: string;
};

export type FetchLabelsApiResponse = ApiResponse & {
  Labels: { [key: string]: ClientAccountLabel };
};

export type FetchLabelsResponse = ApiResponse & {
  Labels: ClientAccountLabel[];
};

export type AddClientAccountLabelRequest = {
  ClientAccountID: string;
  Label: string;
};

export type AddContactLabelRequest = {
  ContactID: string;
  Label: string;
};

export type AddLabelResponse = ApiResponse & {
  LabelID: string;
};

export type DeleteClientAccountLabelRequest = {
  ClientAccountID: string;
  Label: string;
};

export type DeleteContactLabelRequest = {
  ContactID: string;
  Label: string;
};

export type DeleteLabelResponse = ApiResponse;

export type GetDebitAuthorityAgreementRequest = {
  Language?: string;
};

export type GetDebitAuthorityAgreementResponse = ApiResponse & {
  AgreementTitle: string;
  AgreementContent: string;
};

export type CreateDebitAuthorityAgreementRequest = {
  AgreementTitle: string;
  AgreementContent: string;
  Language?: string;
};

export type VideoObject = {
  title: string;
  url: string;
  thumbnail: string;
  category: string;
  length: number;
  lastModified: string;
};
export type PortalVideoRequest = IsPartner;
export type PortalVideoResponse = {
  VideoList: { [key: string]: VideoObject };
  Categories: { [key: number]: { ID: number; Category: string } };
};

export enum BrandingProductType {
  Email = 'email',
  Elinx = 'elinx',
  Portal = 'portal',
  Onboarding = 'onboarding',
  crossborder = 'crossborder',
}

export type AccountBrandingRequest = PortalUser & {
  Token?: string;
  Product: BrandingProductType;
};

export type LoginBrandingApiResponse = ApiResponse & {
  BrandingDetails: {
    PrimaryColor?: string;
    SecondaryColor?: string;
  };
  Favicon: string;
  PageTitle: string;
  Logo: string;
};

export type LoginBrandingResponse = Omit<LoginBrandingApiResponse, 'PageTitle'> & {
  AppTitle: string;
};

export type AccountBrandingApiResponse = ApiResponse & {
  BrandingDetails: {
    // unused for now
    // ButtonTextColor: string;
    // TextColor: string;
    PrimaryColor: string;
    SecondaryColor: string;
  };
  Favicon: string;
  PageTitle: string;
  Logo: string;
  SmallLogo: string;
};

export type AccountBrandingResponse = Omit<AccountBrandingApiResponse, 'PageTitle'> & {
  AppTitle: string;
};

export type WorkflowApprover = {
  User: string;
  PaymentRails: string;
  Amount: string;
  IsAny: boolean;
};
export type WorkflowUsersResponse = ApiResponse & {
  admin: {
    [id: string]: string;
  };
  approvers: {
    [id: string]: WorkflowApprover;
  };
};
export type Workflow2 = {
  Id: number;
  Name: string;
  DateCreated: string;
  PaymentRails: string;
  Status: 'active' | 'inactive';
  NumberOfApprovers: number;
  MinimumAmount: string;
};
export type WorkflowResponse = ApiResponse & {
  Workflows: {
    [id: string]: Workflow2;
  };
};

/** -_- * */

export type ApprovalInboxTransactionsRequest = PortalUser & {
  StartDateTime?: string;
  EndDateTime?: string;
  Currency?: string;
  Frequency?: string;
  SearchText?: string;
};
export type ApprovalInboxTransaction = {
  Success: boolean;
  ErrorMessage: string;
  ID: number;
  FullName: string;
  TransactionType: TransactionType;
  Amount: number;
  NumberPayments: number;
  FileName: string;
  Currency: string;
  NumberApprovalsRequired: number;
  AvailableApprovers: number;
  NumberApproved: string;
  Approved: PseudoBool;
  TransactionDate: string;
  AccountName: string;
  AccountID: string;
  DocumentID: string | null;
  ELinxID: string;
};

export type ApprovalInboxTransactionsResponse = ApiResponse & {
  Transactions: {
    [key: string]: ApprovalInboxTransaction;
  };
  PaginationMetaData?: PaginationMetaData;
};

export type VerifyTransactionApproveRequest = PortalUser & {
  VerificationRequestID: string;
};

export type VerifyTrasnsactionApproveResponse = ApiResponse & {
  TransactionID: number;
};

export type InboxStatusChangeRequest = PortalUser & {
  TransactionID: number;
};
export type InboxRejectStatusChangeRequest = PortalUser & {
  TransactionID: number;
  Reason?: string;
};

export type TransactionApprovalRole = 'super admin' | 'approver';

export type UserRolesRequest = PortalUser & {
  Role: TransactionApprovalRole;
};

export type UserRoles = {
  USRUsers_ID: number;
  UserRoles_ID: number;
  Username: string;
  Role: string;
  MaxAmount: string | null;
  TransactionType: TransactionType;
  ApplyToAllSubaccounts: boolean;
};

export type UserRolesApiResponse = ApiResponse & {
  UserRolePermissions: {
    [key: string]: UserRoles;
  };
  Roles: {
    [key: string]: string;
  };
};

export type UserRolesResponse = ApiResponse & {
  UserRolePermissions: UserRoles[];
  Roles: string[];
};

export type ApproverLinkedAccount = {
  AccountID: string;
  APIAccountID: string;
  AccountName: string;
  Parent_ID: string;
};

export type FetchApproverLinkedAccountsRequest = {
  Username: string;
  TransactionApprovalRole?: TransactionApprovalRole;
};

export type FetchApproverLinkedAccountsApiResponse = ApiResponse & {
  Accounts: {
    [key: string]: ApproverLinkedAccount;
  };
};

export type FetchApproverLinkedAccountsResponse = ApiResponse & {
  Accounts: ApproverLinkedAccount[];
};

export type UpdateUserRoleRequest = PortalUser & {
  Role: string;
  Username: string;
  ApplyToAllSubaccounts?: boolean;
};

export type UpdateUserRolePermissionRequest = PortalUser & {
  Role: string;
  Username: string;
  TransactionType: string;
  MaxAmount?: number;
  SetNoMaxAmount?: boolean;
  ApplyToAllSubaccounts?: boolean;
};

export type WorkflowApi = {
  WorkflowID: string;
  NumberOfApprovalsRequired: number;
  MinAmount: string;
  MaxAmount: string | null;
  IsActive: PseudoBool;
  DateAdded: string;
  LastModified: string;
};

export type Workflow = Omit<WorkflowApi, 'IsActive'> & {
  IsActive: boolean;
};

export type WorkflowGroupApi = {
  TransactionType: TransactionTypesOptions;
  ApplyToAllSubaccounts: PseudoBool;
  Workflows: {
    [key: string]: WorkflowApi;
  };
};

export type WorkflowGroup = {
  TransactionType: TransactionTypesOptions;
  ApplyToAllSubaccounts: boolean;
  Workflows: Workflow[];
};

export type WorkflowsApiResponse = ApiResponse & {
  Workflows: {
    [key: string]: WorkflowGroupApi;
  };
};

export type WorkflowsResponse = ApiResponse & {
  Workflows: WorkflowGroup[];
};

export type WorkflowCreateRequest = PortalUser & {
  TransactionType: string;
  NumberApprovalsRequired: string;
  MinAmount: string;
  MaxAmount?: string | null;
  ApplyToAllSubaccounts?: boolean;
};
export type WorkflowUpdateRequest = PortalUser & {
  NumberApprovalsRequired?: string;
  MinAmount?: string;
  MaxAmount?: string | null;
  IsActive?: boolean;
  WorkflowID: Workflow['WorkflowID'];
  ApplyToAllSubaccounts?: boolean;
};
export type WorkflowDeleteRequest = PortalUser & {
  WorkflowID: string;
};
export type TransactionTypesRequst = PortalUser & {
  IsFunding?: number;
  IsWithdraw?: number;
  IsManual?: number;
  IsBillable?: number;
  CountriesID?: number;
  IsTransactionApprovalSupported?: number;
};

export type AccountPortalTransactionType = {
  ID: string;
  TransactionType: TransactionType;
  ADRCountries_ID: string | null;
  IsManual: boolean;
  IsBillable: boolean;
  IsFunding: boolean;
  IsWithdraw: boolean;
  DateAdded: string;
};
export type TransactionTypesResponseApi = ApiResponse & {
  TransactionTypes: {
    [key: string]: AccountPortalTransactionType;
  };
};
export type TransactionTypesResponse = ApiResponse & {
  TransactionTypes: AccountPortalTransactionType[];
};

export type SaveAccountBrandingRequest = PortalUser & {
  Token?: string;
  Product: BrandingProductType;
  PrimaryColor: string;
  SecondaryColor: string;
  Logo: string;
};

export type FAQResponse = ApiResponse & {
  FAQCategories: { [key: string]: FAQCategoryList };
};

export type FAQRequest = {
  QuestionID?: string;
};

export type FAQCategoryList = {
  ID: string;
  Category: string;
  Description: string;
  SubCategories: { [key: string]: FAQSubCategoryList };
};

export type FAQSubCategoryList = {
  ID: string;
  VIOFaqCategories_ID: string;
  SubCategory: string;
  Description: string;
  Questions: { [key: string]: FAQQuestionsList };
};

export type FAQQuestionsList = {
  ID: string;
  VIOFaqSubCategories_ID: string;
  Question: string;
  Answer: string;
  ClickCount: string;
};

export type FAQAllQuestionsResponse = ApiResponse & {
  FAQAllQuestions: { [key: string]: FAQAllQuestions };
};

export type FAQAllQuestions = {
  ID: string;
  Category: string;
  Description: string;
  SubCategoryID: string;
  SubCategory: string;
  SubCategoryDescription: string;
  QuestionID: string;
  Question: string;
  Answer: string;
  ClickCount: string;
};

export type FAQCategoriesResponse = ApiResponse & {
  FAQCategories: { [key: string]: FAQCategories };
};

export type FAQCategories = {
  ID: string;
  Category: string;
  Description: string;
  Position: string;
  IconBase64: string;
};

export type AccountBrandingLoginPageRequest = PortalUser & {
  HostName?: string;
};

export type BaseRailzeRequest = PortalUser & {
  BusinessName: string;
  ServiceName: string;
};

export type RailzBillsOrInvoicesRequest = BaseRailzeRequest & {
  Status?: 'open' | 'paid';
  StartDate: string;
  EndDate: string;
  Offset?: number;
  Limit?: number;
};

export type ChartOfAccount = {
  AccountRefID: string;
  Classification: string;
  Currency: string;
  DateAdded: string;
  Description: string;
  ID: string;
  LastModified: string;
  Name: string;
  Type: string;
};
export type ChartOfAccounts = {
  classification: string;
  currency: string;
  currentBalance: number;
  depth: number;
  description: string;
  fullyQualifiedName: string;
  group: string;
  id: string;
  isActive: boolean;
  isBankAccount: boolean;
  isSubAccount: boolean;
  name: string;
  section: string;
  sourceModifiedDate: string;
  subGroup: string;
  subSection: string;
  subType: string;
  type: string;
};
export type GetChartOfAccountRequest = BaseRailzeRequest & {
  Type: 'receivables' | 'payables';
};
export type ChartOfAccountRequest = BaseRailzeRequest & {
  Type: 'receivables' | 'payables';
  Account: ChartOfAccounts;
};
export type ChartOfAccountsResponse = ApiResponse & {
  Accounts: { [key: string]: ChartOfAccounts };
};
export type ChartOfAccountResponse = ApiResponse & {
  Account: ChartOfAccount;
};
export type RailzServiceNames =
  | 'dynamicsBusinessCentral'
  | 'freshbooks'
  | 'oracleNetsuite'
  | 'quickbooks'
  | 'sageBusinessCloud'
  | 'sageIntacct'
  | 'wave'
  | 'xero';
export type RailzBusinessAccount = {
  BusinessName: string;
  ServiceName: RailzServiceNames;
};
export type RailzBusinessAccountResponse = ApiResponse & {
  Accounts: { [key: string]: RailzBusinessAccount };
};
export type BillOrInvoiceRailzPaymentDetails = ApiResponse & {
  CreditAmount: string;
  PaymentMethod?: string;
  TransactionAmount: string;
  TransactionDate: string;
  TransactionID?: string;
};
export type BillOrInvoiceRailz = {
  AccountRef: string;
  Customer?: {
    BankAccount?: {
      AccountHolderName?: string;
      ABARoutingNumber?: string;
      AccountNumber?: string;
      BranchTransitNumber?: string;
      FinancialInstitutionNumber?: string;
      Token?: string;
      Type?: string;
      MaskedAccount?: string;
      Address?: string;
      City?: string;
      PostalCode?: string;
      Phone?: string;
      State?: string;
      ACTCurrencies_ID?: string;
    };
    Interac?: {
      RecipientName?: string;
      RecipientEmailAddress?: string;
      RecipientPhoneNumber?: string;
      Question?: string;
      Answer?: string;
      Language?: SupportedLanguages;
    };
    CreditCard?: {
      CreditCardToken?: string;
      CreditCardHolderName?: string;
      CreditCardNumber?: string;
      CreditCardExpiryYear?: string;
      CreditCardExpiryMonth?: string;
      CreditCardBrand?: string;
    };
    DebitCard?: {
      PushToCardToken?: string;
      CardHolderName?: string;
      CardNumber?: string;
      CardExpiryYear?: string;
      CardExpiryMonth?: string;
      CardBrand?: string;
      CardHolderEmail?: string;
    };
    CustomerRefID?: string;
    DateAdded?: string;
    Email?: string;
    LastModified?: string;
    Phone?: string;
    Status?: string;
    Type?: string;
    Name?: string;
    VIOBankAccounts_ID?: number;
  };
  customerRef?: {
    id: string;
    name: string;
  };
  vendorRef?: {
    id: string;
    name: string;
  };
  currencyRef?: {
    id: string;
  };
  payments?: Record<
    string,
    {
      paymentId: string;
      date: string;
      amount: string;
    }
  >;
  PaymentDetails: BillOrInvoiceRailzPaymentDetails[];

  currency: string;
  dueDate: string;
  postedDate: string;
  amountDue: string;
  status: string;
  FailureReason: string;
  invoiceNumber: string;
  vendorInvoiceNumber: string;
  subTotal: string;
  totalAmount: string;
  ScheduledDate: string;
  creditNotes?: string;
  id: string;
};

export type BillOrInvoiceRailzPost = {
  AccountRef: string;
  Customer?: {
    BankAccount?: {
      RoutingNumber?: string;
      AccountNumber?: string;
      BranchTransitNumber?: string;
      FinancialInstitutionNumber?: string;
      EmailAddress?: string;
      PhoneNumber?: string;
      City?: string;
      Address?: string;
      State?: string;
      ZipCode?: string;
      ACTCurrencies_ID?: number;
      IdentificationNumber?: string;
    };
    Interac?: {
      EmailAddress?: string;
      PhoneNumber?: string;
      Question?: string;
      Answer?: string;
      Language?: SupportedLanguages;
    };
    CreditCard?: {
      Token?: string;
      CreditCardNumber?: string;
      CreditCardExpiryYear?: string;
      CreditCardExpiryMonth?: string;
      CreditCardBrand?: string;
    };
    DebitCard?: {
      Token?: string;
      CardNumber?: string;
      CardExpiryYear?: string;
      CardExpiryMonth?: string;
      CardBrand?: string;
    };

    CustomerRefID?: string;
    DateAdded?: string;
    Email?: string;
    LastModified?: string;
    Phone?: string;
    Status?: string;
    Type?: string;
    Name?: string;
    VIOBankAccounts_ID?: number;
  };
  customerRef?: {
    id: string;
    name: string;
  };
  vendorRef?: {
    id: string;
    name: string;
  };
  currencyRef?: {
    id: string;
  };
  payments?: Record<
    string,
    {
      paymentId: string;
      date: string;
      amount: string;
    }
  >;
  PaymentDetails: BillOrInvoiceRailzPaymentDetails[];

  currency: string;
  dueDate: string;
  postedDate: string;
  amountDue: string;
  status: string;
  FailureReason: string;
  invoiceNumber: string;
  vendorInvoiceNumber: string;
  subTotal: string;
  totalAmount: string;
  id: string;
  PaymentRail: 'eft' | 'interac' | 'ach' | 'creditcard' | 'aft' | 'vopayinstant' | 'rtp' | 'oct';
  PaidAmount: string;
  scheduledDate?: string;
  creditNotes?: string;
};

export type TemporaryBillsOrInvoicesRails = BillOrInvoiceRailzPost & {
  hasBankAccount: boolean;
  hasInterac: boolean;
  hasCreditCard: boolean;
  hasDebitCard: boolean;
  isSelected: boolean;
  isExpanded: boolean;
  paymentMethodUser: string;
};
export type BillOrInvoice = {
  VIORailzBusinessAccounts_ID: string;
  VIORailzCustomerAccounts_ID: string;
  VIOAccountTransactions_ID: string;
  InvoiceRefID?: string;
  AccountRefID: string;
  InvoicePaymentRefID: string;
  BillRefID?: string;
  Name: string;
  Email: string;
  Phone: string;
  DateAdded: string;
  LastModified: string;
  PaymentMethod: string;
  Currency: string;
  CurrencyRate: number;
  Status: string;
  Amount: number;
  PaymentRail: string;
};
export type PayInvoicesRequest = BaseRailzeRequest & {
  Invoices: BillOrInvoiceRailzPost[];
};
export type PayBillsRequest = BaseRailzeRequest & {
  Bills: BillOrInvoiceRailzPost[];
};
export type InvoicesResponse = ApiResponse & {
  Invoices: { [key: number]: BillOrInvoice };
};
export type RailzInvoicesResponse = ApiResponse & {
  Invoices?: BillOrInvoiceRailz[];
};
export type RailzInvoicesApiResponse = ApiResponse & {
  Invoices?: BillOrInvoiceRailz[];
};
export type BillsResponse = ApiResponse & {
  Bills: { [key: number]: BillOrInvoice };
};

export type RailzBillsResponse = ApiResponse & {
  Bills?: BillOrInvoiceRailz[];
};
export type RailzBillsApiResponse = ApiResponse & {
  Bills?: BillOrInvoiceRailz[];
};
export type RailzStatusSyncData = ApiResponse & {
  SyncStatus: string;
  MostRecentUpdateDate: string | null;
};

export type RailzBillsCancelRequest = {
  BillRefID: string;
};
export type RailzInvoiceCancelRequest = {
  InvoiceRefID: string;
};

export type PortalDocumentRequest = {
  FileName: string;
};

export type PortalDocument = {
  category: string;
  lastModified: string;
  title: string;
  url: string;
  thumbnail: string;
};

export type PortalDocumentResponse = {
  Documents: { [key: number]: PortalDocument };
  Categories: { [key: number]: { ID: number; Category: string } };
};

export type ElinxNotificationSettings = {
  SendNotification?: boolean;
  SendReminder?: boolean;
  ReminderFrequency?: string;
  NotificationMethod?: ElinxNotificationMethod;
};

export type PaymentFields = ElinxNotificationSettings & {
  ABARoutingNumber: string;
  AccountConnectionMethod: string;
  AccountNumber: string;
  Address1: string;
  Address2: string;
  Amount?: number;
  Answer: string;
  BranchTransitNumber: string;
  City: string;
  ClientAccount?: string;
  ClientReferenceNumber: string;
  CompanyName: string;
  Contact?: string;
  ContactType: string;
  Country: string;
  Currency?: string;
  Description?: string;
  EndDate?: string;
  Ending?: string;
  EndingAfterPayments?: string;
  EtransferConnectionType: string;
  FinancialInstitutionNumber: string;
  FirstName: string;
  Frequency?: string;
  IdentificationNumber?: string;
  InvoiceNumber?: string;
  LastName: string;
  Message?: string;
  MessageForRecipient?: string;
  Nickname: string;
  Notes?: string;
  PaymentMethod: string | 'new';
  BankingPaymentRail?: BankingPaymentRail;
  PostalCode: string;
  ProvideOrRequestPaymentInformation?: string;
  Province: string;
  Question: string;
  RecipientEmailAddress: string;
  RecipientName: string;
  RecipientPhoneNumber: string;
  ScheduleType?: string;
  SemiMonthlyDates?: string;
  SendEmail: boolean;
  SenderName?: string;
  StartDate?: string;
  TakeFromAccountOn?: string;
  TransactionLabel?: string;
  CancellationPeriod?: number;
  NewEmailAddress?: string;
  NewPhoneNumber?: string;
  PaymentMethodDisplayOptions?: PaymentMethodDisplayOptions;
  PaymentSelectionMethod?: ELinxConnectionMethod | string; // Can be a comma separated list of ELinxConnectionMethod values
  AccountSelectionMethod?: string;
  RecipientMessage?: string;
  ReceiverPhoneNumber?: string;
  ReceiverEmailAddress?: string;
  TransactionCode?: string;
  GLCode?: string;
  InvoiceFile?: string;
  InvoiceFileName?: string;
  AutoDepositEnabled?: boolean;
  SecCode?: SecCode;
  AcceptedCardBrands?: string;
  CardTypeValidation?: boolean;
  BankPhoneNumber?: string;
};

export type TicketAttachmentRequest = {
  TicketID: string;
  TicketAttachment: string;
  AttachmentFileName: string;
};
export type TicketAttachmentResponse = ApiResponse & {
  Response: string;
};
export type AutoBalanceTransferTransaction = {
  TransactionID: string;
  TransactionType: string;
  TransactionDate: string;
  CreditAmount: string;
  DebitAmount: string;
  FullName: string;
  ReferenceNo: string;
};
export type AutoBalanceTransferReportResponse = ApiResponse & {
  Transactions: { [key: string]: AutoBalanceTransferTransaction };
};

type RequestWithPagination = {
  Limit?: number;
  Offset?: number;
};

export type ContactsRequest = RequestWithPagination & {
  ContactID?: string;
  // Limit?: number;
  // Offset?: number;
  SearchText?: string;
  IsBusiness?: boolean;
  Label?: string;
  AccountStatus?: boolean; // IsActive; yeah, weird...
};

export type SingleContactApiResponse = AdditionalApiContacts & {
  ContactID: string;
  ContactName: string;
  EmailAddress: string;
  PhoneNumber: string;
  Language: string;
  IsActive: string;
  Currency: string;
  IsBusiness: boolean;
  Address1: string;
  Address2: string;
  City: string;
  Province: string;
  Country: string;
  PostalCode: string;
  Labels: string; // comma-separated list
};

export type SingleContact = AdditionalContacts & {
  ContactID: string;
  ContactName: string;
  EmailAddress: string;
  PhoneNumber: string;
  Language: string;
  IsActive: boolean;
  Currency: string;
  IsBusiness: boolean;
  Address1: string;
  Address2: string;
  City: string;
  Province: string;
  Country: string;
  PostalCode: string;
  Labels: string[];
};

type ResponseWithPagination = {
  PaginationMetaData: PaginationMetaData;
};

export type ContactsApiResponse = ApiResponse &
  ResponseWithPagination & {
    Contacts: { [key: string]: SingleContactApiResponse };
  };

export type ContactsResponse = ApiResponse &
  ResponseWithPagination & {
    Contacts: SingleContact[];
  };

export type GlobalSendRecentTransactionApi = {
  RecipientContactID: string;
  CorridorID: string;
  Amount: string;
  CustomerCreditedAmount: string;
  DeliveryMethodID: string;
  DeliveryMethodToken: string;
  DeliveryMethodType: string;
  DestinationCountryAbbreviation: string;
  Status: TransactionStatus;
  TransactionDate: string;
  TransactionID: string;
  BusinessName: string;
  FirstName: string;
  LastName: string;
  PaymentType: 'buy' | 'sell';
  FeesIncluded: PseudoBool;
  FXRate: string;
  PrincipalAmount: string;
  RecipientAddress1: string;
  RecipientAddress2: string;
  RecipientAddressCity: string;
  RecipientAddressCountry: string;
  RecipientAddressPostalCode: string;
  RecipientAddressProvince: string;
  RecipientBusinessName: string;
  RecipientCurrency: SupportedXBCurrencies;
  RecipientEmailAddress: string;
  RecipientFirstName: string;
  RecipientGovernmentIds: string;
  RecipientLastName: string;
  RecipientName: string;
  RecipientNationality: string;
  RecipientPhone: string;
  SenderAddress1: string;
  SenderAddress2: string;
  SenderAddressCity: string;
  SenderAddressCountry: string;
  SenderAddressPostalCode: string;
  SenderAddressProvince: string;
  SenderBusinessName: string;
  SenderCurrency: SupportedXBCurrencies;
  SenderDateOfBirth: string;
  SenderEmailAddress: string;
  SenderFirstName: string;
  SenderGovernmentIds: string;
  SenderLastName: string;
  SenderNationality: string;
  SenderOccupation: string;
  SenderPurposeOfPayment: string;
  SenderRelationshipWithBeneficiary: string;
  SenderSourceOfIncome: string;
  FailureReason: string;
  CashoutCode: string;
  EWalletID: string;
  ServiceProvider: MobileWalletBrand;
  TelephoneNumber: string;
  FundingOption: PaymentRailType;
  FundingOptionProcessingTime: ProcessingTime;
  FundingOptionTransactionFee: string;
  GLCode: string;
  PaymentRailID: string;
  TransactionTypeCode: string;
};
export type GlobalSendRecentTransaction = Omit<GlobalSendRecentTransactionApi, 'FeesIncluded'> & {
  FeesIncluded: boolean;
};

export type GlobalSendRecentTransactionsRequest = {
  StartDateTime?: string;
  EndDateTime?: string;
  TransactionID?: string;
  Limit?: number;
  Timezone?: string;
  ClientAccountID: string;
};

export type GlobalSendRecentTransactionsResponse = ApiResponse & {
  Transactions: GlobalSendRecentTransaction[];
};

export type GlobalSendRecentTransactionsApiResponse = ApiResponse & {
  Transactions: {
    [key: string]: GlobalSendRecentTransactionApi;
  };
};

export type CrossBorderUrlRequest = {
  ClientAccountID: string;
  ClientName: string;
  ClientReferenceNumber: string;
  Language: string;
  DarkMode: boolean;
};

export type CrossBorderUrlResponse = ApiResponse & {
  Link: string;
};

export type SingleUseTokenApplicationType =
  | 'paylink'
  | 'renewal'
  | 'verification'
  | 'crossborder'
  | 'client-account-creation'
  | 'contact-creation'
  | 'gcm-contact-creation'
  | 'dispute-management'
  | 'crossborder-admin'
  | 'approval-transaction'
  | 'verification';

export type CrossBorderUrlInfoRequest = {
  Token: string;
  ApplicationType: SingleUseTokenApplicationType;
};

export type GlobalSendAdminUrlInfoRequest = {
  Token: string;
};

export type CrossBorderBranding = {
  ActivationDate: string;
  ButtonTextColor: string;
  DateAdded: string;
  DeactivationDate: string;
  ID: string;
  IsActive: string;
  LastModified: string;
  PrimaryColor: string;
  Product: string;
  SecondaryColor: string;
  TextColor: string;
  VIOAccountDocuments_ID: string;
  VIOAccounts_ID: string;
  VIOPartnerAccounts_ID: string;
};

// TODO: update once we have the shape from the b/e
export type FundingOption = Record<string, string>;
export type UseCase = 'B2B' | 'B2P' | 'P2P' | 'P2B';
export type DeliveryMethodType = 'Bank Account' | 'Mobile Wallet' | 'Cash Pick-Up' | 'Payment Card';

export type CrossBorderUrlApiInfoResponse = ApiResponse & {
  ClientName: string;
  IsTechnology: boolean;
  Language: string;
  DarkMode: boolean;
  ClientAccountID?: string;
  ContactID?: string;
  JWT: string;
  ClientType: 'individual' | 'business';
  ClientAccountsEnabled: PseudoBool;
  DeliveryMethodToken: string;
  DeliveryMethodType: DeliveryMethodType | '';
  DeliveryChannelID: string;
  RecipientContactID: string;
  SellAmount: string;
  BuyAmount: string;
  FundingOptions?: Record<string, FundingOption>;
  StylesheetUrl: string;
  Country: SupportedXBCountries;
  UseCase: UseCase | '';
};

export type CrossBorderUrlInfoResponse = ApiResponse &
  Omit<CrossBorderUrlApiInfoResponse, 'FundingOptions' | 'ClientAccountsEnabled'> & {
    FundingOptions: FundingOption[];
    ClientAccountsEnabled: boolean;
  };

export type GlobalSendAdminUrlInfoResponse = ApiResponse & {
  ApplicationType: SingleUseTokenApplicationType;
  ClientAccountsEnabled: boolean;
  ExtraInfo: Record<string, unknown>;
  JWT: string;
  Token: string;
  PartnerName: string;
  PartnerAccountID: string;
};

export type GenerateEmbedUrlDisputeManagementRequest = {
  AccountID?: string;
  ManageDisputesEnabled?: boolean;
};

export type GenerateEmbedUrlDisputeManagementResponse = ApiResponse & {
  Link: string;
};

export type DisputeManagementUrlInfoRequest = {
  Token: string;
};

export type FeatureName = 'ChallengeDispute' | 'AcceptDispute' | 'RespondDispute' | 'AddNote';
export type DisputePermission = 'ManageDisputes';

export type DisputeManagementUrlInfoResponse = ApiResponse & {
  ApplicationType: Extract<SingleUseTokenApplicationType, 'dispute-management'>;
  ExtraInfo: Record<string, unknown>;
  JWT: string;
  Token: string;
  PartnerName: string;
  PartnerAccountID: string;
  Processor: 'globalpay' | 'worldpay';
  FeatureList: FeatureName[];
  Permissions?: DisputePermission[];
};

export type CreditNotesInvoicesRequest = BaseRailzeRequest & {
  CustomerRefID: string;
};
export type CreditNotesBillsRequest = BaseRailzeRequest & {
  VendorRefID: string;
};

export type CrossBorderCountriesRequest = {
  UseCase?: UseCase | '';
};

export type Country = {
  CorridorID: string;
  Country: string;
  DestinationCountryAbbreviation: SupportedXBCountries;
};

export type CrossBorderCountriesResponse = ApiResponse & {
  Countries: Country[];
};

export type CrossBorderCountriesApiResponse = ApiResponse & {
  Countries?: { [key: string]: Country };
};

export type DeliveryChannelsFieldsRequest = {
  DeliveryChannelID: string;
  FieldFor?: 'sender' | 'recipient';
};

export type DeliveryChannelFieldApi = {
  FieldFor: string;
  FieldID: string;
  InputType: 'text' | 'options' | 'number';
  Label: string;
  Options: string | null;
  Group: 'user-info' | 'address' | 'delivery-method' | 'government-identifier';
  GroupOrder: string;
  RequirementStatus: 'optional' | 'required';
};

export type DeliveryChannelField = {
  FieldFor: string;
  FieldID: string;
  InputType: 'text' | 'options' | 'number' | 'date' | 'tel' | 'email';
  Label: string;
  Group: 'user-info' | 'address' | 'delivery-method' | 'government-identifier';
  GroupOrder: number;
  Options: string | null;
  RequirementStatus: 'optional' | 'required';
};

export type DeliveryChannelsFieldsApiResponse = ApiResponse & {
  DeliveryChannelFields?: { [key: string]: DeliveryChannelFieldApi };
};

export type DeliveryChannelsFieldsResponse = ApiResponse & {
  DeliveryChannelFields: DeliveryChannelField[];
};

export type DeliveryChannelsFieldsDataRequest = {
  ClientAccountID: string;
  RecipientContactID?: string;
};

export type DeliveryChannelFieldData = {
  RelationshipWithBeneficiary: string;
  PurposeOfPayment: string;
  BusinessName: string;
  FirstName: string;
  LastName: string;
  Address1: string;
  Address2: string;
  City: string;
  PostalCode: string;
  Country: string;
  Province: string;
  PhoneNumber: string;
  EmailAddress: string;
  Nationality: string;
  Occupation: string;
  SourceOfIncome: string;
  DateOfBirth: string;
  IssuingAbbreviation: string;
  IssuingCountry: string;
};

export type DeliveryChannelsFieldsDataResponse = ApiResponse & {
  DeliveryChannelFieldsData: DeliveryChannelFieldData;
};

export type DeliveryChannelsRequest = {
  CorridorID: string;
  UseCase?: string;
};

export type SupportedXBCurrencies =
  | 'CAD'
  | 'AUD'
  | 'HKD'
  | 'USD'
  | 'NZD'
  | 'MXN'
  | 'EUR'
  | 'GBP'
  | 'EGP'
  | 'JPY'
  | 'CNY'
  | 'BDT'
  | 'BRL'
  | 'DOP'
  | 'GHS'
  | 'INR'
  | 'JMD'
  | 'KES'
  | 'KRW'
  | 'LKR'
  | 'PHP'
  | 'ZAR'
  | 'THB'
  | 'VND'
  | 'IDR'
  | '';

export type SupportedXBCountries =
  | 'AUS'
  | 'BGD'
  | 'BRA'
  | 'CAN'
  | 'CHN'
  | 'DOM'
  | 'GHA'
  | 'HKG'
  | 'IND'
  | 'JAM'
  | 'JPN'
  | 'KEN'
  | 'KOR'
  | 'MEX'
  | 'PHL'
  | 'AND'
  | 'AUT'
  | 'BEL'
  | 'BGR'
  | 'HRV'
  | 'CYP'
  | 'CZE'
  | 'DNK'
  | 'EST'
  | 'FIN'
  | 'FRA'
  | 'DEU'
  | 'GRC'
  | 'HUN'
  | 'IRL'
  | 'ISL'
  | 'ITA'
  | 'LVA'
  | 'LIE'
  | 'LTU'
  | 'LUX'
  | 'MLT'
  | 'MCO'
  | 'NLD'
  | 'NOR'
  | 'POL'
  | 'PRT'
  | 'ROU'
  | 'SMR'
  | 'SVK'
  | 'SVN'
  | 'ESP'
  | 'SWE'
  | 'CHE'
  | 'GBR'
  | 'VAT'
  | 'ZAF'
  | 'LKA'
  | 'THA'
  | 'USA'
  | 'VNM'
  | 'EGY'
  | 'IDN'
  | '';

export type DeliveryMethodTypeDetailType = 'swift' | 'iban' | 'routing-number' | 'bank-code' | 'clearing-code' | 'ifsc';

export type DeliveryChannel = {
  DeliveryChannelID: string;
  DeliveryMethodType: DeliveryMethodType | '';
  DeliveryMethodTypeDetails: DeliveryMethodTypeDetailType;
  UseCase: UseCase | '';
  DeliveryFee: string;
  DestinationServiceTag: string;
  Currency: string;
  ShortForm: SupportedXBCurrencies;
  HomeCurrency: string;
  HomeShortForm: SupportedXBCurrencies;
  /**
   * This value is random some potential values are:
   *
   * PesoNet: 1:45 pm local time (M-F)
   * PDDTS: 12:45 pm (M-F)
   * To Lank Bank account: 10:45 pm (M-Su)
   * 9:45 pm local time (M-F)
   *
   * 13:45 pm CET (M-F)
   *
   * 24/7
   *
   * No Cut Off Time (M-Su)
   */
  CutOffTime: string;
  DeliveryTimeNotes: string;
  Notes: string;
};

export type DeliveryChannelsApiResponse = ApiResponse & {
  DeliveryChannels: { [key: string]: DeliveryChannel };
};

export type DeliveryChannelsResponse = ApiResponse & {
  DeliveryChannels: DeliveryChannel[];
};

export type CrossBorderQuotesRequest = {
  BuyAmount?: string | number;
  SellAmount?: string | number;
  DeliveryChannelID: string;
  ClientAccountID: string;
  ContactID?: string;
  FeesIncluded: boolean;
};

export type Quote = {
  ChargedAmount: string;
  CreditedAmount: string;
  CrossborderQuoteID: string;
  DeliveryFee: string;
  ExpiryTime: string;
  FXRate: string;
  MidMarketRate: string;
  HasSufficientFunds: boolean;
  PrincipalAmount: string;
  ServiceFee: string;
};

export type CrossBorderQuotesResponse = ApiResponse & {
  Quote: Quote;
};

export type CrossBorderRecipientContactsRequest = {
  RecipientContactID?: string;
  Limit?: string;
  AccountStatus?: string;
  ClientAccountID: string;
};

export type CrossBorderRecipientContactApi = {
  Address: string;
  City: string;
  Country: SupportedXBCountries;
  PostalCode: string;
  Province: string;
  BusinessName: string;
  RecipientContactID: string;
  ContactClientType: 'business' | 'individual';
  EmailAddress: string;
  FirstName: string;
  IsFavorite: PseudoBool;
  LastName: string;
  PhoneNumber: string;
  DeliveryMethod?: string;
  DeliveryMethodType?: string;
};

export type CrossBorderRecipientContactsApiResponse = ApiResponse & {
  RecipientContacts: { [key: string]: CrossBorderRecipientContactApi };
};

export type CrossBorderRecipientContact = Omit<CrossBorderRecipientContactApi, 'IsFavorite'> & {
  IsFavorite: boolean;
  AddressDetails: {
    Address: string;
    City: string;
    Country: SupportedXBCountries;
    PostalCode: string;
    Province: string;
  };
};

export type CrossBorderRecipientContactsResponse = ApiResponse & {
  RecipientContacts: CrossBorderRecipientContact[];
};

export type AddFavoriteRecipientContactRequest = {
  ClientAccountID: string;
  RecipientContactID: string;
};

export type AddFavoriteRecipientContactResponse = ApiResponse & {
  RecipientContactID: string;
};

export type DeleteFavoriteRecipientContactRequest = {
  ClientAccountID: string;
  RecipientContactID: string;
};

export type DeleteFavoriteRecipientContactResponse = ApiResponse & {
  RecipientContactID: string;
};

export type RecipientContactDeliveryMethodsRequest = {
  DeliveryChannelID?: string;
  RecipientContactID?: string;
  ClientAccountID?: string;
};

export type ContactDeliveryMethod = {
  AccountType: string;
  BankAccountNumber: string;
  BankCode: string;
  BankIdentifierCode: string;
  BankName: string;
  BranchName: string;
  DeliveryChannelID: string;
  DeliveryFee: string;
  DeliveryMethodToken: string;
  DeliveryMethodType: DeliveryMethodType;
  DestinationAbbreviation: string;
  DestinationCountry: string;
  DestinationCountryCode: string;
  EWalletID: string;
  InternationalBankAccountNumber: string;
  ServiceProvider: MobileWalletBrand;
  TelephoneNumber: string;
};

export type RecipientContactDeliveryMethodsApiResponse = ApiResponse & {
  DeliveryMethods: {
    [key: string]: ContactDeliveryMethod;
  };
};

export type RecipientContactDeliveryMethodsResponse = ApiResponse & {
  DeliveryMethods: ContactDeliveryMethod[];
};

export type AddRecipientRequest = {
  ContactClientType: 'individual' | 'business';
  EmailAddress: string;
  PhoneNumber: string;
  FirstName: string;
  LastName: string;
  BusinessName: string;
  Country: string;
  Address1: string;
  Address2: string;
  City: string;
  Province: string;
  PostalCode: string;
  Language: string;
  Nationality: string;
  ClientAccountID: string;
};

export type AddRecipientResponse = ApiResponse & {
  RecipientContactID: string;
};

export type CreditNoteDetail = {
  description: string;
  unitAmount: number;
  quantity: number;
  amount: number;
  accountRef: {
    id: string;
    name: string;
  };
  taxRateRef: {
    id: string;
  };
  inventoryRef: {
    id: string;
    name: string;
  };
  trackingCategoryRefs?: {
    [key: string]: {
      id: string;
      name: string;
      type: string;
    };
  };
};
export type CreditNote = {
  id: string;
  customerRef?: {
    id: string;
    name: string;
  };
  vendorRef?: {
    id: string;
    name: string;
  };
  postedDate: string;
  currency: string;
  lines: {
    [key: string]: CreditNoteDetail;
  };
  subTotal: number;
  taxAmount: number;
  totalAmount: number;
  remainingCredit: number;
  status: string;
  sourceModifiedDate: string;
};
export type CreditNotesApiResponse = ApiResponse & {
  CreditNotes: { [key: number]: CreditNote };
};
export type CreditNotesResponse = ApiResponse & {
  CreditNotes: CreditNote[];
};

export type CrossBorderBankCitiesRequest = {
  Country: string;
  BankName?: string;
};
export type CrossBorderBankCitiesApiResponse = ApiResponse & {
  BankCities: {
    [key: string]: string;
  };
};
export type CrossBorderBankCitiesResponse = ApiResponse & {
  BankCities: string[];
};

export type CrossBorderBankNamesRequest = {
  Country: string;
  City?: string;
};
export type CrossBorderBankNamesApiResponse = ApiResponse & {
  BankNames: {
    [key: string]: string;
  };
};
export type CrossBorderBankNamesResponse = ApiResponse & {
  BankNames: string[];
};

export type CrossBorderBankBranchesRequest = {
  Country: string;
  City?: string;
  BankName?: string;
};
export type CrossBorderBankBranchesApiResponse = ApiResponse & {
  BankBranches: {
    [key: string]: string;
  };
};
export type CrossBorderBankBranchesResponse = ApiResponse & {
  BankBranches: string[];
};

export type CrossBorderBankLocationsRequest = {
  Country: string;
  City: string;
  BankName: string;
  BranchName?: string;
};
export type CrossBorderBankLocation = {
  BicCode: string;
  BankName: string;
  BranchName: string;
  Address: string;
  City: string;
  State: string;
  Phone: string;
};
export type CrossBorderBankLocationsApiResponse = ApiResponse & {
  BankLocations: {
    [key: string]: CrossBorderBankLocation;
  };
};
export type CrossBorderBankLocationsResponse = ApiResponse & {
  BankLocations: CrossBorderBankLocation[];
};

export type CrossBorderAddDeliveryMethodRequest = {
  ClientAccountID: string;
  RecipientContactID: string;
  DeliveryChannelID: string;
  BankName?: string;
  BankCode?: string;
  BranchName?: string;
  CashoutCode?: string;
  AccountType?: string;
  BankAccountNumber?: string;
  BankIdentifierCode?: string;
  InternationalBankAccountNumber?: string;
  EWalletID?: string;
  TelephoneNumber?: string;
  SP?: string;
  PAN?: string;
  EXP?: string;
  TEL?: string;
};
export type CrossBorderAddDeliveryMethodResponse = ApiResponse & {
  DeliveryMethodToken: string;
};
export type EditRecipientRequest = {
  ClientAccountID: string;
  RecipientContactID: string;
  EmailAddress: string;
  PhoneNumber: string;
  FirstName: string;
  LastName: string;
  BusinessName: string;
  Country: string;
  Address1: string;
  Address2?: string;
  City: string;
  Province: string;
  PostalCode: string;
  SourceOfIncome?: string;
  Occupation?: string;
  Nationality?: string;
};
export type EditRecipientResponse = ApiResponse & {
  RecipientContactID: string;
};

export type GovernmentIdentifierRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  RecipientContactID?: string;
  CorridorID?: string;
};

export type GovernmentIdentifierType =
  | 'Passport Number'
  | 'Social Security Number'
  | 'Employer Identification Number'
  | 'Tax Identification Number'
  | 'Alien Registration Number'
  | 'Customer Number'
  | 'Identity Card Number'
  | 'Drivers License Number';

export type GovernmentIdentifier = {
  CorridorID: string;
  GovernmentIdentifierToken: string;
  ExpirationDate: string;
  GovernmentIdentifierType: GovernmentIdentifierType;
  IDNumber: string;
  IssueDate: string;
  IssuingCountry: string;
  IssuingAbbreviation: string;
  IssuingCountryCode: string;
};
export type GovernmentIdentifierApiResponse = ApiResponse & {
  GovernmentIdentifiers?: { [key: string]: GovernmentIdentifier };
};
export type GovernmentIdentifierResponse = ApiResponse & {
  GovernmentIdentifiers: GovernmentIdentifier[];
};
export type GovernmentIdentifierSchemaValue = {
  [label: string]: string;
};
export type GovernmentIdentifierSchemaRequirements = {
  [label: string]: {
    regex?: string;
    description?: string;
  };
};
export type GovernmentIdentifierSchemasResponse = ApiResponse & {
  GovernmentIdentifierSchemaValues: {
    AllowedTypes: GovernmentIdentifierSchemaValue;
    Requirements: GovernmentIdentifierSchemaRequirements;
  };
};
export type GovernmentIdentifierSchemasRequest = {
  DeliveryChannelID?: string;
};
export type AddGovernmentIdentifierRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  RecipientContactID?: string;
  CorridorID: string;
  GovernmentIdentifierSchema: string;
  IDNumber: string;
  ExpirationDate: string;
  IssueDate: string;
  IssuingCountry: string;
};
export type AddGovernmentIdentifierResponse = ApiResponse & {
  GovernmentIdentifierToken: string;
};

export type CreateGlobalSendTransactionRequest = {
  CrossborderQuoteID: string;
  PurposeOfPayment: string;
  DeliveryMethodToken: string;
  RelationshipWithBeneficiary?: string;
  ParentTransactionID?: string;
};

export type CreateGlobalSendTransactionResponse = ApiResponse & {
  TransactionID: string;
};
export type EditContactRequest = {
  ContactID: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  FirstName?: string;
  LastName?: string;
  BusinessName?: string;
  SourceOfIncome?: string;
  Occupation?: string;
  DateOfBirth?: string;
  DOB?: string;
  Nationality?: string;
  OtherProvince?: string;
} & Partial<Address>;

export type BankSchemaRequest = {
  Country: string;
};
export type BankSchemaApiResponse = ApiResponse & {
  BanksSchemaValues?: {
    [key: string]: string;
  };
};
export type BankSchemaResponse = ApiResponse & {
  BanksSchemaValues: string[];
};

export type ContactVerificationConfirmRequest = {
  Token: string;
  OTP: string;
};

export type ContactVerificationConfirmResponse = ApiResponse & {};

export type GenerateOtpRequest = {
  SingleUseToken: string;
  PhoneNumber: string;
};

export type GenerateOtpResponse = ApiResponse & {
  Expiration: string;
};

export type ValidateOtpRequest = {
  SingleUseToken: string;
  OTP: string;
};

export type ElinxPaymentMethodsRequest = {
  SingleUseToken: string;
  Currency: SupportedCurrencies;
};

export type PaymentMethodType =
  | 'BankAccount'
  | 'CreditCard'
  | 'DebitCard'
  | 'PhoneNumber'
  | 'Email'
  | 'GooglePay'
  | 'ApplePay'
  | 'PayPal'
  | 'Venmo';
export type VerificationStatus = 'unverified' | 'verified' | 'failed';
export type CardBrand =
  | 'visa'
  | 'mastercard'
  | 'amex'
  | 'diners'
  | 'discover'
  | 'unionpay'
  | 'jcb'
  | 'uatp'
  | 'unknown';

export type ElinxPaymentMethodsApiResponse = ApiResponse & {
  PaymentMethods: { [key: string]: PaymentMethod };
};

export type ElinxPaymentMethodsResponse = ApiResponse & {
  PaymentMethods: PaymentMethod[];
};

export type RequirePadAgreementRequest = {
  PaymentMethod: string;
  Token: string;
};

export type RequirePadAgreementResponse = ApiResponse & {
  RequiresPADAgreement: boolean;
};

export type AcceptAgreementRequest = {
  // defaults to 'terms-of-service' if Type is not provided
  LegalDocumentType?: 'terms-of-service' | 'debit-authority-agreement' | 'privacy-policy';
};

export type InterestAccountRequest = {
  InterestMaturityType?: InterestTerm;
};
export type InterestAccountApiResponse = ApiResponse & {
  InterestAccounts: { [key: string]: InterestAccount };
};
export type InterestAccountResponse = ApiResponse & {
  InterestAccounts: InterestAccount[];
};
export type InterestAccount = {
  AccountName: string;
  InterestMaturityType: InterestTerm;
  CurrentBalance: number;
  InterestAccrued: number;
  EligibleBalance: number;
};
export type InterestAccountDetailRequest = {
  InterestMaturityType?: InterestTerm;
  Month?: string;
  Year?: string;
  StartDate?: string;
  EndDate?: string;
  Timezone?: string;
};
export type InterestAccountDetailApiResponse = ApiResponse & {
  InterestAccrued: { [key: string]: InterestAccruedDetail };
};
export type InterestAccountDetailResponse = ApiResponse & {
  InterestAccruedDetails: InterestAccruedDetail[];
};
export type InterestAccruedDetail = {
  DateAccrued: string;
  AmountAccrued: string;
  Rate: string;
  BalanceForCalculation: string;
  InterestMaturityType: InterestTerm;
};
export type InterestAccountTransferRequest = {
  PaymentType: string;
  Amount: string;
  Notes?: string;
};
export type InterestAccountTransferResponse = ApiResponse & {
  TransactionID: string;
};
export type InterestAccountRatesRequest = {
  InterestMaturityType?: InterestTerm;
};
export type InterestAccountRatesApiResponse = ApiResponse & {
  CurrentRates: {
    'short-term': string;
  };
  InterestRates: { [key: string]: InterestRate };
};

export type CurrentRates = {
  'short-term': string;
};

export type InterestAccountRatesResponse = ApiResponse & {
  CurrentRates: CurrentRates;
  InterestRates: InterestRate[];
};

export type InterestTerm = 'short-term' | 'long-term';

export type InterestRate = {
  AnnualInterestRate: number;
  Term: InterestTerm;
  RangeStart: number;
  RangeEnd: number;
};
export type InterestAccountAccruedInterestRequest = {
  Year: string;
  Month: string;
  InterestMaturityType: InterestTerm;
};
export type InterestAccountAccruedInterestApiResponse = ApiResponse & {
  AccruedInterest: { [key: string]: AccruedInterestData };
};
export type InterestAccountAccruedInterestResponse = ApiResponse & {
  AccruedInterestList: AccruedInterestData[];
};
export type AccruedInterestData = {
  Year: string;
  Month: string;
  AccruedInterest: string;
  Currency: string;
};
export type InterestAccountTransactionsRequest = RequestWithPagination & {
  InterestMaturityType?: InterestTerm;
  StartDate?: string;
  EndDate?: string;
  Timezone?: string;
  TransactionType?: TransactionType;
  TransactionStatus?: InterestAccountTransactionHistoryStatus;
  TransactionID?: string;
};
export type InterestAccountTransaction = {
  TransactionID: string;
  TransactionType: TransactionType;
  TransactionDate: string;
  CreditAmount: string;
  DebitAmount: string;
  AccountType: string;
  Status: string;
  EligibilityDate: string;
};
export type InterestAccountTransactionsResponse = ApiResponse &
  ResponseWithPagination & {
    InterestAccountTransactions: InterestAccountTransaction[];
  };
export type InterestAccountTransactionsApiResponse = ApiResponse &
  ResponseWithPagination & {
    Transactions?: { [key: string]: InterestAccountTransaction };
  };

export type InterestAccountTransactionHistoryStatus = 'waiting' | 'pending' | 'successful';

export type PortalClientLoginHistoryRequest = {
  BrowserName?: string;
  BrowserVersion?: string;
  City: string;
  Country: string;
  BrowserEngineName?: string;
  BrowserEngineVersion?: string;
  Hostname: string;
  IPAddress: string;
  Location: string;
  Organization: string;
  OSName?: string;
  OSVersion?: string;
  OSVersionName?: string;
  PlatformType?: string;
  PlatformVendor?: string;
  PostalCode: string;
  Region: string;
  TimeZone: string;
  Username: string;
  RefferingUrl: string;
  RawUserAgent: string;
};

export type PortalClientLoginHistoryResponse = ApiResponse & {
  SuspiciousLogin: boolean;
};

export type RecipientContactsGenerateEmbedUrlRequest = {
  SendEmail: boolean;
  ReceiverEmailAddress?: string;

  SendSMS: boolean;
  ReceiverPhoneNumber?: string;

  ContactClientType: 'individual' | 'business';
  FirstName?: string;
  LastName?: string;
  BusinessName?: string;

  DeliveryMethodTypes: string;
  Label?: string;
  Country: string;
  UseCase: UseCase | '';
  StyleSheetUrl?: string;
  ClientAccountID: string;
  IsActive: boolean;
};
export type RecipientContactsGenerateEmbedUrlResponse = ApiResponse & {
  OnboardingLink: string;
  RecipientContactID: string;
};
export type UserSettingsRequest = {
  EmailAddress: string;
};

export type SubAccountBalanceView = 'do-not-show-balances' | 'available-balance' | 'roll-up-balance';

export type UserSetting = {
  timezone: Timezone;
  SubAccountBalanceDisplay: SubAccountBalanceView;
  Language?: string;
};
export type UserSettingsResponse = ApiResponse & {
  Username: string;
  Settings: UserSetting;
};

export type SubmitUserSettingsRequest = {
  EmailAddress: string;
  Timezone: Timezone;
  SubAccountBalanceDisplay: SubAccountBalanceView;
  Language?: string;
};

export type ActivateDeactiveteClientAccountRequest = {
  ClientAccountID: string;
};
export type ActivateDeactiveteClientAccountResponse = ApiResponse & {
  ClientAccountID: string;
  IsActive: boolean;
};
export type ActivateDeactiveteContactRequest = {
  ContactID: string;
};
export type ActivateDeactiveteContactResponse = ApiResponse & {
  ContactID: string;
  IsActive: boolean;
};

type DebitCardApiResponse = {
  DebitCardHolderName: string;
  DebitCardNumber: string;
  DebitCardExpiryYear: string;
  DebitCardExpiryMonth: string;
  DebitCardBrand: string;
  DebitCardToken: string;
  IsDefault: string;
  ClientAccountID: string;
  SendingEligibility?: PseudoBool;
  ReceivingEligibility?: PseudoBool;
  FundsAvailability?: string;
};

export type GetDebitCardsApiResponse = ApiResponse & {
  DebitCards?: {
    [idx: string]: DebitCardApiResponse;
  };
};

export type GetDebitCardsResponse = ApiResponse & {
  DebitCards: (Omit<DebitCardApiResponse, 'IsDefault' | 'SendingEligibility' | 'ReceivingEligibility'> & {
    IsDefault: boolean;
    SendingEligibility?: boolean;
    ReceivingEligibility?: boolean;
  })[];
};

export type RtpWithdrawRequest = {
  AccountNumber: string;
  ABARoutingNumber: string;
  Amount: number;
  RecipientName: string;
  ClientReferenceNumber?: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type RtpWithdrawResponse = ApiResponse & {
  TransactionID: string;
};

export type FedwireWithdrawRequest = {
  AccountNumber: string;
  ABARoutingNumber: string;
  Amount: number;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  Address1: string;
  City: string;
  State: string;
  Country: string;
  ZipCode: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type FedwireWithdrawResponse = ApiResponse & {
  TransactionID: string;
};

export type FedwireFundRequest = {
  AccountNumber: string;
  ABARoutingNumber: string;
  Amount: number;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  Address1: string;
  City: string;
  State: string;
  Country: string;
  ZipCode: string;
  GLCode?: string;
  TransactionCode?: string;
};

export type FedwireFundResponse = ApiResponse & {
  TransactionID: string;
};

export type RailzCreateInvoiceLineItem = {
  Description: string;
  Amount: number;
  Quantity: number;
  InventoryRefID: number;
  TaxRateID?: number;
  TrackingCategoryID: number;
};

export type RailzCreateInvoiceRequest = BaseRailzeRequest & {
  Invoice: {
    InvoiceNumber: string;
    PostedDate: string;
    DueDate: string;
    Currency: string;
    CurrencyRate: number;
    Memo: string;
    CustomerRefID: number;
    Lines: RailzCreateInvoiceLineItem[];
  };
};

export type RailzCustomersRequest = BaseRailzeRequest & {
  CustomerName?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzAddress = {
  line1: string;
  city: string;
  region: string;
  postalCode: string;
  country?: string;
};

export type RailzCustomer = {
  id: string;
  customerName: string;
  contactName: string;
  emailAddress?: string;
  phone: string;
  balance: number;
  billingAddress: RailzAddress;
  shippingAddress?: RailzAddress;
  currency: string;
  contactLastName: string;
  contactFirstName: string;
  status: string;
  sourceModifiedDate: string;
  website?: string;
  parentRef?: {
    id: string;
  };
};

export type RailzCustomerBaseApiResponse = ApiResponse & {
  Customers?: {
    [key: string]: RailzCustomer;
  };
};
export type RailzCustomersResponse = ApiResponse & {
  Customers: RailzCustomer[];
};

export type RailzInventoryRequest = BaseRailzeRequest & {
  InvoiceItem?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzAccountRef = {
  id: string;
  name: string;
};

export type RailzInvoiceItem = {
  description: string;
  unitPrice: number;
  accountRef: RailzAccountRef;
};

export type RailzBillItem = {
  description: string;
  unitPrice: number;
  accountRef: RailzAccountRef;
};

export type RailzQuantityOnHand = {
  quantity: number;
  accountRef: RailzAccountRef;
};

type RailzBaseInventoryItem = {
  id: string;
  name: string;
  type?: string;
  status: string;
  isInvoiceItem?: boolean;
  invoiceItem?: RailzInvoiceItem;
  isBillItem?: boolean;
  billItem?: RailzBillItem;
  quantityOnHand?: {
    [key: string]: RailzQuantityOnHand;
  };
  code?: string;
  sourceModifiedDate: string;
};
export type RailzInventoryItem = Omit<RailzBaseInventoryItem, 'quantityOnHand'> & {
  quantityOnHand: RailzQuantityOnHand[];
};
export type RailzInventoryBaseApiResponse = ApiResponse & {
  Inventory?: {
    [key: string]: RailzBaseInventoryItem;
  };
};

export type RailzInventoryResponse = ApiResponse & {
  Inventory: RailzInventoryItem[];
};
export type RailzTaxRatesRequest = BaseRailzeRequest & {
  TaxRateName?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzTaxComponent = {
  id: string;
  name: string;
  rate: number;
  isPurchasesTax: boolean;
  isSalesTax: boolean;
};

type RailzBaseTaxRate = {
  id: string;
  name: string;
  code: string;
  effectiveTaxRate?: number;
  totalTaxRate?: number;
  components?: {
    [key: string]: RailzTaxComponent;
  };
  sourceModifiedDate: string;
};
export type RailzTaxRate = Omit<RailzBaseTaxRate, 'components'> & {
  components: RailzTaxComponent[];
};
export type RailzTaxRatesBaseApiResponse = ApiResponse & {
  TaxRates?: {
    [key: string]: RailzBaseTaxRate;
  };
};

export type RailzTaxRatesResponse = ApiResponse & {
  TaxRates: RailzTaxRate[];
};
export type RailzTrackingCategoriesRequest = BaseRailzeRequest & {
  TrackingCategory?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzTrackingCategory = {
  id: string;
  name: string;
  isEditable: boolean;
  parentRef?: {
    id: string;
  };
  status: string;
  sourceModifiedDate: string;
  hasChildren: boolean;
  type: string;
};

export type RailzTrackingCategoriesBaseApiResponse = ApiResponse & {
  TrackingCategories?: {
    [key: string]: RailzTrackingCategory;
  };
};

export type RailzTrackingCategoriesResponse = ApiResponse & {
  TrackingCategories: RailzTrackingCategory[];
};

export type RailzCreateBillLineItem = {
  Description: string;
  Amount: number;
  Quantity: number;
  AccountRefID: number; // Category
  TaxRateRef?: number;
  TaxAmount?: number;
  TrackingCategoryRefs: string;
  BillableStatus: 'billable' | 'notBillable';
};

export type RailzCreateBillRequest = BaseRailzeRequest & {
  Bill: {
    VendorInvoiceNumber: string;
    PostedDate: string;
    DueDate: string;
    Currency: string;
    CurrencyRate: number;
    Memo: string;
    VendorRefID: number;
    Lines: RailzCreateBillLineItem[];
  };
};

export type RailzVendorsRequest = BaseRailzeRequest & {
  VendorName?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzVendor = {
  id: string;
  vendorName: string;
  contactName?: string;
  emailAddress?: string;
  website?: string;
  phone: string;
  balance: number;
  billingAddress?: RailzAddress;
  currency: string;
  contactFirstName?: string;
  contactLastName?: string;
  taxNumber?: string;
  status: string;
  sourceModifiedDate: string;
};

export type RailzVendorsBaseApiResponse = ApiResponse & {
  Vendors?: {
    [key: string]: RailzVendor;
  };
};

export type RailzVendorsResponse = ApiResponse & {
  Vendors: RailzVendor[];
};

export type RailzCategories = BaseRailzeRequest & {
  CategoryName?: string;
  Limit?: number;
  Offset?: number;
};
export type RailzSubAccount = {
  id: string;
  nominalCode: string | null;
  name: string;
};

type RailzBaseCategory = {
  id: string;
  nominalCode: string | null;
  name: string;
  subAccounts: {
    [key: string]: RailzSubAccount;
  };
};
export type RailzCategory = Omit<RailzBaseCategory, 'subAccounts'> & {
  subAccounts: RailzSubAccount[];
};

export type RailzCategoriesBaseApiResponse = ApiResponse & {
  Categories?: {
    [key: string]: RailzBaseCategory;
  };
};

export type RailzCategoriesResponse = ApiResponse & {
  Categories: RailzCategory[];
};
export type PartnerAccountPermissionFieldsResponse = ApiResponse & {
  PermissionValues: PartnerAccountPermissionResponse[];
};

export type PartnerAccountPermissionRequest = {
  VopayAccountID: string;
};

export type PartnerAccountPermissionResponse = {
  Permission: string;
  Type: string;
  Label: string;
  Section: string;
  Value: string | number | boolean;
  ExtraFields?: object;
};

export type ELinxSettingsSetNotificationRequest = {
  SenderNotificationsEnabled: boolean;
  ReceiverNotificationsEnabled: boolean;
  DefaultNotificationMethod: ElinxNotificationMethod;
};

export type ELinxSettingsSetReminderRequest = {
  IsELinxReminderEnabled: boolean;
  ELinxReminderFrequency: number;
};

export type WatchListRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  CreateDefaults?: boolean;
};
export type WatchListCurrency = {
  Currency: string;
  ShortForm: SupportedXBCurrencies;
  FxRate: string;
};
export type WatchListBaseResponse = ApiResponse & {
  Watchlist?: { [key: string]: WatchListCurrency };
};

export type WatchListResponse = ApiResponse & {
  Watchlist: WatchListCurrency[];
};

export type AddWatchListRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  Currency: string;
};

export type DeleteWatchListRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  Currency: string;
};
export type SetWatchListRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  Currencies: string;
};

export type CurrenciesRequest = {
  UseCase: UseCase | '';
};
export type Currency = {
  Currency: string;
  ShortForm: SupportedXBCurrencies;
  Countries: string;
};
export type CurrenciesApiResponse = ApiResponse & {
  Currencies?: { [key: string]: Currency };
};
export type CurrenciesResponse = ApiResponse & {
  Currencies: Currency[];
};
export type InteracEditEmailRequest = {
  Token: string;
  ClientAccountID?: string;
  ContactID?: string;
  RecipientName?: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  Question?: string;
  Answer?: string;
  Message?: string;
  Language?: string;
  ClientReferenceNumber?: string;
  ClientControlled?: boolean;
};

export type InteracEditEmailResponse = ApiResponse & {
  Token: string;
};

export type AddContactRequest = {
  ContactID?: string;
  EmailAddress: string;
  PhoneNumber: string;
  FirstName: string;
  LastName: string;
  BusinessName?: string;
  Label?: string;

  Address1?: string;
  Address2?: string;
  City?: string;
  Province?: string;
  Country?: string;
  PostalCode?: string;

  FlinksAccountID?: string;
  FlinksLoginID?: string;
  PlaidProcessorToken?: string;
};

export type AddContactResponse = ApiResponse & {
  ContactID: string;
};

export type EditContactResponse = ApiResponse & {
  ContactID: string;
};

export type GenerateGCMEmbedUrlRequest = {
  ClientAccountID?: string;
  RecipientContactID?: string;
  DeliveryChannelID?: string;
  BuyAmount?: string;
  SellAmount?: string;
  Currency?: string;
};

export type GenerateGCMEmbedUrlResponse = ApiResponse & {
  Link?: string;
};

export type AuthenticateMerchantUserResponse = ApiResponse & {
  MerchantUserToken: string;
};

export type GCMBalanceRequest = {
  Currency?: SupportedXBCurrencies;
  IframeKey: string;
};

export type GCMBalanceResponse = ApiResponse & {
  Balance: string;
};

export type GCMRatesFeesComparisonRequest = {
  Currency: SupportedXBCurrencies;
  HomeCurrency?: string;
};

export type GCMRatesFeesComparisonProvider = {
  ProviderName: string;
  ProviderLogo: string;
  ExchangeRate: string;
  TransferFee: string;
};
export type GCMRatesFeesComparisonApiResponse = ApiResponse & {
  Results: {
    [key: string]: GCMRatesFeesComparisonProvider;
  };
};
export type GCMRatesFeesComparisonResponse = ApiResponse & {
  Results: GCMRatesFeesComparisonProvider[];
};

// TODO: Should not be here technically not a vopay api type
export type CrossborderMessages =
  | {
      type: 'ACTION';
      code: 'NAVIGATION';
      payload: {
        path: string;
      };
    }
  | {
      type: 'ACTION';
      code: 'CONFIG';
      payload: {
        hideMenu: boolean;
        primaryColor?: string;
        timezone?: string;
      };
    }
  | {
      type: 'INFO';
      code: 'INIT';
    }
  | {
      type: 'INFO';
      code: 'CONFIG_PROCESSED';
    };

export type DisputeManagementIFrameEvent =
  | {
      type: 'INITIALIZED';
    }
  | {
      type: 'NAVIGATED';
      payload: {
        path: string;
      };
    }
  | {
      type: 'LOADING';
      payload: {
        completed: boolean;
      };
    }
  | {
      type: 'READY';
    };

export type DisputeManagementIFrameMethod =
  | {
      type: 'SET_CONFIG';
      payload: {
        primaryColor?: string;
        timezone?: string;
      };
    }
  | {
      type: 'NAVIGATED';
      payload: {
        path: string;
      };
    };

export type BillPaymentIFrameEvent =
  | {
      type: 'READY_FOR_MESSAGES';
    }
  | {
      type: 'NAVIGATED';
      payload: {
        path: string;
      };
    }
  | {
      type: 'LOADING';
      payload: {
        completed: boolean;
      };
    }
  | {
      type: 'CONFIG_PROCESSED';
    };

export type BillPaymentIFrameMethod =
  | {
      type: 'SET_CONFIG';
      payload: {
        primaryColor?: string;
        timezone?: string;
        fullScreenLoader?: boolean;
        language?: string;
      };
    }
  | {
      type: 'NAVIGATED';
      payload: {
        path: string;
      };
    };

export type AddressVerificationIFrameEvent =
  | {
      type: 'READY_FOR_MESSAGES';
    }
  | {
      type: 'NAVIGATED';
      payload: {
        path: string;
      };
    }
  | {
      type: 'LOADING';
      payload: {
        completed: boolean;
      };
    }
  | {
      type: 'CONFIG_PROCESSED';
    }
  | {
      type: 'CONNECTED';
    };

export type AddressVerificationIFrameMethod =
  | {
      type: 'SET_CONFIG';
      payload: {
        brandingKey?: string;
        primaryColor?: string;
        fullScreenLoader?: boolean;
      };
    }
  | {
      type: 'NAVIGATE';
      payload: {
        path: string;
      };
    };

export type TransactionTypesOptions =
  | 'All'
  | 'EFT Withdrawal'
  | 'EFT Funding'
  | 'VoPayInstant Withdraw'
  | 'Refund'
  | 'Currency Conversion'
  | 'Crossborder Withdrawal'
  | 'Interac Money Request'
  | 'Interac Bulk Payout'
  | 'Inbound e-Transfer'
  | 'Visa Direct Push'
  | 'Credit Card'
  | 'Account Transfer'
  | 'Reversal'
  | 'Auto Balance Transfer'
  | 'Virtual Account Deposit'
  | 'Virtual Account Funding'
  | 'Virtual Account Withdraw'
  | 'Virtual Account Wire'
  | 'Other Funding'
  | 'Other Withdrawal'
  | 'ACH Withdrawal'
  | 'ACH Funding'
  | 'RTP Withdrawal'
  | 'Fedwire Withdrawal'
  | 'Fedwire Funding'
  | 'Google Pay'
  | 'PayPal Withdrawal'
  | 'PayPal Funding'
  | 'Venmo Withdrawal'
  | 'Venmo Funding'
  | 'Fednow Withdrawal'
  | 'Bill Pay'
  | 'Crossborder Withdrawal'
  | 'Fee'
  | 'Security Deposit'
  | 'International Funding'
  | 'International Withdrawal'
  | 'PayLink'
  | 'Adjustment'
  | 'Settlement'
  | 'OCT'
  | 'AFT'
  | 'Pay By Bank'
  | 'Apple Pay'
  | 'Interest'
  | 'Tax Remittance'
  | 'eLinx'
  | '';

export type MerchantPortalMessages =
  | {
      type: 'ACTION';
      code: 'CONFIG';
      payload: {
        sessionToken: string;
        hideHeader: boolean;
        hideFooter: boolean;
        primaryColor?: string;
        role: PartnerRole;
      };
    }
  | {
      type: 'INFO';
      code: 'INIT';
    }
  | {
      type: 'INFO';
      code: 'CONFIG_PROCESSED';
    };
export type PCIVaultResponse = {
  token: string;
};
export type TransactionCode = {
  TransactionTypeCode: number;
  Category: string;
  Description: string;
};
export type TransactionCodesApiResponse = ApiResponse & {
  TransactionCodes: { [key: string]: TransactionCode };
};
export type TransactionCodesResponse = ApiResponse & {
  TransactionCodes: TransactionCode[];
};
export type GlCode = {
  GLCode: string;
  Name: string;
  Section: string;
  SubSection: string;
  AccountGroup: string;
  SubGroup: string;
  Classification: string;
};

export type GLCodesApiResponse = ApiResponse & {
  GLCodes: { [key: string]: GlCode };
};

export type GLCodesResponse = ApiResponse & {
  GLCodes: GlCode[];
};

export type ProcessorType = 'globalpay' | 'pci' | 'worldpay';
type CommonProcessorConfig = {
  enabled3ds: boolean;
  cardTypeValidationEnabled: boolean;
  acceptedCardBrands: AcceptedCardBrand[];
  primaryColor?: string;
  language?: SupportedLanguages;
  transactionDetails?: {
    amount: string;
    currency: string;
    country: string;
    paymentType: 'fund' | 'withdraw' | 'other';
  };
  appInformation?: {
    appID: string;
    appKey: string;
  };
  convenienceFees?: ConvenienceFeesResponse;
  cardType: 'credit' | 'debit';
};

export type CreditCardIFrameLanguage = {
  type: 'LANGUAGE_UPDATE';
  payload: { language: SupportedLanguages };
};

export type CreditCardIFrameEvent =
  | {
      type: 'READY_FOR_MESSAGES';
    }
  | {
      type: 'ERROR';
      payload: {
        errorTitle?: string;
        errorMessage: string;
      };
    }
  | {
      type: 'LOADING';
      payload: {
        completed: boolean;
      };
    }
  | {
      type: 'CARD';
      payload: {
        success: boolean;
        errorMessage: string;
        paymentToken: string;
        cardHolderName: string;
        maskedCardNumber: string;
        cardBrand: string;
        expiryYear: string;
        expiryMonth: string;
        Address1?: string;
        Address2?: string;
        City?: string;
        Province?: string;
        PostalCode?: string;
        Country?: string;
      };
    }
  | CreditCardIFrameLanguage;

export type EditDeliveryMethodRequest = {
  AccountType: string;
  DeliveryMethodToken: string;
  BankAccountNumber?: string;
  BankIdentifierCode?: string;
  InternationalBankAccountNumber?: string;
  EWalletID?: string;
  ServiceProvider?: string;
  TelephoneNumber?: string;
  BankName?: string;
  BankCode?: string;
  BranchName?: string;
} & (
  | {
      ClientAccountID?: never;
      ContactID: string;
    }
  | {
      ClientAccountID: string;
      ContactID?: never;
    }
);

export type CreditCardIFrameMethod = {
  type: 'CONFIG';
  payload:
    | (CommonProcessorConfig & {
        processorType: 'globalpay';
        accessToken: string;
      })
    | (CommonProcessorConfig & {
        processorType: 'pci';
        userId: string;
        enabled3ds: boolean;
      })
    | (CommonProcessorConfig & {
        processorType: 'worldpay';
        username: string;
        password: string;
        merchantId: string;
      });
};

export type CrossBorderCashPickupStatesRequest = {
  Country: string;
};

export type CrossBorderCashPickupStatesApiResponse = ApiResponse & {
  CashPickupStates: {
    [key: string]: string;
  };
};

export type CrossBorderCashPickupStatesResponse = ApiResponse & {
  CashPickupStates: string[];
};

export type CrossBorderCashPickupCitiesRequest = {
  Country: string;
  State: string;
};

export type CrossBorderCashPickupCitiesApiResponse = ApiResponse & {
  CashPickupCities: {
    [key: string]: string;
  };
};

export type CrossBorderCashPickupCitiesResponse = ApiResponse & {
  CashPickupCities: string[];
};

export type CrossBorderCashPickupLocationsRequest = {
  Country: string;
  State: string;
  City: string;
  BranchName: string;
};

export type CashPickupLocation = {
  BranchName: string;
  BranchNameAlternate: string;
  BranchCode: string;
  Address: string;
  City: string;
  State: string;
  Phone: string;
};

export type CrossBorderCashPickupLocationsApiResponse = ApiResponse & {
  CashPickupLocations: {
    [key: string]: CashPickupLocation;
  };
};
export type CrossBorderCashPickupLocationsResponse = ApiResponse & {
  CashPickupLocations: CashPickupLocation[];
};
export type LinkPaypalRequest = {
  PayPalRecipientType: 'EMAIL' | 'PHONE' | 'PAYPAL_ID';
  RecipientID: string;
  RecipientName: string;
  IframeKey: string;
};

export type LinkPaypalResponse = ApiResponse & {
  PayPalToken: string;
};

export type LinkVenmoRequest = {
  VenmoRecipientType: 'EMAIL' | 'PHONE' | 'USER_HANDLE';
  RecipientID: string;
  RecipientName: string;
  IframeKey: string;
};

export type LinkVenmoResponse = ApiResponse & {
  VenmoToken: string;
};

export type GenerateEmployeeOTPRequest = {
  EmailAddress: string;
};

export type GenerateEmployeeOTPResponse = ApiResponse & {
  Token: string;
};

export type ValidateEmployeeOTPRequest = {
  SingleUseToken: string;
  OTP: string;
};

export type ValidateEmployeeOTPResponse = ApiResponse & {
  Token: string;
};

export type FundingRail = {
  TransactionFee: string;
  ProcessingTime: string;
};

export type PaymentRailType =
  | 'eft'
  | 'interac'
  | 'creditcard'
  | 'aft'
  | 'applepay'
  | 'googlepay'
  | 'accountbalance'
  | 'vopaybalance';

export type GCMFundingRailsResponse = ApiResponse & {
  FundingOptions: Record<PaymentRailType, FundingRail>;
};

export type SetMyGooglePayRequest = {
  GooglePayToken: string;
  ClientAccountID?: string;
  SetAsDefault?: boolean;
};

export type SetMyGooglePayResponse = ApiResponse & {
  GooglePayToken: string;
  IsDefault: boolean;
};

export type ChargeGooglePayRequest = {
  ClientAccountID?: string;
  Amount: string;
};

export type ChargeGooglePayResponse = ApiResponse & {
  TransactionID: string;
};
export type GlobalSendDeliveryChannelsApiResponse = ApiResponse & {
  IsMarkupByPercent: boolean;
  Corridors: {
    [CorridorID: string]: {
      Selected: boolean;
      CorridorID: string;
      CountryID: string;
      HomeCountry: string;
      DestinationCountry: string;
      Currencies: {
        [CurrencyID: string]: {
          CurrencyID: string;
          Currency: SupportedXBCurrencies;
          Selected: boolean;
          // LongForm?: string;
          UseCases: {
            [UseCase: string]: {
              UseCase: UseCase;
              Selected: boolean;
              DeliveryMethods: {
                [DeliveryMethodType: string]: {
                  DeliveryChannelID: string;
                  DeliveryMethodType: DeliveryMethodType;
                  DeliveryFee: number;
                  FeeMarkup: number;
                  MarkupPoints: number;
                  MarkupPercent: number;
                  FxRate: number;
                  Selected: boolean;
                };
              };
            };
          };
        };
      };
    };
  };
};
export type BillPaymentMerchantsRequest = {
  SearchText?: string;
  Limit?: number;
  Offset?: number;
};

export type BillPaymentMerchant = {
  BillPayMerchantID: string;
  MerchantName: string;
  MerchantId: string;
  MerchantCategory: string;
  PaymentAccountFormat: string;
  CreditInstitution: string;
  CreditCategory: string;
  CanadianCreditorIdentificationNumber: string;
  Instructions: string;
};
export type BillPaymentMerchantsApiResponse = ApiResponse &
  ResponseWithPagination & {
    Merchants: {
      [key: string]: BillPaymentMerchant;
    };
  };
export type BillPaymentMerchantsResponse = ApiResponse &
  ResponseWithPagination & {
    Merchants: BillPaymentMerchant[];
  };

export type BillPaymentAccountMerchantsRequest = {
  SearchText?: string;
  Limit?: number;
  Offset?: number;
  ClientAccountID?: string;
  ContactID?: string;
};
export type BillPaymentAccountMerchant = {
  BillPayMerchantID: string;
  AccountBillPayMerchantID: string;
  MerchantName: string;
  MerchantCategory: string;
  Nickname: string;
  PaymentAccount: string;
  AdditionalInformation: string;
  LastModified: string;
};
export type BillPaymentAccountMerchantsApiResponse = ApiResponse &
  ResponseWithPagination & {
    AccountBillPayMerchants: {
      [key: string]: BillPaymentAccountMerchant;
    };
  };
export type BillPaymentAccountMerchantsResponse = ApiResponse &
  ResponseWithPagination & {
    AccountBillPayMerchants: BillPaymentAccountMerchant[];
  };

export type BillPayInfoRequest = {
  Token: string;
};

export type BillPayInfoResponse = ApiResponse & {
  ContactID: string;
  ClientAccountID: string;
  JWT: string;
  ApplicationType: 'bill-pay';
};

export type TransactionApprovalInfoRequest = {
  Token: string;
  ApproverID: string;
};
export type TransactionApprovalInfoTransactionDetails = {
  TransactionID: string;
  Amount: number;
  TransactionDate: string;
  Currency: SupportedCurrencies;
  FullName: string;
  TransactionType: TransactionType;
  Status: TransactionStatus;
  NumberOfApprovals: number;
  InvoiceLink: string;
};
export type FetchTransactionApprovalInfoResponse = ApiResponse & {
  JWT: string;
  ApplicationType: 'transaction-approval';
  ApproversRequired: number;
  TransactionDetails: TransactionApprovalInfoTransactionDetails;
};

export type ApprovalHistoryItem = {
  TransactionID: string;
  Username: string;
  ApprovalDecision: 'Approved' | 'Rejected';
  Reason: string;
  DecisionDate: string;
};

export type TransactionApprovalHistoryRequest = {
  TransactionID: string;
  Timezone?: string;
};
export type FetchTransactionApprovalHistoryApiResponse = ApiResponse & {
  ApprovalHistory: {
    [key: string]: ApprovalHistoryItem;
  };
};
export type FetchTransactionApprovalHistoryResponse = ApiResponse & {
  ApprovalHistory: ApprovalHistoryItem[];
};

export type WorkflowLogsRequest = {
  WorkflowID?: string;
};
export type WorkflowLogAction = 'create' | 'update' | 'delete';
export type WorkflowLogItemApi = {
  LogID: string;
  WorkflowID: string;
  Action: WorkflowLogAction;
  TransactionType: string;
  NumberApprovalsRequired: number;
  MinAmount: string;
  MaxAmount: string;
  IsActive: PseudoBool;
  Username: string;
  DateAdded: string;
};
export type WorkflowLogItem = Omit<WorkflowLogItemApi, 'IsActive'> & {
  IsActive: boolean;
};

export type FetchWorkflowLogsApiResponse = ApiResponse & {
  Logs: {
    [key: string]: WorkflowLogItemApi;
  };
};

export type FetchWorkflowLogsResponse = ApiResponse & {
  Logs: WorkflowLogItem[];
};

export type BillPayCreateRequest = {
  ClientAccountID?: string;
  AccountBillPayMerchantID: string;
  Amount: string;
  Currency?: string;
  ClientReferenceNumber?: string;
  Notes?: string;
  IdempotencyKey?: string;
};

export type BillPayCreateResponse = ApiResponse & {
  TransactionID: string;
};

export type BillPayAccountMerchantAddRequest = {
  BillPayMerchantID: string;
  Nickname?: string;
  PaymentAccount?: string;
  AdditionalInformation?: string;
  ClientAccountID?: string;
};

export type BillPayAccountMerchantAddResponse = ApiResponse & {
  AccountMerchantID: string;
};

export type BillPayAccountMerchantEditRequest = {
  AccountBillPayMerchantID: string;
  Nickname?: string;
  PaymentAccount?: string;
  AdditionalInformation?: string;
  ClientAccountID?: string;
};

export type BillPayAccountMerchantEditResponse = ApiResponse & {
  AccountMerchantID: string;
};

export type GlobalSendDeliveryChannelsResponse = ApiResponse & {
  IsMarkupByPercent: boolean;
  Corridors: GlobalSendAdminCorridors;
};

export type PublishGlobalSendAdminDeliveryChannelsRequest = {
  IsMarkupByPercent: boolean;
  DeliveryChannelsData: GlobalSendAdminDeliveryMethod[];
};

export type GlobalSendAdminCorridors = {
  [CorridorID: string]: GlobalSendAdminCorridor;
};

export type GlobalSendAdminCorridor = {
  Selected: boolean;
  CorridorID: string;
  CountryID: string;
  HomeCountry: string;
  DestinationCountry: string;
  Currencies: GlobalSendAdminCurrencies;
};

export type GlobalSendAdminCurrencies = {
  [CurrencyID: string]: GlobalSendAdminCurrency;
};

export type GlobalSendAdminCurrency = {
  CurrencyID: string;
  Currency: SupportedXBCurrencies;
  Selected: boolean;
  // LongForm?: string;
  UseCases: GlobalSendAdminUseCases;
};

export type GlobalSendAdminUseCases = {
  [UseCase: string]: GlobalSendAdminUseCase;
};

export type GlobalSendAdminUseCase = {
  UseCase: UseCase;
  Selected: boolean;
  DeliveryMethods: GlobalSendAdminDeliveryMethods;
};

export type GlobalSendAdminDeliveryMethods = {
  [DeliveryMethodType: string]: GlobalSendAdminDeliveryMethod;
};

export type GlobalSendAdminDeliveryMethod = {
  DeliveryChannelID: string;
  DeliveryMethodType: DeliveryMethodType;
  DeliveryFee: number;
  FeeMarkup: number;
  MarkupPoints: number;
  MarkupPercent: number;
  FxRate: number;
  Selected: boolean;
};

export type GlobalSendAdminFundingOptions = Partial<
  Record<
    GlobalSendAdminFundingOption,
    {
      FundingOption: GlobalSendAdminFundingOption;
      TransactionFee: number;
      ProcessingTime: ProcessingTime;
      Selected: boolean;
    }
  >
>;

export type FetchGlobalSendAdminFundingOptionsResponse = ApiResponse & {
  FundingOptions: GlobalSendAdminFundingOptions;
};

export type ProcessingTime = 'real-time' | '3 business days';

export type SubmitGlobalSendAdminFundingOptionsRequest = {
  FundingOptions: GlobalSendAdminFundingOption[];
};

export type GlobalSendAdminFundingOption =
  | 'vopaybalance'
  | 'interac'
  | 'eft'
  | 'aft'
  | 'creditcard'
  | 'googlepay'
  | 'applepay';

export type BillPayTransactionRequest = {
  TransactionID: string;
};

export type BillPayTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Currency: string;
  LastModified: string;
  MerchantID: string;
  MerchantName: string;
  MerchantCategory: string;
  PaymentAccountFormat: string;
  CreditInstitution: string;
  CreditCategory: string;
  CanadianCreditorIdentificationNumber: string;
  Nickname: string;
  PaymentAccount: string;
  AdditionalInformation: string;
  ClientReferenceNumber: string;
  Note: string;
};

export type BillPayGenerateEmbedUrlRequest = {
  ClientAccountID?: string;
  StylesheetUrl?: string;
  Language?: SupportedLanguages;
  DarkMode?: boolean;
};

export type BillPayGenerateEmbedUrlResponse = ApiResponse & {
  Link: string;
  IframeKey: string;
};
export type DisputeManagementOverviewRequest = {
  FromDate?: string;
};

export type DisputeManagementOverviewResponse = ApiResponse & {
  DisputeOverview: {
    InReview: number;
    Lost: number;
    NeedsResponse: number;
    Won: number;
  };
};

export type DisputeManagementListRequest = {
  Limit?: number;
  FromDate?: string;
  ToDate?: string;
  DisputeStatus?: string;
  DisputeStage?: string;
  DisputeID?: string;
  Currency?: string;
  CardBrand?: string;
  Offset?: number;
};

export type DisputeStatus = 'Closed' | 'UnderReview' | 'WithMerchant';
export type DisputeManagementCardBrand = 'Visa' | 'Mastercard' | 'Amex' | 'Discover' | 'UnionPay' | 'Diners';
export type DisputeStageID =
  | 'PRE_COMPLIANCE'
  | 'ARBITRATION'
  | 'REVERSAL'
  | 'GOOD_FAITH'
  | 'COMPLIANCE'
  | 'PRE_ARBITRATION'
  | 'SECOND_CHARGEBACK'
  | 'CHARGEBACK'
  | 'RETRIEVAL';

export type DisputeStageName =
  | 'Pre Compliance'
  | 'Arbitration'
  | 'Reversal'
  | 'Good Faith'
  | 'Compliance'
  | 'Pre Arbitration'
  | 'Second Chargeback'
  | 'Chargeback'
  | 'Retrieval';
export type DisputeCurrency = 'CAD' | 'USD';

export type Dispute = {
  DisputeID: string;
  DisputeCreatedOn: string;
  DisputeStatus: DisputeStatus;
  DisputeStage: DisputeStageName;
  DisputeAmount: number;
  DisputeCurrency: DisputeCurrency;
  DisputeReason: string;
  DisputeReasonCode: string;
  DisputeResult: string;
  DisputeReplyByDate: string;
  DaysLeftToRespond: number;
  DisputeCardBrand: DisputeManagementCardBrand;
  DisputeCardLast4: string;
  DisputeARN: string;
};

export type DisputeManagementListApiResponse = ApiResponse & {
  Disputes: { [key: string]: Dispute };
};

export type DisputeManagementListResponse = ApiResponse & {
  Disputes: Dispute[];
};

export type DisputeStagesRequest = {
  FromDate?: string;
};

export type DisputeStage = {
  StageID: DisputeStageID;
  StageName: DisputeStageName;
};

export type DisputeStagesApiResponse = ApiResponse & {
  DisputeStages: { [key: string]: DisputeStage };
};

export type DisputeStagesResponse = ApiResponse & {
  DisputeStages: DisputeStage[];
};

export type DisputeDetailsRequest = {
  DisputeID: string;
};

export type DisputeDetailNote = {
  Note: string;
  NoteDate: string;
};

export type DisputeDetailDocument = {
  DocumentID: string;
  DocumentType: string;
};

export type DisputeDetail = {
  DisputeID: string;
  DisputeCreatedOn: string;
  DisputeStatus: string;
  DisputeStage: string;
  DisputeAmount: number;
  DisputeCurrency: string;
  DisputeReason: string;
  DisputeReasonCode: string;
  DisputeResult: 'Won' | 'Lost' | 'Pending';
  DisputeReplyByDate: string;
  DaysLeftToRespond: number;
  DisputeCardDetails: {
    DisputeCardBrand: string;
    DisputeCardLast4: string;
    AccountHolderName: string;
  };
  TransactionDetails: {
    TransactionID: string;
    TransactionAmount: number;
    TransactionCurrency: string;
    TransactionDate: string;
  };
  DisputeARN: string;
  LastUpdatedDate: string;
  Notes: DisputeDetailNote[];
  Documents: DisputeDetailDocument[];
};

export type DisputeDetailsResponse = ApiResponse & {
  Dispute: DisputeDetail;
};

export type DisputeDocumentsRequest = {
  DisputeID: string;
  DocumentID: string;
};

export type DisputeDocument = {
  document: string;
  documentID: string;
};

export type DisputeDocumentsResponse = ApiResponse & {
  Document: DisputeDocument;
};

export type AddDisputeNoteRequest = {
  DisputeID: string;
  Note: string;
};

export type AddDisputeNoteResponse = ApiResponse & {
  Dispute: DisputeDetail;
};

export type RespondAndChallengeDisputeRequest = {
  DisputeID: string;
  Documents: string;
};

export type RespondAndChallengeDisputeResponse = ApiResponse & {
  Dispute: DisputeDetail;
};

export type AcceptDisputeRequest = {
  DisputeID: string;
};

export type AcceptDisputeResponse = ApiResponse & {
  Dispute: DisputeDetail;
};

export type DisputeReasonsRequest = {
  FromDate: string;
};

export type DisputeReasonsResponse = ApiResponse & {
  DisputeReasons: {
    [reason: string]: number;
  };
};

export type InteracAutoDepositStatusRequest = {
  EmailAddress: string;
};
export type InteracAutoDepositStatusResponse = ApiResponse & {
  AutoDepositEnabled: boolean;
};

export type ConvenienceFeeSetting = {
  TransactionType:
    | 'EFT Funding'
    | 'EFT Withdrawal'
    | 'Fee'
    | 'Account Transfer'
    | 'Reversal'
    | 'Security Deposit'
    | 'Interac Money Request'
    | 'Other Funding'
    | 'Other Withdrawal'
    | 'Currency Conversion'
    | 'Interac Bulk Payout'
    | 'International Funding'
    | 'International Withdrawal'
    | 'Visa Direct Push'
    | 'Inbound e-Transfer'
    | 'Credit Card'
    | 'Refund'
    | 'PayLink'
    | 'VoPayInstant Withdraw'
    | 'Adjustment'
    | 'Settlement'
    | 'Virtual Account Funding'
    | 'Virtual Account Withdraw'
    | 'Virtual Account Wire'
    | 'ACH Funding'
    | 'ACH Withdrawal'
    | 'RTP Withdrawal'
    | 'OCT'
    | 'Fedwire Funding'
    | 'Fedwire Withdrawal'
    | 'Crossborder Withdrawal'
    | 'AFT'
    | 'Pay By Bank'
    | 'Google Pay'
    | 'Apple Pay'
    | 'Interest'
    | 'PayPal Withdrawal'
    | 'PayPal Funding'
    | 'Venmo Withdrawal'
    | 'Venmo Funding'
    | 'Fednow Withdrawal'
    | 'Bill Pay';
  TransactionFee: string;
  ProcessingFee: string;
};

export type ConvenienceFeeRestriction = {
  Province: string;
  ProvinceAbbreviation: string;
  Country: string;
  CountryAbbreviation: string;
};

export type ConvenienceFeesResponseApi = ApiResponse & {
  FeeSettings: { [key: string]: ConvenienceFeeSetting };
  Restrictions: { [key: string]: ConvenienceFeeRestriction };
};
export type ConvenienceFeesResponse = ApiResponse & {
  FeeSettings: ConvenienceFeeSetting[];
  Restrictions: ConvenienceFeeRestriction[];
};
export type ConvenienceFeesRequest = {
  Token: string;
};

export type GlobalSendTransactionDetailsRequest = {
  TransactionID: string;
  Timezone?: string;
};

export type InteracPaymentMethod = {
  FundingOption: 'interac';
  RecipientPaymentDetails: string;
};

export type CreditPaymentMethod = {
  FundingOption: 'creditcard' | 'applepay' | 'googlepay';
  CreditCardBrand: CardBrand;
  CreditCardNumber: string;
};

export type DebitPaymentMethod = {
  FundingOption: 'aft';
  CardBrand: CardBrand;
  CardNumber: string;
};

export type BankPaymentMethod = BankAccount & {
  FundingOption: 'eft';
};

export type FundingPaymentMethod = InteracPaymentMethod | CreditPaymentMethod | DebitPaymentMethod | BankPaymentMethod;

export type GlobalSendTransactionDetailsResponse = ApiResponse & {
  Transaction: GlobalSendRecentTransaction;
  FundingPaymentMethod: FundingPaymentMethod;
};

type BaseWalletTransactionResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  ClientAccountID: string;
  Amount: string;
  Currency: string;
  HoldAmount: string;
  ClientReferenceNumber: string;
  Notes: string;
  LastModified: string;
  GLCode: string;
  TransactionTypeCode: string;
};
export type GooglePayChargeTransactionResponse = BaseWalletTransactionResponse & {
  GooglePayToken: string;
};
export type PayPalWithdrawTransactionResponse = BaseWalletTransactionResponse & {
  PayPalToken: string;
};
export type VenmoWithdrawTransactionResponse = BaseWalletTransactionResponse & {
  VenmoToken: string;
};

// Venmo Withdraw Request
export type VenmoWithdrawRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  VenmoToken?: string;
  VenmoRecipientType?: 'EMAIL' | 'PHONE' | 'USER_HANDLE';
  RecipientID?: string;
  RecipientName?: string;
  Amount: number;
  Notes?: string;
  ClientReferenceNumber?: string;
  IdempotencyKey?: string;
  GLCode?: string;
  TransactionTypeCode?: string;
};

export type VenmoWithdrawResponse = ApiResponse & {
  TransactionID: string;
};

// PayPal Withdraw Request
export type PayPalWithdrawRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  PayPalToken?: string;
  PayPalRecipientType?: 'EMAIL' | 'PHONE' | 'PAYPAL_ID';
  RecipientID?: string;
  RecipientName?: string;
  Amount: number;
  Currency?: string;
  Notes?: string;
  ClientReferenceNumber?: string;
  IdempotencyKey?: string;
  GLCode?: string;
  TransactionTypeCode?: string;
};

export type PayPalWithdrawResponse = ApiResponse & {
  TransactionID: string;
};

// Venmo Recipients Request and Response
export type VenmoRecipientsRequest = {
  ClientControlled?: boolean;
  Limit?: number;
  Offset?: number;
  SearchText?: string;
  ClientAccountID?: string;
};

export type VenmoRecipientApi = {
  RecipientName: string;
  RecipientID: string;
  VenmoRecipientType: string;
  VenmoToken: string;
  ClientControlledPayPalAccount: string;
  IsDefault: PseudoBool;
};
export type VenmoRecipient = Omit<VenmoRecipientApi, 'IsDefault'> & {
  IsDefault: boolean;
};

export type VenmoRecipientsApiResponse = ApiResponse & {
  VenmoRecipients: {
    [key: number]: VenmoRecipientApi;
  };
};

export type VenmoRecipientsResponse = ApiResponse & {
  VenmoRecipients: VenmoRecipient[];
};

// PayPal Recipients Request and Response
export type PayPalRecipientsRequest = {
  ClientControlled?: boolean;
  Limit?: number;
  Offset?: number;
  SearchText?: string;
  ClientAccountID?: string;
};

export type PayPalRecipientApi = {
  RecipientName: string;
  RecipientID: string;
  PayPalRecipientType: string;
  PayPalToken: string;
  ClientControlledPayPalAccount: string;
  IsDefault: PseudoBool;
};

export type PayPalRecipient = Omit<PayPalRecipientApi, 'IsDefault'> & {
  IsDefault: boolean;
};

export type PayPalRecipientsApiResponse = ApiResponse & {
  PaypalRecipients: {
    [key: number]: PayPalRecipientApi;
  };
};
export type PayPalRecipientsResponse = ApiResponse & {
  PaypalRecipients: PayPalRecipient[];
};

// PayPal Default Recipient Request and Response
export type PayPalDefaultRecipientRequest = {
  ClientAccountID?: string;
};

export type PayPalDefaultRecipientApi = {
  ClientControlledPayPalAccount: string;
  RecipientName: string;
  RecipientID: string;
  PayPalRecipientType: string;
  IsActive: string;
  IsDefault: string;
  PayPalToken: string;
  DateAdded: string;
};

export type PayPalDefaultRecipient = Omit<PayPalDefaultRecipientApi, 'IsActive' | 'IsDefault'> & {
  IsActive: boolean;
  IsDefault: boolean;
};

export type PayPalDefaultRecipientApiResponse = ApiResponse & {
  DefaultPayPalRecipient: {
    [key: number]: PayPalDefaultRecipientApi;
  };
};

export type PayPalDefaultRecipientResponse = ApiResponse & {
  DefaultPayPalRecipient: PayPalDefaultRecipient | null;
};

// Venmo Default Recipient Request and Response
export type VenmoDefaultRecipientRequest = {
  ClientAccountID?: string;
};

export type VenmoDefaultRecipientApi = {
  ClientControlledVenmoAccount: string;
  RecipientName: string;
  RecipientID: string;
  VenmoRecipientType: string;
  IsActive: string;
  IsDefault: string;
  VenmoToken: string;
  DateAdded: string;
};

export type VenmoDefaultRecipient = Omit<VenmoDefaultRecipientApi, 'IsActive' | 'IsDefault'> & {
  IsActive: boolean;
  IsDefault: boolean;
};

export type VenmoDefaultRecipientApiResponse = ApiResponse & {
  DefaultVenmoRecipient: {
    [key: number]: VenmoDefaultRecipientApi;
  };
};

export type VenmoDefaultRecipientResponse = ApiResponse & {
  DefaultVenmoRecipient: VenmoDefaultRecipient | null;
};

export type AFTPullRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  CardToken?: string;
  Amount: string;
  Currency?: string;
  Notes?: string;
  ClientReferenceNumber?: string;
  IdempotencyKey?: string;
  GLCode?: string;
  TransactionTypeCode?: string;
  ParentTransactionID?: string;
};

export type AFTPullResponse = ApiResponse & {
  TransactionID: string;
};

export type BlockAccountsRequest = {
  VopayAccountID?: string;
  TransferAvailableFunds?: boolean;
};

export type OCTPushRequest = {
  ClientAccountID?: string;
  ContactID?: string;
  CardToken?: string;
  Amount: number;
  Currency?: string;
  Notes?: string;
  ClientReferenceNumber?: string;
  IdempotencyKey?: string;
  GLCode?: string;
  TransactionTypeCode?: string;
  ParentTransactionID?: string;
};

export type OCTPushResponse = ApiResponse & {
  TransactionID: string;
};

export type FetchTranslationsUrlRequest = {
  Product: `${BrandingProductType}`; // converts enum's values into union type, ie 'portal' | 'elinx' | etc
  Language: string;
};

export type FetchTranslationsUrlResponse = ApiResponse & {
  Url: string;
};
export type MobileWalletProvidersRequest = {
  Country: string;
};

export type MobileWalletBrand =
  | 'M-PESA'
  | 'Equitel Money'
  | 'PayMaya'
  | 'Gcash'
  | 'DcPay'
  | 'eZ Cash'
  | 'bKash'
  | 'Alipay'
  | 'MTN'
  | 'UPI';

export type MobileWalletProvider = {
  Brand: MobileWalletBrand;
  Currency: SupportedCurrencies;
  Format: string;
  NetworkParticipant: string;
  Type: 'TelephoneNumber' | 'EWalletID';
};

export type MobileWalletProvidersApiResponse = ApiResponse & {
  MobileWalletProviders: { [key: string]: MobileWalletProvider };
};

export type MobileWalletProvidersResponse = ApiResponse & {
  MobileWalletProviders: MobileWalletProvider[];
};

export type EditAccountPermissionsRequest = Record<string, boolean | string | number> & {
  SubaccountID: string;
};

export type SubAccountPermissionsRequest = {
  SubaccountID: string;
};

/**
 * Individual sub-account permission item with dependencies (API format)
 */
export type SubAccountPermissionItemApi = {
  Permission: string;
  Type: 'boolean' | 'number' | 'string';
  Section: string;
  Label: string;
  Value: boolean | number | string | null;
  Dependencies: Record<string, string>; // API returns numeric-keyed object
  IsCurrency?: boolean;
};

/**
 * Individual sub-account permission item with dependencies (transformed)
 */
export type SubAccountPermissionItem = {
  Permission: string;
  Type: 'boolean' | 'number' | 'string';
  Section: string;
  Label: string;
  Value: boolean | number | string | null;
  Dependencies: string[]; // Transformed to array
  IsCurrency?: boolean;
};

/**
 * Permission section containing array of permission items (API returns numeric-keyed object)
 */
export type SubAccountPermissionSectionApi = {
  [key: string]: SubAccountPermissionItemApi;
};

/**
 * Consistent section structure with ID, name, and subitems
 */
export type SubAccountPermissionSection = {
  SectionId: string;
  SectionName: string;
  SubItems: SubAccountPermissionItem[] | SubAccountPermissionSection[];
};

/**
 * Generic type for any nested permission structure from API (with numeric keys)
 * This recursively handles any depth of nesting without hardcoding specific keys
 */
export type SubAccountNestedPermissionStructureApi = {
  [key: string]: SubAccountPermissionSectionApi | SubAccountNestedPermissionStructureApi;
};

/**
 * API response with numeric-keyed objects
 */
export type SubAccountPermissionApiResponse = ApiResponse & {
  PermissionValues: SubAccountNestedPermissionStructureApi;
};

/**
 * Transformed response with consistent section structure
 */
export type SubAccountPermissionResponse = ApiResponse & {
  PermissionValues: SubAccountPermissionSection[];
};

export type SaveExtendedInfoRequest = {
  Address: string;
  City: string;
  PostalCode: string;
  Province: string;
  Country: string;
  TaxID?: string;
};

export type AccountExtendedInfoResponse = ApiResponse & {
  AccountInformationResponse: {
    AcceptDonations: boolean;
    AcceptDonationsCash: boolean;
    AccountNumber: string;
    AverageDonationCash: string;
    AvgPaychequeAmount: string;
    BillingContactEmail: string;
    BillingContactFullName: string;
    BillingContactOccupation: string;
    BillingContactPhoneNumber: string;
    BillingContactTitle: string;
    BranchTransitNumber: string;
    BusinessTypeCategoryID: string;
    BusinessTypeID: string;
    CustomerSupportPhoneNumber: string;
    DateAdded: string;
    DateIncorporation: string;
    DonationCashProcess: string;
    DonationLimitCash: string;
    DonationLimitNonCash: string;
    DonationPercentageCash: string;
    FinancialInstitutionNumber: string;
    FullLegalName: string;
    ID: string;
    KYCTransactionID: string;
    KYCTransactionRecordID: string;
    KYCVerificationStatus: 'Pending' | 'Verified' | 'No Match' | 'Req Info Missing';
    LastModified: string;
    LegalBusinessName: string;
    LenderApr: string;
    LenderFundsSource: string;
    NatureOfBusiness: string;
    NotificationContactEmail: string;
    NumberOfEmployees: string;
    Occupation: string;
    OrganizationalType: string;
    PayrollFrequency: 'weekly' | 'bi-weekly' | 'monthly' | 'other';
    PrimaryContactEmail: string;
    PrimaryContactFullName: string;
    PrimaryContactOccupation: string;
    PrimaryContactPhoneNumber: string;
    PrimaryContactTitle: string;
    PrimaryEmail: string;
    PrimaryFax: string;
    PrimaryPhone: string;
    ProductDescription: string;
    RegistrationNumber: string;
    RegistrationProvince: string;
    SetupFee: string;
    SetupFeeACTCurrenciesID: string;
    StatementDescriptor: string;
    StatementDescriptorShortName: string;
    SupportContactEmail: string;
    SupportContactFullName: string;
    SupportContactOccupation: string;
    SupportContactPhoneNumber: string;
    SupportContactTitle: string;
    TaxID: string;
    TaxType: 'federal tax' | 'tax exempt' | 'zero rate';
    TechnicalContactEmail: string;
    TechnicalContactFullName: string;
    TechnicalContactOccupation: string;
    TechnicalContactPhoneNumber: string;
    TechnicalContactTitle: string;
    ThirdPartyUse: boolean;
    TotalPayrollPayPeriod: string;
    VIODigitalSignaturesID: string;
    VIOIq11TokensID: string;
    Website: string;
  };
  AddressResponse: {
    Address1: string;
    Address2: string;
    City: string;
    ADRProvinces_ID: string;
    ADRCountries_ID: string;
    PostalCode: string;
  };
};

export type PartnerExtendedInfoResponse = ApiResponse &
  AccountExtendedInfoResponse & {
    CertificateofIncorporationDocumentID: string;
  };

export type FetchDocumentRequest = {
  DocumentID: string;
  IsPartner?: boolean;
  Token?: string;
};

export type FetchDocumentResponse = ApiResponse & {
  Document: string;
  DocumentName: string;
};

export type ApprovalUser = {
  Username: string;
};

export type FetchApprovalUsersApiResponse = ApiResponse & {
  Users: {
    [key: string]: ApprovalUser;
  };
};

export type FetchApprovalUsersResponse = ApiResponse & {
  Users: ApprovalUser[];
};

export type AccountTransferRequest = {
  TransactionID: string;
};

export type AccountTransferResponse = ApiResponse & {
  TransactionID: string;
  TransactionStatus: TransactionStatus;
  TransactionDateTime: string;
  Amount: string;
  Sender: string;
  Receiver: string;
  ClientReferenceNumber: string;
  Notes: string;
  ParentTransaction: {
    FailureReason: string;
    Timestamp: string;
    TransactionID: string;
    TransactionStatus: TransactionStatus;
    TransactionType: TransactionTypesOptions;
  };
};

export type TransactionHistoryRequest = TimezoneRequest & {
  TransactionID: string;
};

export type TransactionHistoryItem = {
  Status: TransactionStatus;
  DateAdded: string;
};

export type TransactionHistoryApiResponse = ApiResponse & {
  TransactionHistory: { [key: string]: TransactionHistoryItem };
};

export type TransactionHistoryResponse = ApiResponse & {
  TransactionHistory: TransactionHistoryItem[];
};

export type AddCportalUserRequest = {
  PhoneNumber: string;
  Email: string;
  ClientAccountID: string;
  SendWelcomeEmail?: boolean;
};

export type AddCportalUserResponse = ApiResponse & {
  UserID: string;
};

export type FetchCportalUserAccountRequest = {
  ClientAccountID: string;
};

export type FetchCportalUserAccountResponse = ApiResponse & {
  User: {
    IsActive: boolean;
  };
};

export type AccountCportalSettingsRequest = {
  PhoneNumber: string;
  Email: string;
  ClientAccountID: string;
};

export type CportalService = 'Fund' | 'Withdraw' | 'Transfer' | 'Global Send';

export type CportalServiceApiItem = {
  Service: CportalService;
  Enabled: PseudoBool;
};

export type CportalServiceItem = Omit<CportalServiceApiItem, 'Enabled'> & {
  Enabled: boolean;
};

export type CportalPaymentRailSettings = {
  Fund?: {
    'EFT Funding'?: {
      MaxAmount: string;
    };
    'Interac Money Request'?: {
      MaxAmount: string;
      GenerateURLEnabled: string;
    };
  };
  Transfer?: {
    'Account Transfer'?: {
      MaxAmount: string;
    };
  };
  Withdraw?: {
    'EFT Withdrawal'?: {
      MaxAmount: string;
    };
    'Interac Bulk Payout'?: {
      MaxAmount: string;
    };
    'VoPayInstant Withdraw'?: {
      MaxAmount: string;
    };
  };
  'Global Send'?: {
    'Crossborder Withdrawal'?: {
      MaxAmount: string;
    };
  };
};

export type AccountCportalSettingsResponse = ApiResponse & {
  Services: CportalServiceItem[];
  PaymentRailSettings: CportalPaymentRailSettings;
  cPortalLink: string;
};

export type AccountCportalSettingsApiResponse = ApiResponse & {
  Services: { [key: string]: CportalServiceApiItem };
  PaymentRailSettings: CportalPaymentRailSettings;
  cPortalLink: string;
};

export type SendCportalEmailRequest = {
  ClientAccountID: string;
  EmailType: 'WelcomeEmail';
};

export type ReconciliationTransactionsRequest = TimezoneRequest & {
  Token: string;
  StartDate?: string;
  EndDate?: string;
  IsReconciled?: boolean;
  Limit?: number;
  Offset?: number;
  AccountName?: string;
};

export type ReconciliationTransactionApi = {
  BankAccount: string;
  VirtualAccount: string;
  AccountName: string;
  IsReconciled: PseudoBool;
  TransactionID: string;
  Amount: string;
  Currency: string;
  TransactionType: 'DEBIT' | 'CREDIT';
  TransactionService: TransactionType;
  TransactionDate: string;
  PostedDate: string;
  TransactionDescription: string;
  CounterpartyName: string;
  CounterpartyAccount: string;
};

export type ReconciliationTransaction = Omit<ReconciliationTransactionApi, 'IsReconciled'> & {
  IsReconciled: boolean;
};

export type ReconciliationTransactionsApiResponse = ApiResponse & {
  NumberOfRecords: number;
  Transactions: { [key: string]: ReconciliationTransactionApi };
  PaginationMetaData: PaginationMetaData;
};

export type ReconciliationTransactionsResponse = ApiResponse & {
  NumberOfRecords: number;
  Transactions: ReconciliationTransaction[];
  PaginationMetaData: PaginationMetaData;
};

export type DeactivateSubaccountRequest = {
  SubaccountID: string;
};
export type PortalPartnerAccountsRequest = {
  Limit?: number;
  Offset?: number;
  SearchText?: string;
};

export type PortalPartnerAccount = {
  APIAccountID: string;
  AccountName: string;
};

export type PortalPartnerAccountsResponseRaw = ApiResponse & {
  Accounts?: Record<string, PortalPartnerAccount>;
  PaginationMetaData: PaginationMetaData;
};

export type PortalPartnerAccountsResponse = ApiResponse & {
  Accounts: PortalPartnerAccount[];
  PaginationMetaData: PaginationMetaData;
};
